export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Base64 scalar type */
  Base64: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** The `UUID` scalar type represents UUID values as specified by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export enum ArDetection {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
  VerticalAndHorizontal = 'VERTICAL_AND_HORIZONTAL'
}

export type ArObject = {
  __typename?: 'ARObject';
  /** @deprecated Not required */
  allows_pan?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not required */
  allows_rotation?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not required */
  detection?: Maybe<ArDetection>;
  id: Scalars['UUID']['output'];
  platform: ArPlatform;
  /** @deprecated Not required */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not required */
  type?: Maybe<ArObjectType>;
  url: Scalars['String']['output'];
};


export type ArObjectThumbnailArgs = {
  size?: InputMaybe<Size>;
};

export enum ArObjectType {
  Default = 'DEFAULT'
}

export enum ArPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type AbstractActor = {
  country_of_origin?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
};

export type AbstractAttribute = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type AbstractAttributeMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type AbstractBlock = {
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AbuseReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  reason: AbuseReportReason;
  type: AbuseReportType;
};

export enum AbuseReportReason {
  PoorPhotoQuality = 'POOR_PHOTO_QUALITY',
  Spam = 'SPAM',
  ViolatingContent = 'VIOLATING_CONTENT',
  WrongCategory = 'WRONG_CATEGORY'
}

export enum AbuseReportType {
  Product = 'PRODUCT',
  User = 'USER'
}

export type AddProductToCart = {
  product_id: Scalars['UUID']['input'];
};

export type AddProductsToCart = {
  productIds: Array<Scalars['UUID']['input']>;
};

export type AddReferralCodeInput = {
  referral_code: Scalars['String']['input'];
};

export type AddReferralCodeResult = {
  __typename?: 'AddReferralCodeResult';
  success: Scalars['Boolean']['output'];
};

export type AddToBoostCartInput = {
  clearBeforeAdding?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['UUID']['input'];
};

export type AddToCartInput = {
  object_id: Scalars['UUID']['input'];
  service_type?: InputMaybe<ServiceType>;
  type: CartItemType;
};

export type AdditionalInfo = AbstractAttribute & {
  __typename?: 'AdditionalInfo';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type AdditionalInfoMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type Address = {
  __typename?: 'Address';
  can_be_deleted?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  postal_code: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  merchant_id: Scalars['UUID']['input'];
  postal_code: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AgeGroup = {
  __typename?: 'AgeGroup';
  count: Scalars['Int']['output'];
  group: Scalars['String']['output'];
};

/** The input for the AnalyzeProductImage mutation. */
export type AnalyzeProductImageInput = {
  /** The base64 encoded images to analyze. */
  image: Scalars['Base64']['input'];
};

/** The result of the AnalyzeProductImage mutation. */
export type AnalyzeProductImageResult = {
  __typename?: 'AnalyzeProductImageResult';
  /** The id of the image */
  imageId: Scalars['String']['output'];
};

/** The input for the AnalyzeProductTitleAndImages mutation. */
export type AnalyzeProductTitleAndImagesInput = {
  /** The description of the product. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The base64 encoded images to analyze. */
  images: Array<Scalars['Base64']['input']>;
  /** The language of the output. */
  lang?: InputMaybe<Language>;
  /** The title of the product. */
  title: Scalars['String']['input'];
};

/** The result of the AnalyzeProductTitleAndImages mutation. */
export type AnalyzeProductTitleAndImagesResult = {
  __typename?: 'AnalyzeProductTitleAndImagesResult';
  /** The brand of the product */
  brand?: Maybe<Brand>;
  /** The brand suggestion of the product */
  brandSuggestion?: Maybe<Scalars['String']['output']>;
  /** The category of the product */
  category?: Maybe<Category>;
  /** The colors of the product */
  colors: Array<Color>;
  /** The description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** The feedback of the product */
  feedback?: Maybe<Scalars['String']['output']>;
  /** The materials of the product */
  materials: Array<Material>;
  /** The quality of the product */
  quality?: Maybe<ProductQuality>;
  /** The styles of the product */
  styles: Array<Style>;
  /** The usage signs of the product */
  usageSigns: Array<UsageSign>;
  /** The description of the usage signs */
  usageSignsDescription?: Maybe<Scalars['String']['output']>;
};

export type AppScreen = {
  __typename?: 'AppScreen';
  name: ScreenName;
  params?: Maybe<AppScreenParams>;
};

export type AppScreenParams = ChatScreenParams | ProductScreenParams | SearchScreenParams;

export enum ArtOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Square = 'SQUARE'
}

export enum ArtSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Mini = 'MINI',
  Small = 'SMALL',
  XLarge = 'X_LARGE'
}

export type Artist = AbstractActor & AbstractAttribute & {
  __typename?: 'Artist';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ArtistMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type Attribute = AdditionalInfo | Artist | Brand | Color | Designer | Label | Material | Style | Subject | UsageSign;

export type AttributeBlock = AbstractBlock & {
  __typename?: 'AttributeBlock';
  attributes: Array<Attribute>;
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AttributeFilter = {
  key?: InputMaybe<AttributeFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AttributeFilterKey {
  Slug = 'SLUG',
  Type = 'TYPE'
}

export type AttributeResult = {
  __typename?: 'AttributeResult';
  items: Array<Attribute>;
  pagination: PaginationResult;
};

export enum AttributeSort {
  Title = 'TITLE'
}

export enum AttributeType {
  AdditionalInfo = 'ADDITIONAL_INFO',
  Artist = 'ARTIST',
  Brand = 'BRAND',
  Color = 'COLOR',
  Designer = 'DESIGNER',
  Label = 'LABEL',
  Material = 'MATERIAL',
  Style = 'STYLE',
  Subject = 'SUBJECT',
  UsageSign = 'USAGE_SIGN'
}

export type Auction = {
  __typename?: 'Auction';
  allow_bid: Scalars['Boolean']['output'];
  allow_buy_now: Scalars['Boolean']['output'];
  bid_count: Scalars['Int']['output'];
  bids: Array<Bid>;
  buy_now_price?: Maybe<Price>;
  coming_soon_time?: Maybe<Scalars['DateTime']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  expiring?: Maybe<Scalars['Boolean']['output']>;
  expiry_date?: Maybe<Scalars['DateTime']['output']>;
  highest_bid?: Maybe<Bid>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  minimum_bid?: Maybe<Price>;
  product: Product;
  sold_at?: Maybe<Price>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  state: AuctionState;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type AuctionInput = {
  allow_bid: Scalars['Boolean']['input'];
  allow_buy_now: Scalars['Boolean']['input'];
  buy_now_price?: InputMaybe<PriceInput>;
  currency: Currency;
  minimum_bid?: InputMaybe<PriceInput>;
  product_id: Scalars['UUID']['input'];
};

export enum AuctionState {
  Banned = 'BANNED',
  BidOnly = 'BID_ONLY',
  Canceled = 'CANCELED',
  ComingSoon = 'COMING_SOON',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED',
  Reserved = 'RESERVED'
}

export type Audio = {
  __typename?: 'Audio';
  id: Scalars['UUID']['output'];
  thumbnail: Scalars['String']['output'];
  type: AudioType;
  url: Scalars['String']['output'];
};


export type AudioThumbnailArgs = {
  size?: InputMaybe<Size>;
};

export type AudioBlock = AbstractBlock & {
  __typename?: 'AudioBlock';
  audios: Array<Audio>;
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum AudioType {
  Description = 'DESCRIPTION'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  account_holder_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  routing_number?: Maybe<Scalars['String']['output']>;
};

export type BankAccountInput = {
  account_holder_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  routing_number?: InputMaybe<Scalars['String']['input']>;
};

export type Bid = {
  __typename?: 'Bid';
  amount: Price;
  auction: Auction;
  buyer: Merchant;
  buyerId: Scalars['UUID']['output'];
  canceledFromState?: Maybe<BidCanceledFromState>;
  created: Scalars['DateTime']['output'];
  end_date?: Maybe<Scalars['DateTime']['output']>;
  expiry_date: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  is_counter: Scalars['Boolean']['output'];
  merchant: Merchant;
  merchantId: Scalars['UUID']['output'];
  message?: Maybe<Message>;
  order?: Maybe<Order>;
  state: BidState;
  thread?: Maybe<Thread>;
};

export enum BidCanceledFromState {
  Accepted = 'ACCEPTED',
  New = 'NEW'
}

export enum BidCancellationReason {
  BidsTested = 'BIDS_TESTED',
  DeliveryTakesTooLong = 'DELIVERY_TAKES_TOO_LONG',
  FoundAnotherItem = 'FOUND_ANOTHER_ITEM',
  NoFundingAvailable = 'NO_FUNDING_AVAILABLE',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  TransportCostsUnclear = 'TRANSPORT_COSTS_UNCLEAR'
}

export type BidFilter = {
  key: BidFilterKey;
  value: Scalars['String']['input'];
};

export enum BidFilterKey {
  Auction = 'AUCTION',
  Merchant = 'MERCHANT',
  Product = 'PRODUCT'
}

export type BidInput = {
  amount: PriceInput;
  auction_id: Scalars['UUID']['input'];
  create_thread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BidResult = {
  __typename?: 'BidResult';
  items: Array<Bid>;
  pagination: PaginationResult;
};

export enum BidSort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  Name = 'NAME',
  Updated = 'UPDATED'
}

export enum BidState {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export type Block = AttributeBlock | AudioBlock | CallToActionBlock | CategoriesBlock | CategoryBlock | CollectionBlock | ImageBlock | MemberBlock | MerchantBlock | ProductBlock | QueryBlock | SearchProductsBlock | TextBlock | VideoBlock;

export type BlockFilter = {
  key?: InputMaybe<AttributeFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum BlockFilterKey {
  Location = 'LOCATION',
  Slug = 'SLUG'
}

export enum BlockLocation {
  AsideLeft = 'ASIDE_LEFT',
  AsideRight = 'ASIDE_RIGHT',
  Body = 'BODY',
  Footer = 'FOOTER',
  Header = 'HEADER'
}

export type BlockResult = {
  __typename?: 'BlockResult';
  items: Array<Block>;
  pagination: PaginationResult;
};

export enum BlockSort {
  Location = 'LOCATION',
  Title = 'TITLE'
}

export type BoostCart = {
  __typename?: 'BoostCart';
  products: Array<Product>;
  total: Price;
};

export type BoostPayment = {
  __typename?: 'BoostPayment';
  paymentClientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type Brand = AbstractActor & AbstractAttribute & {
  __typename?: 'Brand';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  listingPage?: Maybe<ListingPage>;
  media: Array<Media>;
  popular: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  superPopular: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type BrandDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type BrandMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type BrandsFilter = {
  isDesignerBrand?: InputMaybe<Scalars['Boolean']['input']>;
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  superPopular?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrengerAppointment = {
  __typename?: 'BrengerAppointment';
  awaitingResponseFrom?: Maybe<Merchant>;
  awaitingResponseFromId?: Maybe<Scalars['UUID']['output']>;
  brengerShipment?: Maybe<BrengerShipment>;
  buyer: Merchant;
  buyerId: Scalars['UUID']['output'];
  finalisedDate?: Maybe<Scalars['Date']['output']>;
  hasProposedDates: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  merchant: Merchant;
  merchantId: Scalars['UUID']['output'];
  order: Order;
  orderId: Scalars['UUID']['output'];
  type: BrengerAppointmentType;
};

export type BrengerAppointmentOptions = {
  __typename?: 'BrengerAppointmentOptions';
  awaitingResponseFrom?: Maybe<Merchant>;
  awaitingResponseFromId?: Maybe<Scalars['UUID']['output']>;
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  finalised: Scalars['Boolean']['output'];
  unavailableDates?: Maybe<Array<UnavailableDate>>;
};

export enum BrengerAppointmentType {
  Delivery = 'DELIVERY',
  Return = 'RETURN'
}

export type BrengerDatesProposalInput = {
  dates: Array<Scalars['Date']['input']>;
  orderId: Scalars['UUID']['input'];
};

export type BrengerProposedDate = {
  __typename?: 'BrengerProposedDate';
  brengerAppointmentId: Scalars['UUID']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  merchant: Merchant;
  merchantId: Scalars['UUID']['output'];
  state: BrengerProposedDateState;
};

export enum BrengerProposedDateState {
  Accepted = 'ACCEPTED',
  New = 'NEW',
  Rejected = 'REJECTED'
}

export type BrengerProposedDates = {
  __typename?: 'BrengerProposedDates';
  proposedDates: Array<BrengerProposedDate>;
};

export type BrengerShipment = {
  __typename?: 'BrengerShipment';
  id: Scalars['UUID']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type BuyerCountVsOrderCount = {
  __typename?: 'BuyerCountVsOrderCount';
  buyer_count: Scalars['Int']['output'];
  order_count: Scalars['Int']['output'];
};

export enum CalculationMethod {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type CallToActionBlock = {
  __typename?: 'CallToActionBlock';
  buttonText: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type CallToActionBlockButtonTextArgs = {
  lang?: InputMaybe<Language>;
};


export type CallToActionBlockTextArgs = {
  lang?: InputMaybe<Language>;
};

export type CancelBidInput = {
  customReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<BidCancellationReason>;
};

export type Cart = {
  __typename?: 'Cart';
  /** @deprecated Use billing_address and shipping_address */
  address?: Maybe<Address>;
  available_coupon_codes: Array<CouponCode>;
  billing_address?: Maybe<Address>;
  /** @deprecated Use buyer_protection in cart item */
  buyer_protection?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use available_services.eligible in cart item */
  buyer_protection_available?: Maybe<Scalars['Boolean']['output']>;
  coupon_code?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /** @deprecated Use delivery_method in cart item */
  delivery_method: DeliveryMethod;
  id: Scalars['UUID']['output'];
  items: Array<CartItem>;
  /** @deprecated Use payment in orderGroup */
  payment?: Maybe<CartPayment>;
  payment_method: PaymentMethod;
  shipping_address?: Maybe<Address>;
  /** @deprecated Use totals2 */
  totals?: Maybe<OrderTotals>;
  totals2?: Maybe<CartTotals>;
  updated: Scalars['DateTime']['output'];
};

export type CartItem = {
  __typename?: 'CartItem';
  available_services: Array<CartItemService>;
  bid?: Maybe<Bid>;
  /** @deprecated Use shippingOptions instead */
  delivery_method?: Maybe<DeliveryMethod>;
  /** @deprecated Use shippingOptions instead */
  externalShippingCost?: Maybe<Price>;
  /** @deprecated Use shippingOptions instead */
  external_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use shippingOptions instead */
  external_delivery_available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  product: Product;
  /** @deprecated Not needed anymore */
  service_type?: Maybe<ServiceType>;
  shipping?: Maybe<Price>;
  /** @deprecated Use shippingOptions instead */
  shippingCost?: Maybe<Price>;
  shippingOptions: Array<ShippingOption>;
  subtotal: Price;
  total: Price;
};


export type CartItemShippingOptionsArgs = {
  lang?: InputMaybe<Language>;
};

export type CartItemService = {
  __typename?: 'CartItemService';
  active: Scalars['Boolean']['output'];
  eligible: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  ineligibleError?: Maybe<Scalars['String']['output']>;
  ineligibleReason?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
  service: Service;
};


export type CartItemServiceIneligibleErrorArgs = {
  lang?: InputMaybe<Language>;
};


export type CartItemServiceIneligibleReasonArgs = {
  lang?: InputMaybe<Language>;
};

export enum CartItemType {
  Bid = 'BID',
  Product = 'PRODUCT'
}

export type CartPayment = {
  __typename?: 'CartPayment';
  payment_client_secret: Scalars['String']['output'];
  payment_intent_id: Scalars['String']['output'];
};

export type CartTotals = {
  __typename?: 'CartTotals';
  discount?: Maybe<Price>;
  serviceCost?: Maybe<Price>;
  services: Array<CartTotalsServices>;
  shipping?: Maybe<Price>;
  subtotal?: Maybe<Price>;
  total?: Maybe<Price>;
};

export type CartTotalsServices = {
  __typename?: 'CartTotalsServices';
  price: Price;
  service: Service;
};

export type CategoriesBlock = {
  __typename?: 'CategoriesBlock';
  categories: Array<Category>;
  id: Scalars['UUID']['output'];
};

export type Category = MediaQueries & {
  __typename?: 'Category';
  children?: Maybe<Array<Maybe<Category>>>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  images: Array<Image>;
  /** @deprecated Use Category.children. */
  items: Array<Category>;
  level?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  listingPage: ListingPage;
  media: Array<Media>;
  parent?: Maybe<Category>;
  route?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  svgIcon?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  video?: Maybe<Video>;
  videos: Array<Video>;
};


export type CategoryChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  popular?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryImageArgs = {
  type?: InputMaybe<ImageType>;
};


export type CategoryImagesArgs = {
  type?: InputMaybe<ImageType>;
};


export type CategoryItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type CategoryRouteArgs = {
  lang?: InputMaybe<Language>;
};


export type CategorySlugArgs = {
  lang?: InputMaybe<Language>;
};


export type CategoryTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type CategoryVideoArgs = {
  type?: InputMaybe<VideoType>;
};


export type CategoryVideosArgs = {
  type?: InputMaybe<VideoType>;
};

export type CategoryBlock = AbstractBlock & {
  __typename?: 'CategoryBlock';
  categories: Array<Category>;
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CategoryFilter = {
  key: CategoryFilterKey;
  value: Scalars['String']['input'];
};

export enum CategoryFilterKey {
  Level = 'LEVEL',
  Parent = 'PARENT',
  Slug = 'SLUG'
}

export type CategoryResult = {
  __typename?: 'CategoryResult';
  items: Array<Category>;
  pagination: PaginationResult;
};

export type CategorySales = {
  __typename?: 'CategorySales';
  sales_volume: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export enum CategorySort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  Level = 'LEVEL',
  Lft = 'LFT',
  Name = 'NAME',
  TreeId = 'TREE_ID',
  Updated = 'UPDATED'
}

export type ChatScreenParams = {
  __typename?: 'ChatScreenParams';
  threadId: Scalars['String']['output'];
};

export type CheckEmailExistsResponse = {
  __typename?: 'CheckEmailExistsResponse';
  status?: Maybe<CheckEmailExistsStatus>;
};

export enum CheckEmailExistsStatus {
  Available = 'AVAILABLE',
  Banned = 'BANNED',
  Unavailable = 'UNAVAILABLE'
}

export type Collection = {
  __typename?: 'Collection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  listingPage?: Maybe<ListingPage>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CollectionDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type CollectionTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type CollectionBlock = {
  __typename?: 'CollectionBlock';
  collection: Collection;
  id: Scalars['UUID']['output'];
  products: Array<Product>;
  showCollectionImage: Scalars['Boolean']['output'];
};


export type CollectionBlockProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Color = AbstractAttribute & {
  __typename?: 'Color';
  description?: Maybe<Scalars['String']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ColorMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type ColorSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type ColorTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type ComingSoonAlert = {
  __typename?: 'ComingSoonAlert';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  product: Product;
};

export type ComingSoonAlertInput = {
  product_id: Scalars['UUID']['input'];
};

export type ComingSoonAlertResult = {
  __typename?: 'ComingSoonAlertResult';
  items: Array<ComingSoonAlert>;
  pagination: PaginationResult;
};

export enum ContentType {
  Merchant = 'MERCHANT',
  Message = 'MESSAGE',
  Product = 'PRODUCT'
}

export type CounterBidInput = {
  amount: PriceInput;
  auction_id: Scalars['UUID']['input'];
  buyer_id: Scalars['UUID']['input'];
};

export enum Country {
  At = 'AT',
  Be = 'BE',
  Ch = 'CH',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  Hu = 'HU',
  It = 'IT',
  Lu = 'LU',
  Mc = 'MC',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Se = 'SE',
  Si = 'SI',
  Sk = 'SK'
}

export type CouponCode = {
  __typename?: 'CouponCode';
  code: Scalars['String']['output'];
  discount: CouponCodeDiscount;
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponCodeDiscount = {
  __typename?: 'CouponCodeDiscount';
  type: DiscountType;
  value: Scalars['Float']['output'];
};

export type CreateMessageInput = {
  body: Scalars['String']['input'];
  threadId: Scalars['UUID']['input'];
};

export type CreateOrderGroupForCartInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentForBoostInput = {
  /** @deprecated Use paymentMethodId instead */
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThreadInput = {
  merchantId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
};

export type CurationFeedback = {
  __typename?: 'CurationFeedback';
  message: Scalars['String']['output'];
  severity: CurationFeedbackSeverity;
};

export enum CurationFeedbackSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type CurationReason = {
  __typename?: 'CurationReason';
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum Currency {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CursorPaginationInput = {
  from?: InputMaybe<Scalars['UUID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CursorPaginationResult = {
  __typename?: 'CursorPaginationResult';
  hasMore: Scalars['Boolean']['output'];
};

export enum DeliveryMethod {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  PickupDelivery = 'PICKUP_DELIVERY'
}

export type Designer = AbstractActor & {
  __typename?: 'Designer';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  listingPage?: Maybe<ListingPage>;
  media: Array<Media>;
  popular: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  superPopular: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type DesignerDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type DesignerMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type DesignersFilter = {
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  superPopular?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']['output']>;
  type: CalculationMethod;
};

export enum DiscountType {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export enum DisputeReason {
  NotAsAdvertised = 'NOT_AS_ADVERTISED',
  Other = 'OTHER',
  TransportDamage = 'TRANSPORT_DAMAGE'
}

export type Document = {
  __typename?: 'Document';
  id: Scalars['UUID']['output'];
  thumbnail: Scalars['String']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
};


export type DocumentThumbnailArgs = {
  size?: InputMaybe<Size>;
};

export enum DocumentType {
  Default = 'DEFAULT',
  PassportBack = 'PASSPORT_BACK',
  PassportFront = 'PASSPORT_FRONT'
}

export type EmailTokenLoginResponse = {
  __typename?: 'EmailTokenLoginResponse';
  redirectUrl: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: Member;
};

export type Empty = {
  __typename?: 'Empty';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export enum Entity {
  Category = 'CATEGORY',
  FavoriteCollection = 'FAVORITE_COLLECTION',
  Merchant = 'MERCHANT',
  Product = 'PRODUCT'
}

export enum Event {
  Bid = 'BID',
  Buy = 'BUY',
  Like = 'LIKE',
  Message = 'MESSAGE',
  Question = 'QUESTION',
  Share = 'SHARE',
  View = 'VIEW'
}

export type ExternalBankAccount = {
  __typename?: 'ExternalBankAccount';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_name: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Currency;
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type ExternalBankAccountInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalShippingMethod = {
  __typename?: 'ExternalShippingMethod';
  id: Scalars['String']['output'];
  price: Price;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Favorite = {
  __typename?: 'Favorite';
  collection?: Maybe<FavoriteCollection>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  item: FavoriteItem;
};

export type FavoriteCollection = {
  __typename?: 'FavoriteCollection';
  id: Scalars['UUID']['output'];
  items: Array<Maybe<Favorite>>;
  title: Scalars['String']['output'];
};

export type FavoriteCollectionInput = {
  title: Scalars['String']['input'];
};

export type FavoriteInput = {
  collection?: InputMaybe<Scalars['UUID']['input']>;
  content_type: ContentType;
  object_id: Scalars['UUID']['input'];
};

export type FavoriteItem = Merchant | Product;

export type FavoriteResult = {
  __typename?: 'FavoriteResult';
  items: Array<Favorite>;
  pagination: PaginationResult;
};

export enum FavoriteSort {
  Created = 'CREATED'
}

export type Fee = {
  __typename?: 'Fee';
  amount: Scalars['Float']['output'];
  type: CalculationMethod;
};

/**
 * FilterInput is a key / value pair to build filters.
 *
 * A SearchKey can only be defined once, but can have
 * multiple values by joining the string with a ,
 *
 * To filter on multiple values join the string with a comma
 * {
 *   "key": "COLOR",
 *   "value": "red,white"
 * }
 *
 * To filter on ranges join the range with a comma (values
 * may be omitted)
 * {
 *   "key": "PRICE",
 *   "value": "0,100"
 * }
 */
export type FilterInput = {
  key?: InputMaybe<SearchFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterObject = Brand | Category | Color | Label | Material | ProductBlock | Style;

export type FilterOutput = {
  __typename?: 'FilterOutput';
  key?: Maybe<SearchFilterKey>;
  /** @deprecated Use models instead as it provides multiple models. */
  model?: Maybe<FilterOutputModel>;
  models?: Maybe<Array<FilterOutputModel>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FilterOutputModel = Brand | Category | Color | Designer | Empty | Material | Style;

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message: Scalars['String']['output'];
  status: ForgotPasswordResult;
};

export enum ForgotPasswordResult {
  EmailNotFound = 'EMAIL_NOT_FOUND',
  EmailSent = 'EMAIL_SENT'
}

export type GenerateIterableJwtInput = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GenerateIterableJwtResponse = {
  __typename?: 'GenerateIterableJwtResponse';
  token: Scalars['String']['output'];
};

export type GetMessagesInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  threadId: Scalars['UUID']['input'];
};

export type GetMessagesResult = {
  __typename?: 'GetMessagesResult';
  items: Array<Message>;
  pagination: CursorPaginationResult;
};

export type GetThreadsInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type GetThreadsResult = {
  __typename?: 'GetThreadsResult';
  items: Array<Thread>;
  pagination: CursorPaginationResult;
};

export type GuestCart = {
  __typename?: 'GuestCart';
  products: Array<Product>;
};

export type GuestCartInput = {
  productIds: Array<Scalars['UUID']['input']>;
};

export type Homepage = {
  __typename?: 'Homepage';
  blocks: Array<Block>;
  id: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  orientation?: Maybe<ImageOrientation>;
  position: Scalars['Int']['output'];
  /** @deprecated Because is isn't being used or needed anywhere */
  rotation: Scalars['Int']['output'];
  type: ImageType;
  url: Scalars['String']['output'];
  variants: Array<ImageVariant>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type ImageUrlArgs = {
  lang?: InputMaybe<Language>;
  size?: InputMaybe<Size>;
  type?: InputMaybe<ImageType>;
};

export type ImageBlock = AbstractBlock & {
  __typename?: 'ImageBlock';
  id: Scalars['UUID']['output'];
  images: Array<Image>;
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum ImageOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Square = 'SQUARE'
}

export enum ImageType {
  Avatar = 'AVATAR',
  Cover = 'COVER',
  Default = 'DEFAULT',
  Detail = 'DETAIL',
  Thumbnail = 'THUMBNAIL'
}

export type ImageVariant = {
  __typename?: 'ImageVariant';
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};


export type ImageVariantUrlArgs = {
  lang?: InputMaybe<Language>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
};

export type InviteUserResult = {
  __typename?: 'InviteUserResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Label = AbstractAttribute & {
  __typename?: 'Label';
  /** @deprecated Field no longer supported */
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type LabelMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export enum Lang {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  Nl = 'NL'
}

export enum Language {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Nl = 'NL'
}

export type ListingCategoryPage = {
  __typename?: 'ListingCategoryPage';
  activeProductCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  listingLevel: ListingLevel;
  productCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type ListingCategoryPageTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type ListingCategoryPageUrlArgs = {
  lang?: InputMaybe<Language>;
};

export enum ListingLevel {
  /** Listing is under the current listing */
  Child = 'CHILD',
  /** This is current listing */
  Current = 'CURRENT',
  /** Listing is on the level above current and has back option */
  Parent = 'PARENT',
  /** Listing is on the same level as current listing but does not have back option */
  Sibling = 'SIBLING'
}

export type ListingPage = {
  __typename?: 'ListingPage';
  brand?: Maybe<Brand>;
  breadcrumbs: Array<ListingPage>;
  category?: Maybe<Category>;
  categoryPages: Array<ListingCategoryPage>;
  collection?: Maybe<ProductBlock>;
  description?: Maybe<Scalars['String']['output']>;
  filters: Array<ListingPageFilterItem>;
  image?: Maybe<Scalars['String']['output']>;
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Ordering>;
  recommended?: Maybe<Scalars['Boolean']['output']>;
  relatedListingPages: Array<RelatedListingPage>;
  sort?: Maybe<SearchSort>;
  subcategoryPages: Array<ListingPage>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};


export type ListingPageDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ListingPageFiltersArgs = {
  lang: Language;
};


export type ListingPageRelatedListingPagesArgs = {
  lang: Language;
  limit?: Scalars['Int']['input'];
};


export type ListingPageTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type ListingPageUrlArgs = {
  lang?: InputMaybe<Language>;
};


export type ListingPageWeightArgs = {
  lang?: InputMaybe<Language>;
};

export type ListingPageByFiltersInput = {
  filters: Array<ListingPageFilterInput>;
};

export type ListingPageFilterInput = {
  key: ListingPageFilterKey;
  value: Scalars['String']['input'];
};

export type ListingPageFilterItem = {
  __typename?: 'ListingPageFilterItem';
  key: ListingPageFilterKey;
  value: Scalars['String']['output'];
};

export enum ListingPageFilterKey {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Collection = 'COLLECTION',
  Color = 'COLOR',
  Condition = 'CONDITION',
  Designer = 'DESIGNER',
  InShowroom = 'IN_SHOWROOM',
  Material = 'MATERIAL',
  OnSale = 'ON_SALE',
  Style = 'STYLE'
}

export type ListingPageInput = {
  lang: Language;
  url: Scalars['String']['input'];
};

export enum ListingPageRelationType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Color = 'COLOR',
  Custom = 'CUSTOM',
  Material = 'MATERIAL',
  Style = 'STYLE'
}

/**
 * The Locale enum represents the possible locality settings for the
 * current merchant.
 */
export enum Locale {
  DeAt = 'DE_AT',
  DeDe = 'DE_DE',
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  FrBe = 'FR_BE',
  FrFr = 'FR_FR',
  NlBe = 'NL_BE',
  NlNl = 'NL_NL'
}

export type LocalizedUrl = {
  __typename?: 'LocalizedUrl';
  status: LocalizedUrlStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export enum LocalizedUrlStatus {
  Found = 'FOUND',
  NotFound = 'NOT_FOUND',
  Redirect = 'REDIRECT'
}

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export enum LoginProvider {
  Apple = 'APPLE',
  /** @deprecated Field no longer supported */
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type LoginResponse = {
  __typename?: 'LoginResponse';
  access_token: Scalars['String']['output'];
  user: Member;
};

export type Material = AbstractAttribute & {
  __typename?: 'Material';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type MaterialMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type MaterialSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type MaterialTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type MeInput = {
  business_name?: InputMaybe<Scalars['String']['input']>;
  country_of_birth?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  place_of_birth?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Please use referralId instead */
  referrer?: InputMaybe<Referrer>;
  type?: InputMaybe<MerchantType>;
};

export type Media = ArObject | Audio | Document | Image | Video;

export type MediaFilter = {
  key?: InputMaybe<MediaFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MediaFilterKey {
  MimeType = 'MIME_TYPE',
  State = 'STATE',
  Type = 'TYPE'
}

export type MediaQueries = {
  image?: Maybe<Image>;
  images: Array<Image>;
  media: Array<Media>;
  video?: Maybe<Video>;
  videos: Array<Video>;
};


export type MediaQueriesImageArgs = {
  type?: InputMaybe<ImageType>;
};


export type MediaQueriesImagesArgs = {
  type?: InputMaybe<ImageType>;
};


export type MediaQueriesMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type MediaQueriesVideoArgs = {
  type?: InputMaybe<VideoType>;
};


export type MediaQueriesVideosArgs = {
  type?: InputMaybe<VideoType>;
};

export type MediaResult = {
  __typename?: 'MediaResult';
  items: Array<Media>;
  pagination: PaginationResult;
};

export enum MediaSort {
  Created = 'CREATED',
  State = 'STATE'
}

export enum MediaState {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export enum MediaType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type MediaUpdateInput = {
  content_type?: InputMaybe<ContentType>;
  object_id?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Member = {
  __typename?: 'Member';
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  date_joined: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  given_name: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastUsedPaymentMethod?: Maybe<PaymentMethod>;
  last_login?: Maybe<Scalars['DateTime']['output']>;
  locale: Locale;
  merchants: Array<Merchant>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
};

export type MemberBlock = AbstractBlock & {
  __typename?: 'MemberBlock';
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  members: Array<Member>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MemberFilter = {
  key?: InputMaybe<MemberFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MemberFilterKey {
  Email = 'EMAIL'
}

export type MemberInput = {
  dob?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  family_name: Scalars['String']['input'];
  given_name: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MemberResult = {
  __typename?: 'MemberResult';
  items: Array<Member>;
  pagination: PaginationResult;
};

export enum MemberSort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  Email = 'EMAIL',
  Updated = 'UPDATED'
}

export type Merchant = MediaQueries & {
  __typename?: 'Merchant';
  addresses: Array<Address>;
  bank_account?: Maybe<BankAccount>;
  biography?: Maybe<Scalars['String']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  completed_payouts?: Maybe<Array<MerchantPayment>>;
  compliance_level?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  currency: Currency;
  discount?: Maybe<Discount>;
  email?: Maybe<Scalars['String']['output']>;
  expert_seller?: Maybe<Scalars['Boolean']['output']>;
  favoriteCollections: Array<FavoriteCollection>;
  favorites: Array<Favorite>;
  fee?: Maybe<Fee>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  images: Array<Image>;
  media: Array<Media>;
  members?: Maybe<Array<Maybe<Member>>>;
  name: Scalars['String']['output'];
  number_of_ads?: Maybe<Scalars['Int']['output']>;
  number_of_bids?: Maybe<Scalars['Int']['output']>;
  number_of_buys?: Maybe<Scalars['Int']['output']>;
  number_of_favorites?: Maybe<Scalars['Int']['output']>;
  number_of_sells?: Maybe<Scalars['Int']['output']>;
  pendingActions: Array<PendingAction>;
  pending_balance: Price;
  pending_payouts?: Maybe<Array<MerchantPayment>>;
  pending_requirements?: Maybe<Array<MerchantRequirement>>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  stripeAccount: StripeAccount;
  stripe_customer_error?: Maybe<Scalars['String']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  type: MerchantType;
  url?: Maybe<Scalars['String']['output']>;
  vacationModeDisableRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  vacationModeEnableRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  vacationModeEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  vacationModeEndDate?: Maybe<Scalars['DateTime']['output']>;
  vat_id?: Maybe<Scalars['String']['output']>;
  vat_id_registrar?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  video?: Maybe<Video>;
  videos: Array<Video>;
};


export type MerchantImageArgs = {
  type?: InputMaybe<ImageType>;
};


export type MerchantImagesArgs = {
  type?: InputMaybe<ImageType>;
};


export type MerchantMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type MerchantVideoArgs = {
  type?: InputMaybe<VideoType>;
};


export type MerchantVideosArgs = {
  type?: InputMaybe<VideoType>;
};

export type MerchantBlock = AbstractBlock & {
  __typename?: 'MerchantBlock';
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  merchants: Array<Merchant>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MerchantCountVsChatCount = {
  __typename?: 'MerchantCountVsChatCount';
  chat_count: Scalars['Int']['output'];
  merchant_count: Scalars['Int']['output'];
};

export type MerchantCountVsProductCount = {
  __typename?: 'MerchantCountVsProductCount';
  merchant_count: Scalars['Int']['output'];
  product_count: Scalars['Int']['output'];
};

export type MerchantFilter = {
  key?: InputMaybe<MerchantFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MerchantFilterKey {
  Email = 'EMAIL',
  Name = 'NAME',
  Slug = 'SLUG',
  Type = 'TYPE'
}

export type MerchantInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  type: MerchantType;
  url?: InputMaybe<Scalars['String']['input']>;
  vat_id?: InputMaybe<Scalars['String']['input']>;
  vat_id_registrar?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantPayment = Node & {
  __typename?: 'MerchantPayment';
  amount: Price;
  created: Scalars['DateTime']['output'];
  destination: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
};

export enum MerchantRequirement {
  Address = 'ADDRESS',
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  FamilyName = 'FAMILY_NAME',
  GivenName = 'GIVEN_NAME',
  IdentifyDocument = 'IDENTIFY_DOCUMENT',
  OwnerDocument = 'OWNER_DOCUMENT',
  TaxId = 'TAX_ID',
  VatId = 'VAT_ID'
}

export type MerchantResult = {
  __typename?: 'MerchantResult';
  items: Array<Merchant>;
  pagination: PaginationResult;
};

export enum MerchantRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum MerchantSort {
  Created = 'CREATED',
  Name = 'NAME',
  Updated = 'UPDATED'
}

export enum MerchantType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL'
}

export type Message = {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  flaggedReasons?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  item?: Maybe<MessageItem>;
  merchant: Merchant;
  metadata?: Maybe<Scalars['JSON']['output']>;
  sender: Member;
  subscriber?: Maybe<Subscriber>;
  thread: Thread;
  threadId: Scalars['UUID']['output'];
  unread: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type MessageBodyArgs = {
  lang?: InputMaybe<Language>;
};

export type MessageFilter = {
  key?: InputMaybe<MessageFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageFilterKey {
  Sender = 'SENDER',
  Thread = 'THREAD'
}

export enum MessageFlaggedReason {
  BidIntent = 'BID_INTENT',
  CommunicationOutsidePlatform = 'COMMUNICATION_OUTSIDE_PLATFORM',
  PersonalInformationShared = 'PERSONAL_INFORMATION_SHARED',
  ProductViewAppointment = 'PRODUCT_VIEW_APPOINTMENT',
  TransactionOutsidePlatform = 'TRANSACTION_OUTSIDE_PLATFORM'
}

export type MessageItem = Audio | Bid | Document | Image | Order | Product | Shipment | Video;

export type MessageResult = {
  __typename?: 'MessageResult';
  items: Array<Message>;
  pagination: PaginationResult;
};

export enum MessageSort {
  Created = 'CREATED',
  Sender = 'SENDER',
  Updated = 'UPDATED'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptBid: Bid;
  acceptBrengerProposedDate: BrengerProposedDate;
  acceptTos: Merchant;
  addProductToCart: Cart;
  addProductsToCart: Cart;
  addReferralCode: AddReferralCodeResult;
  addToBoostCart: BoostCart;
  /** @deprecated Use addProductToCart or addProductsToCart */
  addToCart: Cart;
  /**
   * Analyze image of a product, returns the image id
   * we can use to search for similar products.
   */
  analyzeProductImage?: Maybe<AnalyzeProductImageResult>;
  /**
   * Analyze the title and images of a product, returns the
   * analysis result.
   */
  analyzeProductTitleAndImages?: Maybe<AnalyzeProductTitleAndImagesResult>;
  askProductQuestion: Thread;
  cancelBid?: Maybe<Bid>;
  /** @deprecated Not used by the apps anymore. */
  cancelOrder: Order;
  cancelProduct: Product;
  checkEmailExists: CheckEmailExistsResponse;
  checkOrderPayment: Order;
  clearCart: Cart;
  createAbuseReport: Scalars['Boolean']['output'];
  createAddress: Address;
  createAuction: Auction;
  createBid: Bid;
  createComingSoonAlert: ComingSoonAlert;
  createCounterBid: Bid;
  createFavorite: Favorite;
  createFavoriteCollection: FavoriteCollection;
  createFeedback: Order;
  createMember: Member;
  createMerchant: Merchant;
  createMessage?: Maybe<Message>;
  createOrUpdateBankAccount: ExternalBankAccount;
  createOrder: Order;
  createOrderGroupForCart: OrderGroup;
  createPayment: Order;
  createPaymentForBoost: BoostPayment;
  /** @deprecated Use createOrderGroupForCart */
  createPaymentForCart: Cart;
  createProduct: Product;
  createReview: Review;
  createSavedSearch: SavedSearch;
  createShipment: Shipment;
  createStripeAccountLink: StripeAccountLink;
  createThread: Thread;
  createWuunderShipment?: Maybe<WuunderShipment>;
  deactivateAllServices: Cart;
  deleteThread: Scalars['Boolean']['output'];
  disableThreadTranslation: Thread;
  forgotPassword: ForgotPasswordResponse;
  generateIterableJwt: GenerateIterableJwtResponse;
  inviteUser: InviteUserResult;
  login: LoginResponse;
  /** @deprecated Use loginWithProvider instead */
  loginWithApple: Scalars['String']['output'];
  /** @deprecated Use login */
  loginWithEmailPassword: Scalars['String']['output'];
  loginWithEmailToken: EmailTokenLoginResponse;
  /** @deprecated Use loginWithProvider instead */
  loginWithGoogle: Scalars['String']['output'];
  loginWithProvider: LoginResponse;
  payProductService: Order;
  payShowroomService: Order;
  proposeBrengerAppointmentDates: BrengerProposedDates;
  publishProduct: Product;
  reactivateProduct: Product;
  readThread: Scalars['Boolean']['output'];
  registerFCMToken: Scalars['Boolean']['output'];
  rejectBid: Bid;
  removeAddress: Scalars['Boolean']['output'];
  removeBid: Scalars['Boolean']['output'];
  removeCartItem: CartItem;
  removeComingSoonAlert: Scalars['Boolean']['output'];
  removeFavorite: Scalars['Boolean']['output'];
  removeFavoriteCollection: Scalars['Boolean']['output'];
  removeMedia: Scalars['Boolean']['output'];
  /** @deprecated Not needed */
  removeMember: Scalars['Boolean']['output'];
  removeMerchant: Scalars['Boolean']['output'];
  removeProduct: Scalars['Boolean']['output'];
  removeSavedSearch: Scalars['Boolean']['output'];
  requestAccountDeletion: RequestAccountDeletionResponse;
  requestEmailToken: Scalars['String']['output'];
  requestPhoneUpdateOTP: RequestPhoneUpdateOtpResponse;
  requestVacationModeDisable: Merchant;
  requestVacationModeEnable: Merchant;
  /** @deprecated Please use the createMessage mutation. */
  sendMessage: Message;
  sendOtp: SendOtpResponse;
  sendPlatformFeedback?: Maybe<Scalars['Boolean']['output']>;
  signup: SignupResponse;
  signupForNewsletter: Scalars['Boolean']['output'];
  /** @deprecated Use loginWithProvider instead */
  signupWithApple: Scalars['String']['output'];
  /** @deprecated Use signup */
  signupWithEmailPassword: Scalars['String']['output'];
  /** @deprecated Use loginWithProvider instead */
  signupWithGoogle: Scalars['String']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please use the readThread mutation. */
  touch: Thread;
  trackAddToCart: Scalars['Boolean']['output'];
  trackEvent: Scalars['Boolean']['output'];
  translateReviews?: Maybe<Array<Review>>;
  translateThread: Thread;
  unregisterFCMToken: Scalars['Boolean']['output'];
  updateAddress: Address;
  updateCart: Cart;
  updateCartItem: CartItem;
  /** @deprecated Not needed */
  updateFavorite: Favorite;
  updateFavoriteCollection: FavoriteCollection;
  updateForgottenPassword: UpdateForgottenPasswordResponse;
  updateMe: Member;
  updateMedia: Media;
  /** @deprecated Please use updateMe instead */
  updateMember: Member;
  updateMemberPassword?: Maybe<Member>;
  updateMerchant: Merchant;
  updateMerchantBankAccount: Merchant;
  updatePhoneWithOTP: UpdatePhoneWithOtpResponse;
  updateProduct: Product;
  updateReview: Review;
  updateSavedSearch: SavedSearch;
  updateVacationModeEndDate: Merchant;
  validateVoucher: ValidateVoucherResult;
  verifyOtp: VerifyOtpResponse;
  /** @deprecated Please use the cancelBid mutation instead. */
  withdrawBid: Bid;
  withdrawProduct: Product;
};


export type MutationAcceptBidArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAcceptBrengerProposedDateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAddProductToCartArgs = {
  input: AddProductToCart;
};


export type MutationAddProductsToCartArgs = {
  input: AddProductsToCart;
};


export type MutationAddReferralCodeArgs = {
  input?: InputMaybe<AddReferralCodeInput>;
};


export type MutationAddToBoostCartArgs = {
  input: AddToBoostCartInput;
};


export type MutationAddToCartArgs = {
  input?: InputMaybe<AddToCartInput>;
};


export type MutationAnalyzeProductImageArgs = {
  input: AnalyzeProductImageInput;
};


export type MutationAnalyzeProductTitleAndImagesArgs = {
  input: AnalyzeProductTitleAndImagesInput;
};


export type MutationAskProductQuestionArgs = {
  body: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationCancelBidArgs = {
  input: CancelBidInput;
};


export type MutationCancelOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCancelProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCheckEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type MutationCheckOrderPaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCreateAbuseReportArgs = {
  input: AbuseReportInput;
};


export type MutationCreateAddressArgs = {
  input: AddressInput;
};


export type MutationCreateAuctionArgs = {
  input: AuctionInput;
};


export type MutationCreateBidArgs = {
  input: BidInput;
};


export type MutationCreateComingSoonAlertArgs = {
  input: ComingSoonAlertInput;
};


export type MutationCreateCounterBidArgs = {
  values: CounterBidInput;
};


export type MutationCreateFavoriteArgs = {
  input: FavoriteInput;
};


export type MutationCreateFavoriteCollectionArgs = {
  input: FavoriteCollectionInput;
};


export type MutationCreateFeedbackArgs = {
  disputeReason?: InputMaybe<DisputeReason>;
  id: Scalars['UUID']['input'];
  received: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMemberArgs = {
  input: MemberInput;
};


export type MutationCreateMerchantArgs = {
  input: MerchantInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateOrUpdateBankAccountArgs = {
  input: ExternalBankAccountInput;
};


export type MutationCreateOrderArgs = {
  input: OrderInput;
};


export type MutationCreateOrderGroupForCartArgs = {
  input?: InputMaybe<CreateOrderGroupForCartInput>;
};


export type MutationCreatePaymentArgs = {
  id: Scalars['UUID']['input'];
  values: PaymentInput;
};


export type MutationCreatePaymentForBoostArgs = {
  input: CreatePaymentForBoostInput;
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateSavedSearchArgs = {
  input: SavedSearchInput;
};


export type MutationCreateShipmentArgs = {
  input: ShipmentInput;
};


export type MutationCreateStripeAccountLinkArgs = {
  input: StripeAccountLinkInput;
};


export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


export type MutationCreateWuunderShipmentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationDeleteThreadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDisableThreadTranslationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateIterableJwtArgs = {
  input?: InputMaybe<GenerateIterableJwtInput>;
};


export type MutationInviteUserArgs = {
  input?: InputMaybe<InviteUserInput>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithAppleArgs = {
  platform: Platform;
  token: Scalars['String']['input'];
};


export type MutationLoginWithEmailPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithEmailTokenArgs = {
  cookie: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationLoginWithGoogleArgs = {
  platform: Platform;
  token: Scalars['String']['input'];
};


export type MutationLoginWithProviderArgs = {
  platform: Scalars['String']['input'];
  provider: LoginProvider;
  token: Scalars['String']['input'];
};


export type MutationPayProductServiceArgs = {
  input: ProductServiceOrderInput;
};


export type MutationPayShowroomServiceArgs = {
  input: ShowRoomOrderInput;
};


export type MutationProposeBrengerAppointmentDatesArgs = {
  input: BrengerDatesProposalInput;
};


export type MutationPublishProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationReactivateProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationReadThreadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRegisterFcmTokenArgs = {
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRejectBidArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveAddressArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveBidArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveCartItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveComingSoonAlertArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveFavoriteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveFavoriteCollectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveMediaArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveMemberArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveMerchantArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveSavedSearchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRequestEmailTokenArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationRequestPhoneUpdateOtpArgs = {
  input: RequestPhoneUpdateOtpInput;
};


export type MutationRequestVacationModeEnableArgs = {
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationSendMessageArgs = {
  body: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationSendPlatformFeedbackArgs = {
  input: PlatformFeedbackInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSignupForNewsletterArgs = {
  email: Scalars['String']['input'];
};


export type MutationSignupWithAppleArgs = {
  member: MemberInput;
  merchant: MerchantInput;
  platform: Platform;
  token: Scalars['String']['input'];
};


export type MutationSignupWithEmailPasswordArgs = {
  input: SignupWithEmailPasswordInput;
};


export type MutationSignupWithGoogleArgs = {
  member: MemberInput;
  merchant: MerchantInput;
  platform: Platform;
  token: Scalars['String']['input'];
};


export type MutationTouchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationTrackAddToCartArgs = {
  input: TrackAddToCart;
};


export type MutationTrackEventArgs = {
  entity?: InputMaybe<Entity>;
  event?: InputMaybe<Event>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationTranslateReviewsArgs = {
  ids: Array<Scalars['UUID']['input']>;
  lang: Language;
};


export type MutationTranslateThreadArgs = {
  input: TranslateThreadInput;
};


export type MutationUnregisterFcmTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAddressArgs = {
  id: Scalars['UUID']['input'];
  input: AddressInput;
};


export type MutationUpdateCartArgs = {
  input?: InputMaybe<UpdateCartInput>;
};


export type MutationUpdateCartItemArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateCartItemInput;
};


export type MutationUpdateFavoriteArgs = {
  id: Scalars['UUID']['input'];
  input: FavoriteInput;
};


export type MutationUpdateFavoriteCollectionArgs = {
  id: Scalars['UUID']['input'];
  input: FavoriteCollectionInput;
};


export type MutationUpdateForgottenPasswordArgs = {
  input: UpdateForgottenPasswordInput;
};


export type MutationUpdateMeArgs = {
  input: MeInput;
};


export type MutationUpdateMediaArgs = {
  id: Scalars['UUID']['input'];
  input: MediaUpdateInput;
};


export type MutationUpdateMemberArgs = {
  id: Scalars['UUID']['input'];
  input: MemberInput;
};


export type MutationUpdateMemberPasswordArgs = {
  input?: InputMaybe<UpdateMemberPassword>;
};


export type MutationUpdateMerchantArgs = {
  id: Scalars['UUID']['input'];
  input: MerchantInput;
};


export type MutationUpdateMerchantBankAccountArgs = {
  id: Scalars['UUID']['input'];
  input: BankAccountInput;
};


export type MutationUpdatePhoneWithOtpArgs = {
  input: UpdatePhoneWithOtpInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateProductInput;
};


export type MutationUpdateReviewArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateReviewInput;
};


export type MutationUpdateSavedSearchArgs = {
  id: Scalars['UUID']['input'];
  input: SavedSearchInput;
};


export type MutationUpdateVacationModeEndDateArgs = {
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationValidateVoucherArgs = {
  code: Scalars['String']['input'];
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationVerifyOtpArgs = {
  input: VerifyOtpInput;
};


export type MutationWithdrawBidArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationWithdrawProductArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<ProductWithdrawReason>;
};

export type Node = {
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
};

export enum OtpMethod {
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type Order = {
  __typename?: 'Order';
  address?: Maybe<OrderAddress>;
  auction: Auction;
  bid?: Maybe<Bid>;
  brengerAppointment?: Maybe<BrengerAppointment>;
  bumbal_buyer_uuid?: Maybe<Scalars['String']['output']>;
  bumbal_seller_uuid?: Maybe<Scalars['String']['output']>;
  buyer: Merchant;
  buyerId: Scalars['UUID']['output'];
  buyer_protection_excl_vat: Scalars['Float']['output'];
  buyer_protection_incl_vat: Scalars['Float']['output'];
  buyer_receipt?: Maybe<Scalars['String']['output']>;
  buyer_track_and_trace?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  credit_card_cost_excl_vat: Scalars['Float']['output'];
  credit_card_cost_incl_vat: Scalars['Float']['output'];
  currency: Currency;
  damageFormUrl?: Maybe<Scalars['String']['output']>;
  delivery_feedback?: Maybe<Scalars['String']['output']>;
  delivery_method: DeliveryMethod;
  discount_excl_vat: Scalars['Float']['output'];
  discount_incl_vat: Scalars['Float']['output'];
  disputeReason?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  expiry_date: Scalars['DateTime']['output'];
  external_delivery?: Maybe<Scalars['Boolean']['output']>;
  fee_excl_vat: Scalars['Float']['output'];
  fee_incl_vat: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  merchant: Merchant;
  merchantId: Scalars['UUID']['output'];
  outsourceShippingMethod?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<StripePayment>;
  /** @deprecated Field no longer supported */
  payment_excl_vat: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  payment_incl_vat: Scalars['Float']['output'];
  payment_status?: Maybe<PaymentStatus>;
  payout: Scalars['Float']['output'];
  payoutDetails?: Maybe<PayoutDetails>;
  /** @deprecated Use payoutDetails.eta instead */
  payout_eta?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use payoutDetails.status instead */
  payout_status?: Maybe<PayoutStatus>;
  payout_trace_id?: Maybe<Scalars['String']['output']>;
  paypal_cost_excl_vat: Scalars['Float']['output'];
  paypal_cost_incl_vat: Scalars['Float']['output'];
  product: Product;
  purchase_type: PurchaseType;
  returnBrengerAppointment?: Maybe<BrengerAppointment>;
  returnCaseStatus?: Maybe<Scalars['String']['output']>;
  returnShippingMethod?: Maybe<Scalars['String']['output']>;
  review?: Maybe<Review>;
  seller_receipt?: Maybe<Scalars['String']['output']>;
  seller_track_and_trace?: Maybe<Scalars['String']['output']>;
  service_cost_excl_vat: Scalars['Float']['output'];
  service_cost_incl_vat: Scalars['Float']['output'];
  service_target?: Maybe<Product>;
  shipment?: Maybe<Shipment>;
  shipping_excl_vat: Scalars['Float']['output'];
  shipping_incl_vat: Scalars['Float']['output'];
  shipping_method?: Maybe<ShippingMethod>;
  state: OrderState;
  subtotal_excl_vat: Scalars['Float']['output'];
  subtotal_incl_vat: Scalars['Float']['output'];
  thread?: Maybe<Thread>;
  total_excl_vat: Scalars['Float']['output'];
  total_incl_vat: Scalars['Float']['output'];
  totals?: Maybe<CartTotals>;
  wuunderShipment?: Maybe<WuunderShipment>;
};


export type OrderDamageFormUrlArgs = {
  lang?: InputMaybe<Language>;
};


export type OrderPayoutDetailsArgs = {
  lang?: InputMaybe<Language>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export enum OrderDeliveryMethod {
  Delivery = 'DELIVERY',
  ExternalDelivery = 'EXTERNAL_DELIVERY',
  Pickup = 'PICKUP'
}

export type OrderFilter = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};

export enum OrderFilterKey {
  Auction = 'AUCTION',
  Bid = 'BID',
  BidState = 'BID__STATE',
  Buyer = 'BUYER',
  DeliveryMethod = 'DELIVERY_METHOD',
  Merchant = 'MERCHANT',
  Product = 'PRODUCT',
  ProductTitle = 'PRODUCT__TITLE',
  ShippingMethod = 'SHIPPING_METHOD',
  State = 'STATE'
}

export type OrderGroup = {
  __typename?: 'OrderGroup';
  billingAddress?: Maybe<OrderAddress>;
  buyer: Merchant;
  couponCode?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Shouldn't be used anymore */
  hasExternalDelivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  orders: Array<Order>;
  payment?: Maybe<OrderGroupPayment>;
  paymentMethod: PaymentMethod;
  readableId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<OrderAddress>;
  totals: OrderGroupTotals;
  type: OrderGroupType;
};

export type OrderGroupAddonTotals = {
  __typename?: 'OrderGroupAddonTotals';
  addon: Service;
  price: Price;
};

export type OrderGroupPayment = {
  __typename?: 'OrderGroupPayment';
  paymentClientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type OrderGroupTotals = {
  __typename?: 'OrderGroupTotals';
  addons: Array<OrderGroupAddonTotals>;
  discount: Price;
  serviceCost: Price;
  shipping: Price;
  subtotal: Price;
  tax: Price;
  total: Price;
};

export enum OrderGroupType {
  BoostAd = 'BOOST_AD',
  Courier = 'COURIER',
  Products = 'PRODUCTS',
  ShowroomRequest = 'SHOWROOM_REQUEST'
}

export type OrderInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  bid_id?: InputMaybe<Scalars['UUID']['input']>;
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  delivery_method?: InputMaybe<DeliveryMethod>;
  external_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  external_shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_method?: InputMaybe<PaymentMethod>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  purchase_type?: PurchaseType;
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
  shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  use_payment_intents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderResult = {
  __typename?: 'OrderResult';
  items: Array<Order>;
  pagination: PaginationResult;
};

export enum OrderSort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  EndDate = 'END_DATE',
  ExpiryDate = 'EXPIRY_DATE',
  Payout = 'PAYOUT',
  ProductTitle = 'PRODUCT__TITLE',
  TotalInclVat = 'TOTAL_INCL_VAT'
}

export enum OrderState {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  New = 'NEW',
  Shipped = 'SHIPPED'
}

export type OrderTotals = {
  __typename?: 'OrderTotals';
  buyer_protection_excl_vat: Scalars['Float']['output'];
  buyer_protection_incl_vat: Scalars['Float']['output'];
  credit_card_cost_excl_vat: Scalars['Float']['output'];
  credit_card_cost_incl_vat: Scalars['Float']['output'];
  discount_excl_vat: Scalars['Float']['output'];
  discount_incl_vat: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  payment_excl_vat: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  payment_incl_vat: Scalars['Float']['output'];
  paypal_cost_excl_vat: Scalars['Float']['output'];
  paypal_cost_incl_vat: Scalars['Float']['output'];
  service_cost_excl_vat: Scalars['Float']['output'];
  service_cost_incl_vat: Scalars['Float']['output'];
  shipping_excl_vat: Scalars['Float']['output'];
  shipping_incl_vat: Scalars['Float']['output'];
  subtotal_excl_vat: Scalars['Float']['output'];
  subtotal_incl_vat: Scalars['Float']['output'];
  total_excl_vat: Scalars['Float']['output'];
  total_incl_vat: Scalars['Float']['output'];
};

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC',
  Rand = 'RAND'
}

export type Page = {
  __typename?: 'Page';
  blocks: Array<Block>;
  id: Scalars['UUID']['output'];
  /** @deprecated Not needed */
  items: Array<Page>;
  /** @deprecated Not needed */
  parent?: Maybe<Page>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type PageBlocksArgs = {
  location?: InputMaybe<BlockLocation>;
};

export type PageFilter = {
  key?: InputMaybe<AttributeFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PageFilterKey {
  Slug = 'SLUG'
}

export type PageResult = {
  __typename?: 'PageResult';
  items: Array<Page>;
  pagination: PaginationResult;
};

export enum PageSort {
  Title = 'TITLE'
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationOutput = {
  __typename?: 'PaginationOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
};

export type PaginationParams = {
  __typename?: 'PaginationParams';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
};

export type PaymentInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  delivery_method?: InputMaybe<DeliveryMethod>;
  external_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  external_shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_method: PaymentMethod;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
  shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  use_payment_intents?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PaymentMethod {
  ApplePay = 'APPLE_PAY',
  Bancontact = 'BANCONTACT',
  Card = 'CARD',
  Giropay = 'GIROPAY',
  GooglePay = 'GOOGLE_PAY',
  Ideal = 'IDEAL',
  Klarna = 'KLARNA',
  Link = 'LINK',
  Paypal = 'PAYPAL',
  SepaDebit = 'SEPA_DEBIT',
  Sofort = 'SOFORT'
}

export enum PaymentStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  NotPaid = 'NOT_PAID',
  RefundCanceled = 'REFUND_CANCELED',
  RefundFailed = 'REFUND_FAILED',
  RefundPending = 'REFUND_PENDING',
  RefundSucceeded = 'REFUND_SUCCEEDED',
  Shipped = 'SHIPPED'
}

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
};

export type PayoutDetails = {
  __typename?: 'PayoutDetails';
  eta?: Maybe<Scalars['Date']['output']>;
  status: PayoutStatus;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
};

export enum PayoutStatus {
  /** The payout was canceled. */
  Canceled = 'CANCELED',
  /** @deprecated Field no longer supported */
  Completed = 'COMPLETED',
  /** @deprecated Field no longer supported */
  Delivered = 'DELIVERED',
  /** @deprecated Field no longer supported */
  Disputed = 'DISPUTED',
  /** @deprecated Field no longer supported */
  Expired = 'EXPIRED',
  /** The payout failed. */
  Failed = 'FAILED',
  /** The payout is created and we are waiting for stripe. */
  PendingTransfer = 'PENDING_TRANSFER',
  /** The payout succeeded. */
  Succeeded = 'SUCCEEDED',
  /** The payout is in transit. */
  TransferInTransit = 'TRANSFER_IN_TRANSIT',
  /** Waiting for confirmation for buyer or shipping partners */
  WaitingForConfirmation = 'WAITING_FOR_CONFIRMATION'
}

export type Payouts = {
  __typename?: 'Payouts';
  enabled: Scalars['Boolean']['output'];
  items: Array<Payout>;
};

export enum PendingAction {
  AcceptTos = 'ACCEPT_TOS'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PlatformFeedbackInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  topic?: InputMaybe<Scalars['String']['input']>;
};

export enum PlaylistType {
  Hls = 'HLS',
  Mpegdash = 'MPEGDASH'
}

export enum PostalPackageSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
};

export type Product = MediaQueries & {
  __typename?: 'Product';
  address?: Maybe<Address>;
  all_categories: Array<Category>;
  arobject?: Maybe<ArObject>;
  arobjects: Array<ArObject>;
  art_orientation?: Maybe<ArtOrientation>;
  art_size?: Maybe<ArtSize>;
  artist_suggestion?: Maybe<Scalars['String']['output']>;
  attributes: Array<Attribute>;
  auction?: Maybe<Auction>;
  auctions: Array<Auction>;
  audio?: Maybe<Audio>;
  audios: Array<Audio>;
  auto_discount?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<Brand>;
  brand_suggestion?: Maybe<Scalars['String']['output']>;
  breadcrumbs: Array<Category>;
  /** @deprecated Use product.auction.buy_now_price */
  buy_now_price?: Maybe<Price>;
  /** @deprecated Has behaviour of breadcrumbs so use it instead, or all_categories for actual product categories */
  categories: Array<Category>;
  cleaningServiceAvailable: Scalars['Boolean']['output'];
  coming_soon_alert?: Maybe<ComingSoonAlert>;
  condition: ProductCondition;
  created?: Maybe<Scalars['DateTime']['output']>;
  curated_at?: Maybe<Scalars['DateTime']['output']>;
  curated_by?: Maybe<Member>;
  /** @deprecated Field no longer supported */
  curated_custom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  curated_reason?: Maybe<CurationReason>;
  curation_feedback?: Maybe<CurationFeedback>;
  custom_shipping_cost?: Maybe<Price>;
  delivery_method: DeliveryMethod;
  depth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designer_suggestion?: Maybe<Scalars['String']['output']>;
  externalDeliveryAllowed: Scalars['Boolean']['output'];
  externalShippingMethods: Array<ExternalShippingMethod>;
  favorite?: Maybe<Favorite>;
  favorite_count: Scalars['Int']['output'];
  gone: Scalars['Boolean']['output'];
  ground_floor_only_delivery?: Maybe<Scalars['Boolean']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  image?: Maybe<Image>;
  images: Array<Image>;
  isBoostable?: Maybe<Scalars['Boolean']['output']>;
  isDesignerItem?: Maybe<Scalars['Boolean']['output']>;
  isInCart: Scalars['Boolean']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer used */
  is_in_showroom?: Maybe<Scalars['Boolean']['output']>;
  last_boost?: Maybe<Scalars['DateTime']['output']>;
  link: Scalars['String']['output'];
  media: Array<Media>;
  merchant: Merchant;
  merchant_fee?: Maybe<Fee>;
  mpn?: Maybe<Scalars['String']['output']>;
  newPrice?: Maybe<Price>;
  note_for_curator?: Maybe<Scalars['String']['output']>;
  number_of_items?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  original_price?: Maybe<Price>;
  postal_package_size?: Maybe<Scalars['String']['output']>;
  postal_package_weight_kg?: Maybe<Scalars['Float']['output']>;
  product_type?: Maybe<ProductType>;
  push_to_top_count?: Maybe<Scalars['Int']['output']>;
  quality: ProductQuality;
  /** @deprecated No longer used */
  recommended_price?: Maybe<Price>;
  relatedListingPages: Array<ListingPage>;
  seat_height?: Maybe<Scalars['Int']['output']>;
  shape?: Maybe<Shape>;
  /** @deprecated Use product.link */
  share_link: Scalars['String']['output'];
  shippingOptions: Array<ShippingOption>;
  shipping_cost: Price;
  shipping_method?: Maybe<ShippingMethod>;
  shipping_method_prices: Array<ShippingMethodCountryPrice>;
  /** @deprecated No longer used */
  showroom?: Maybe<Showroom>;
  /** @deprecated No longer used */
  showroom_service_order?: Maybe<Order>;
  /** @deprecated No longer used */
  showroom_state?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used */
  showroom_zone?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: ProductState;
  status: ProductStatus;
  title: Scalars['String']['output'];
  two_man_delivery?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  usage_signs_description?: Maybe<Scalars['String']['output']>;
  user_confirmed_postal_fit?: Maybe<Scalars['Boolean']['output']>;
  video?: Maybe<Video>;
  videos: Array<Video>;
  view_count: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type ProductArobjectArgs = {
  platform?: InputMaybe<ArPlatform>;
};


export type ProductArobjectsArgs = {
  platform?: InputMaybe<ArPlatform>;
};


export type ProductAttributesArgs = {
  type?: InputMaybe<AttributeType>;
};


export type ProductAuctionsArgs = {
  state?: InputMaybe<AuctionState>;
};


export type ProductAudioArgs = {
  type?: InputMaybe<AudioType>;
};


export type ProductAudiosArgs = {
  type?: InputMaybe<AudioType>;
};


export type ProductBuy_Now_PriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductCuration_FeedbackArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductCustom_Shipping_CostArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductImageArgs = {
  type?: InputMaybe<ImageType>;
};


export type ProductImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ImageType>;
};


export type ProductMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type ProductNewPriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductOriginal_PriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductRecommended_PriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductShippingOptionsArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductShipping_CostArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type ProductSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductUsage_Signs_DescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductVideoArgs = {
  type?: InputMaybe<VideoType>;
};


export type ProductVideosArgs = {
  type?: InputMaybe<VideoType>;
};

export type ProductBlock = AbstractBlock & {
  __typename?: 'ProductBlock';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  /** @deprecated Not needed */
  link?: Maybe<Scalars['String']['output']>;
  listingPage?: Maybe<ListingPage>;
  /** @deprecated Not needed */
  location?: Maybe<BlockLocation>;
  /** @deprecated Use searchProducts with Collection filter */
  products: Array<Product>;
  slug: Scalars['String']['output'];
  /** @deprecated Use description */
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type ProductBlockDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductBlockTitleArgs = {
  lang?: InputMaybe<Language>;
};

export enum ProductCondition {
  New = 'NEW',
  Openbox = 'OPENBOX',
  Refurbished = 'REFURBISHED',
  Used = 'USED'
}

export type ProductCountByStatus = {
  __typename?: 'ProductCountByStatus';
  count: Scalars['Int']['output'];
  status: ProductStatus;
};

export type ProductFilter = {
  key: ProductFilterKey;
  value: Scalars['String']['input'];
};

export enum ProductFilterKey {
  Artist = 'ARTIST',
  AuctionState = 'AUCTION_STATE',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Color = 'COLOR',
  Description = 'DESCRIPTION',
  Designer = 'DESIGNER',
  Expiring = 'EXPIRING',
  ExpiryDate = 'EXPIRY_DATE',
  Group = 'GROUP',
  IsInShowroom = 'IS_IN_SHOWROOM',
  Label = 'LABEL',
  Material = 'MATERIAL',
  Merchant = 'MERCHANT',
  /** Valid values: true | false */
  Premium = 'PREMIUM',
  Price = 'PRICE',
  ProductState = 'PRODUCT_STATE',
  ProductStatus = 'PRODUCT_STATUS',
  /** Valid values: round | square | organic | rectangle */
  Shape = 'SHAPE',
  Slug = 'SLUG',
  Style = 'STYLE',
  Subject = 'SUBJECT',
  Tag = 'TAG',
  Title = 'TITLE',
  TitleOrDescription = 'TITLE_OR_DESCRIPTION'
}

export type ProductInput = {
  additional_info?: InputMaybe<Array<Scalars['UUID']['input']>>;
  address?: InputMaybe<Scalars['UUID']['input']>;
  allow_bid: Scalars['Boolean']['input'];
  allow_buy_now: Scalars['Boolean']['input'];
  already_advertised_on_whoppah?: InputMaybe<Scalars['Boolean']['input']>;
  art_orientation?: InputMaybe<ArtOrientation>;
  artist_suggestion?: InputMaybe<Scalars['String']['input']>;
  artists?: InputMaybe<Array<Scalars['UUID']['input']>>;
  auto_discount?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['UUID']['input']>;
  brand_suggestion?: InputMaybe<Scalars['String']['input']>;
  buy_now_price?: InputMaybe<PriceInput>;
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  colors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  condition?: InputMaybe<ProductCondition>;
  delivery_method: DeliveryMethod;
  depth?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer_suggestion?: InputMaybe<Scalars['String']['input']>;
  designers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer used */
  is_in_showroom?: InputMaybe<Scalars['Boolean']['input']>;
  materials?: InputMaybe<Array<Scalars['UUID']['input']>>;
  merchant: Scalars['UUID']['input'];
  minimum_bid?: InputMaybe<PriceInput>;
  mpn?: InputMaybe<Scalars['String']['input']>;
  new_price?: InputMaybe<PriceInput>;
  note_for_curator?: InputMaybe<Scalars['String']['input']>;
  number_of_items?: InputMaybe<Scalars['Int']['input']>;
  original_price?: InputMaybe<PriceInput>;
  postal_package_size?: InputMaybe<PostalPackageSize>;
  postal_package_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  quality: ProductQuality;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
  seat_height?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Shape>;
  shipping_cost?: InputMaybe<PriceInput>;
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  subject?: InputMaybe<Array<Scalars['UUID']['input']>>;
  title: Scalars['String']['input'];
  usage_signs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  usage_signs_description?: InputMaybe<Scalars['String']['input']>;
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Clients should not be allowed to update weight */
  weight?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPlatformFeeInput = {
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductPlatformFeeResult = {
  __typename?: 'ProductPlatformFeeResult';
  campaign_code?: Maybe<Scalars['String']['output']>;
  fee: Fee;
};

export enum ProductQuality {
  Good = 'GOOD',
  Great = 'GREAT',
  Perfect = 'PERFECT'
}

export type ProductResult = {
  __typename?: 'ProductResult';
  items: Array<Product>;
  pagination: PaginationResult;
};

export type ProductScreenParams = {
  __typename?: 'ProductScreenParams';
  slug: Scalars['String']['output'];
};

export type ProductShippingOptionsAddressInput = {
  country: Country;
};

export type ProductShippingOptionsInput = {
  deliveryAddress?: InputMaybe<ProductShippingOptionsAddressInput>;
  lang?: InputMaybe<Language>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  productSlug?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductSlugKey {
  Slug = 'SLUG'
}

export enum ProductSort {
  AskingPrice = 'ASKING_PRICE',
  Created = 'CREATED',
  Default = 'DEFAULT',
  ExpiryDate = 'EXPIRY_DATE',
  Title = 'TITLE',
  Updated = 'UPDATED'
}

export enum ProductState {
  Accepted = 'ACCEPTED',
  Archive = 'ARCHIVE',
  Banned = 'BANNED',
  Canceled = 'CANCELED',
  Curation = 'CURATION',
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  Updated = 'UPDATED'
}

export enum ProductStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expiring = 'EXPIRING',
  InReview = 'IN_REVIEW',
  Sold = 'SOLD'
}

export type ProductType = {
  __typename?: 'ProductType';
  arobject?: Maybe<ArObject>;
};


export type ProductTypeArobjectArgs = {
  platform?: InputMaybe<ArPlatform>;
};

export enum ProductWithdrawReason {
  ExpiredNoResponse = 'EXPIRED_NO_RESPONSE',
  LeavingWhoppah = 'LEAVING_WHOPPAH',
  NoLongerSelling = 'NO_LONGER_SELLING',
  Other = 'OTHER',
  Sold_1Stdibs = 'SOLD_1STDIBS',
  SoldDirectlyToBuyer = 'SOLD_DIRECTLY_TO_BUYER',
  SoldEbay = 'SOLD_EBAY',
  SoldElsewhere = 'SOLD_ELSEWHERE',
  SoldMarktplaats = 'SOLD_MARKTPLAATS',
  SoldPamono = 'SOLD_PAMONO',
  SoldSelency = 'SOLD_SELENCY',
  SoldTweedehands = 'SOLD_TWEEDEHANDS',
  SoldWhoppah = 'SOLD_WHOPPAH'
}

export type Promotion = {
  __typename?: 'Promotion';
  code: Scalars['String']['output'];
  discount: CouponCodeDiscount;
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

export enum PurchaseType {
  Bid = 'BID',
  DirectPurchase = 'DIRECT_PURCHASE'
}

export type Query = {
  __typename?: 'Query';
  addresses: Array<Address>;
  attribute: Attribute;
  attributeByKey?: Maybe<Attribute>;
  attributes: AttributeResult;
  attributesByID: Array<Maybe<Attribute>>;
  attributesByKey: Array<Attribute>;
  balance: Price;
  bid?: Maybe<Bid>;
  bidByKey?: Maybe<Bid>;
  bids: BidResult;
  bidsByID: Array<Maybe<Bid>>;
  bidsByKey: Array<Bid>;
  /** @deprecated Not needed */
  block: Block;
  /** @deprecated Not needed */
  blockByKey?: Maybe<Block>;
  /** @deprecated Not needed */
  blocks: BlockResult;
  /** @deprecated Not needed */
  blocksByID: Array<Maybe<Block>>;
  /** @deprecated Not needed */
  blocksByKey: Array<Block>;
  boostCart: BoostCart;
  brands: Array<Brand>;
  cart: Cart;
  cartCount: Scalars['Int']['output'];
  categories: CategoryResult;
  categoriesByID: Array<Maybe<Category>>;
  categoriesByKey: Array<Category>;
  category?: Maybe<Category>;
  categoryByKey?: Maybe<Category>;
  checkVat?: Maybe<VatCheckResult>;
  collections: Array<Collection>;
  comingSoonAlerts: ComingSoonAlertResult;
  deeplink?: Maybe<AppScreen>;
  designers: Array<Designer>;
  exportOrderOverview?: Maybe<Array<Maybe<Order>>>;
  favorites: FavoriteResult;
  getBrengerAppointmentOptions: BrengerAppointmentOptions;
  getBrengerProposedDates: BrengerProposedDates;
  getFallbackListingPage: ListingPage;
  getMessages: GetMessagesResult;
  getOrderTotals: OrderTotals;
  getProductPlatformFee: ProductPlatformFeeResult;
  getProductShippingOptions: Array<ShippingOption>;
  getStripeEphemeralKey: Scalars['JSON']['output'];
  getThreads: GetThreadsResult;
  getUnreadMessageCount: Scalars['Int']['output'];
  guestCart: GuestCart;
  health: Scalars['Boolean']['output'];
  homepage?: Maybe<Homepage>;
  listingPage?: Maybe<ListingPage>;
  listingPageByFilters?: Maybe<ListingPage>;
  localizeUrl: LocalizedUrl;
  me?: Maybe<Member>;
  member?: Maybe<Member>;
  memberByKey?: Maybe<Member>;
  members: MemberResult;
  membersByID: Array<Maybe<Member>>;
  membersByKey: Array<Member>;
  merchant?: Maybe<Merchant>;
  merchantByKey?: Maybe<Merchant>;
  merchants: MerchantResult;
  merchantsByID: Array<Merchant>;
  merchantsByKey: Array<Merchant>;
  message?: Maybe<Message>;
  messages: MessageResult;
  order?: Maybe<Order>;
  orderByKey?: Maybe<Order>;
  orderGroupByPaymentIntent?: Maybe<OrderGroup>;
  orders: OrderResult;
  ordersByID: Array<Maybe<Order>>;
  ordersByKey: Array<Order>;
  /** @deprecated Not needed */
  page: Page;
  /** @deprecated Not needed */
  pageByKey?: Maybe<Page>;
  /** @deprecated Not needed */
  pages: PageResult;
  /** @deprecated Not needed */
  pagesByID: Array<Maybe<Page>>;
  /** @deprecated Not needed */
  pagesByKey: Array<Page>;
  payouts: Payouts;
  pendingVouchers: Array<CouponCode>;
  product?: Maybe<Product>;
  productByDMId?: Maybe<Product>;
  productById: Product;
  productByIdentifier: Product;
  productByKey?: Maybe<Product>;
  productBySlug?: Maybe<Product>;
  productCountByStatus: Array<ProductCountByStatus>;
  products: ProductResult;
  productsByID: Array<Maybe<Product>>;
  productsByKey: Array<Product>;
  promotions: Array<Promotion>;
  querySuggestions: Array<Scalars['String']['output']>;
  /** @deprecated Use relatedProducts */
  recommendedProducts: Array<Product>;
  referralTypes: Array<ReferralType>;
  relatedProducts: Array<Product>;
  reviews: ReviewResult;
  savedSearch?: Maybe<SavedSearch>;
  savedSearchByIdentifier?: Maybe<SavedSearch>;
  savedSearchByKey?: Maybe<SavedSearch>;
  savedSearches: SavedSearchResult;
  savedSearchesByID: Array<Maybe<SavedSearch>>;
  savedSearchesByKey: Array<SavedSearch>;
  /** @deprecated Please use listingPage.filters */
  searchFiltersByURL?: Maybe<SearchFiltersByUrlResponse>;
  searchProducts?: Maybe<SearchProductsResult>;
  /** @deprecated Please use listingPage.subcategoryPages */
  searchSubpages: SearchSubpagesResponse;
  shippingMethods: Array<ShippingMethod>;
  /** @deprecated Use relatedProducts */
  similarProducts: Array<Product>;
  stats: Stats;
  statsAdsAndSignups?: Maybe<Array<Maybe<StatsAdsAndSignups>>>;
  statsBuyers?: Maybe<StatsBuyers>;
  statsBuyersVsOrders?: Maybe<StatsBuyersVsOrders>;
  statsByMerchantSignup?: Maybe<StatsByMerchantSignup>;
  statsByMonth: Array<StatsByMonth>;
  statsByOrderNo?: Maybe<Array<Maybe<StatsByOrderNo>>>;
  statsByPeriod?: Maybe<StatsByPeriod>;
  statsByPeriodMonthly?: Maybe<Array<Maybe<StatsByPeriodMonthly>>>;
  statsByProductCategory: Array<StatsByProductCategory>;
  statsByQuarter: Array<StatsByQuarter>;
  statsBySignupDate?: Maybe<StatsBySignupDate>;
  statsByUser?: Maybe<Array<StatsByUser>>;
  statsFavorites?: Maybe<StatsFavorites>;
  statsFavoritesByProductState?: Maybe<StatsFavoritesByProductState>;
  statsMerchants?: Maybe<StatsMerchants>;
  statsProduct?: Maybe<StatsProduct>;
  statsRevenue?: Maybe<StatsRevenue>;
  statsSellers?: Maybe<StatsSellers>;
  statsThreads: StatsThreads;
  statsUsers?: Maybe<StatsUsers>;
  status?: Maybe<Scalars['Int']['output']>;
  stripeAccountDetails?: Maybe<StripeAccountDetails>;
  subcategories: Array<Category>;
  thread?: Maybe<Thread>;
  /** @deprecated Please use the getThreads query. */
  threads: ThreadResult;
  throwAuthenticationError: Scalars['Boolean']['output'];
  throwForbiddenError: Scalars['Boolean']['output'];
  throwSyntaxError: Scalars['Boolean']['output'];
  throwUserInputError: Scalars['Boolean']['output'];
  throwValidationError: Scalars['Boolean']['output'];
  translate: Array<TranslationResult>;
};


export type QueryAttributeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAttributeByKeyArgs = {
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryAttributesArgs = {
  filters?: InputMaybe<Array<InputMaybe<AttributeFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AttributeSort>;
};


export type QueryAttributesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QueryAttributesByKeyArgs = {
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryBidArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBidByKeyArgs = {
  key?: InputMaybe<BidFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryBidsArgs = {
  filters?: InputMaybe<Array<BidFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BidSort>;
};


export type QueryBidsByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBidsByKeyArgs = {
  key?: InputMaybe<BidFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryBlockArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBlockByKeyArgs = {
  key?: InputMaybe<BlockFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryBlocksArgs = {
  filters?: InputMaybe<Array<InputMaybe<BlockFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BlockSort>;
};


export type QueryBlocksByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QueryBlocksByKeyArgs = {
  key?: InputMaybe<BlockFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryBrandsArgs = {
  filters?: InputMaybe<BrandsFilter>;
};


export type QueryCategoriesArgs = {
  filters?: InputMaybe<Array<CategoryFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CategorySort>;
};


export type QueryCategoriesByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCategoriesByKeyArgs = {
  key?: InputMaybe<CategoryFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCategoryByKeyArgs = {
  key?: InputMaybe<CategoryFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryCheckVatArgs = {
  input?: InputMaybe<VatCheckInput>;
};


export type QueryComingSoonAlertsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryDeeplinkArgs = {
  lang?: InputMaybe<Language>;
  url: Scalars['String']['input'];
};


export type QueryDesignersArgs = {
  filters?: InputMaybe<DesignersFilter>;
};


export type QueryExportOrderOverviewArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFavoritesArgs = {
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<FavoriteSort>;
};


export type QueryGetBrengerAppointmentOptionsArgs = {
  orderId: Scalars['UUID']['input'];
};


export type QueryGetBrengerProposedDatesArgs = {
  orderId: Scalars['UUID']['input'];
};


export type QueryGetFallbackListingPageArgs = {
  lang: Language;
  slug: Scalars['String']['input'];
};


export type QueryGetMessagesArgs = {
  input: GetMessagesInput;
};


export type QueryGetOrderTotalsArgs = {
  values: OrderInput;
};


export type QueryGetProductPlatformFeeArgs = {
  input?: InputMaybe<ProductPlatformFeeInput>;
};


export type QueryGetProductShippingOptionsArgs = {
  input?: InputMaybe<ProductShippingOptionsInput>;
};


export type QueryGetStripeEphemeralKeyArgs = {
  version: Scalars['String']['input'];
};


export type QueryGetThreadsArgs = {
  input?: InputMaybe<GetThreadsInput>;
};


export type QueryGetUnreadMessageCountArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGuestCartArgs = {
  input: GuestCartInput;
};


export type QueryListingPageArgs = {
  input: ListingPageInput;
};


export type QueryListingPageByFiltersArgs = {
  input: ListingPageByFiltersInput;
};


export type QueryLocalizeUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryMemberArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMemberByKeyArgs = {
  key: MemberFilterKey;
  value: Scalars['String']['input'];
};


export type QueryMembersArgs = {
  filters?: InputMaybe<Array<InputMaybe<MemberFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<MemberSort>;
};


export type QueryMembersByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QueryMembersByKeyArgs = {
  key: MemberFilterKey;
  value: Scalars['String']['input'];
};


export type QueryMerchantArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMerchantByKeyArgs = {
  key: MerchantFilterKey;
  value: Scalars['String']['input'];
};


export type QueryMerchantsArgs = {
  filters?: InputMaybe<Array<InputMaybe<MerchantFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<MerchantSort>;
};


export type QueryMerchantsByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QueryMerchantsByKeyArgs = {
  key: MerchantFilterKey;
  value: Scalars['String']['input'];
};


export type QueryMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMessagesArgs = {
  filters?: InputMaybe<Array<MessageFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<MessageSort>;
};


export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrderByKeyArgs = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};


export type QueryOrderGroupByPaymentIntentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  filters?: InputMaybe<Array<OrderFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OrderSort>;
};


export type QueryOrdersByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrdersByKeyArgs = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};


export type QueryPageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPageByKeyArgs = {
  key?: InputMaybe<PageFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryPagesArgs = {
  filters?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PageSort>;
};


export type QueryPagesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QueryPagesByKeyArgs = {
  key?: InputMaybe<PageFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryPendingVouchersArgs = {
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductByDmIdArgs = {
  dmId: Scalars['String']['input'];
};


export type QueryProductByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryProductByKeyArgs = {
  key?: InputMaybe<ProductFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryProductBySlugArgs = {
  key?: InputMaybe<ProductSlugKey>;
  value: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  filters?: InputMaybe<Array<ProductFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryProductsByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductsByKeyArgs = {
  key?: InputMaybe<ProductFilterKey>;
  value: Scalars['String']['input'];
};


export type QueryQuerySuggestionsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
};


export type QueryRecommendedProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryRelatedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['String']['input'];
};


export type QueryReviewsArgs = {
  filters?: InputMaybe<Array<ReviewFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReviewSort>;
};


export type QuerySavedSearchArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySavedSearchByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QuerySavedSearchByKeyArgs = {
  key: SavedSearchFilterKey;
  value: Scalars['String']['input'];
};


export type QuerySavedSearchesArgs = {
  filters?: InputMaybe<Array<InputMaybe<SavedSearchFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SavedSearchSort>;
};


export type QuerySavedSearchesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


export type QuerySavedSearchesByKeyArgs = {
  key: SavedSearchFilterKey;
  value: Scalars['String']['input'];
};


export type QuerySearchFiltersByUrlArgs = {
  input?: InputMaybe<SearchFiltersByUrlInput>;
};


export type QuerySearchProductsArgs = {
  input?: InputMaybe<SearchProductsInput>;
};


export type QuerySearchSubpagesArgs = {
  input: SearchSubpagesInput;
};


export type QuerySimilarProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  product: Scalars['UUID']['input'];
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryStatsByMonthArgs = {
  buyerType?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatsByPeriodArgs = {
  merchant_type?: InputMaybe<MerchantType>;
};


export type QueryStatsByQuarterArgs = {
  buyerType?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatsBySignupDateArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QuerySubcategoriesArgs = {
  input?: InputMaybe<SubcategoriesInput>;
};


export type QueryThreadArgs = {
  id: Scalars['UUID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryThreadsArgs = {
  filters?: InputMaybe<Array<ThreadFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ThreadSort>;
};


export type QueryTranslateArgs = {
  lang: Lang;
  strings: Array<Scalars['String']['input']>;
};

export type QueryBlock = AbstractBlock & {
  __typename?: 'QueryBlock';
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  products: Array<Product>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type ReferralType = {
  __typename?: 'ReferralType';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};


export type ReferralTypeNameArgs = {
  lang?: InputMaybe<Language>;
};

export enum Referrer {
  /** Mobile or google advertisement */
  DigitalAdvertisement = 'DIGITAL_ADVERTISEMENT',
  /** Email promotions */
  Email = 'EMAIL',
  /** Fairs, exhibitions, etc. */
  Event = 'EVENT',
  /** @deprecated Please use SOCIAL_MEDIA for facebook/instagram instead */
  FacebookInstagram = 'FACEBOOK_INSTAGRAM',
  /** Friend or relative told me about it */
  FamilyFriendsColleagues = 'FAMILY_FRIENDS_COLLEAGUES',
  /** @deprecated Please use SEARCH_ENGINE for google instead */
  Google = 'GOOGLE',
  /** Some other form */
  Others = 'OTHERS',
  /** Physical advertisement or billboard */
  PhysicalAdvertisement = 'PHYSICAL_ADVERTISEMENT',
  /** @deprecated Please use SOCIAL_MEDIA for pinterest instead */
  Pinterest = 'PINTEREST',
  /** News website article */
  PressArticle = 'PRESS_ARTICLE',
  /** I received a referral voucher */
  ReferralVoucher = 'REFERRAL_VOUCHER',
  /** Search engine (Google, Bing, etc.) */
  SearchEngine = 'SEARCH_ENGINE',
  /** Search media (Facebook, Instagram, Pinterest etc.) */
  SocialMedia = 'SOCIAL_MEDIA',
  /** Commercial or program on television */
  Television = 'TELEVISION'
}

export type RelatedListingPage = {
  __typename?: 'RelatedListingPage';
  fallback: Scalars['Boolean']['output'];
  listingPage: ListingPage;
  type: ListingPageRelationType;
};

export type RequestAccountDeletionResponse = {
  __typename?: 'RequestAccountDeletionResponse';
  requestedDeletionAt: Scalars['DateTime']['output'];
  scheduledDeletionAt: Scalars['DateTime']['output'];
};

export type RequestPhoneUpdateOtpInput = {
  method: OtpMethod;
  newPhone: Scalars['String']['input'];
};

export type RequestPhoneUpdateOtpResponse = {
  __typename?: 'RequestPhoneUpdateOTPResponse';
  expiresAfter: Scalars['Int']['output'];
  expiresAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  retryAfter: Scalars['Int']['output'];
  retryAt: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ReturnCaseStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum ReturnShippingMethod {
  Brenger = 'BRENGER',
  Hoekstra = 'HOEKSTRA',
  LiberoLogistics = 'LIBERO_LOGISTICS',
  MagicMovers = 'MAGIC_MOVERS',
  OutsourcePartner = 'OUTSOURCE_PARTNER',
  Swdevries = 'SWDEVRIES',
  Transpoksi = 'TRANSPOKSI',
  VintageExpress = 'VINTAGE_EXPRESS'
}

export type Review = {
  __typename?: 'Review';
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  order: Order;
  review?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<Merchant>;
  score?: Maybe<Scalars['Int']['output']>;
};


export type ReviewReviewArgs = {
  lang?: InputMaybe<Language>;
};

export type ReviewFilter = {
  key: ReviewFilterKey;
  value: Scalars['String']['input'];
};

export enum ReviewFilterKey {
  Merchant = 'MERCHANT',
  Reviewer = 'REVIEWER',
  Score = 'SCORE'
}

export type ReviewInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['UUID']['input'];
  review: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type ReviewResult = {
  __typename?: 'ReviewResult';
  items: Array<Review>;
  pagination: PaginationResult;
};

export enum ReviewSort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  Score = 'SCORE'
}

export type SavedSearch = {
  __typename?: 'SavedSearch';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  filters?: Maybe<Array<Maybe<FilterOutput>>>;
  id: Scalars['UUID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SavedSearchFilter = {
  key: SavedSearchFilterKey;
  value: Scalars['String']['input'];
};

export enum SavedSearchFilterKey {
  Slug = 'SLUG',
  Title = 'TITLE'
}

export type SavedSearchInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SavedSearchResult = {
  __typename?: 'SavedSearchResult';
  items: Array<SavedSearch>;
  pagination: PaginationResult;
};

export enum SavedSearchSort {
  Created = 'CREATED',
  Slug = 'SLUG',
  Title = 'TITLE'
}

export enum ScreenName {
  About = 'ABOUT',
  AccountOverview = 'ACCOUNT_OVERVIEW',
  Chat = 'CHAT',
  CreateAccount = 'CREATE_ACCOUNT',
  CreateAd = 'CREATE_AD',
  HowItWorks = 'HOW_IT_WORKS',
  HowItWorksBidding = 'HOW_IT_WORKS_BIDDING',
  HowItWorksCuration = 'HOW_IT_WORKS_CURATION',
  HowItWorksPayment = 'HOW_IT_WORKS_PAYMENT',
  HowItWorksShipping = 'HOW_IT_WORKS_SHIPPING',
  Product = 'PRODUCT',
  Search = 'SEARCH'
}

/**
 * SearchFacet is the result of the facets when searching.
 * It contains the SearchKey and buckets (values) with their
 * counts and data.
 */
export type SearchFacet = {
  __typename?: 'SearchFacet';
  key?: Maybe<SearchFacetKey>;
  values?: Maybe<Array<Maybe<SearchFacetValue>>>;
};

/**
 * The SearchFacetKey enum represents the ability of attributes
 * to facet upon.
 */
export enum SearchFacetKey {
  ArtOrientation = 'ART_ORIENTATION',
  ArtSize = 'ART_SIZE',
  ArtSubject = 'ART_SUBJECT',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Color = 'COLOR',
  Country = 'COUNTRY',
  Designer = 'DESIGNER',
  Label = 'LABEL',
  Material = 'MATERIAL',
  Premium = 'PREMIUM',
  Quality = 'QUALITY',
  Shape = 'SHAPE',
  Style = 'STYLE'
}

export type SearchFacetStats = {
  __typename?: 'SearchFacetStats';
  key?: Maybe<SearchFacetsStatKey>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/**
 * The SearchFacetValue offers a proxy to a specific type
 * in the system if necessary. But select with caution since
 * it'll degrade the performance.
 *
 * Rather use a translation system based on the SearchFacetKey and
 * the facet value itself to display items.
 *
 * Use the value for filtering
 */
export type SearchFacetValue = {
  __typename?: 'SearchFacetValue';
  attribute?: Maybe<Attribute>;
  category?: Maybe<Category>;
  count?: Maybe<Scalars['Int']['output']>;
  merchant?: Maybe<Merchant>;
  value?: Maybe<Scalars['String']['output']>;
};

/** The SearchFacetsStatKey enum */
export enum SearchFacetsStatKey {
  Depth = 'DEPTH',
  DiscountPercentage = 'DISCOUNT_PERCENTAGE',
  Height = 'HEIGHT',
  NumberOfItems = 'NUMBER_OF_ITEMS',
  Price = 'PRICE',
  Width = 'WIDTH'
}

export type SearchFilterItem = {
  __typename?: 'SearchFilterItem';
  key: SearchFilterKey;
  value: Scalars['String']['output'];
};

/**
 * The SearchFilterKey enum represents the ability of attributes
 * to filter upon.
 */
export enum SearchFilterKey {
  AllowBid = 'ALLOW_BID',
  ArtOrientation = 'ART_ORIENTATION',
  ArtSize = 'ART_SIZE',
  ArtSubject = 'ART_SUBJECT',
  Availability = 'AVAILABILITY',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Collection = 'COLLECTION',
  Color = 'COLOR',
  ComingSoon = 'COMING_SOON',
  Condition = 'CONDITION',
  Country = 'COUNTRY',
  CuratedDate = 'CURATED_DATE',
  Depth = 'DEPTH',
  Designer = 'DESIGNER',
  DiscountPercentage = 'DISCOUNT_PERCENTAGE',
  ExpertSeller = 'EXPERT_SELLER',
  HasAr = 'HAS_AR',
  Height = 'HEIGHT',
  InShowroom = 'IN_SHOWROOM',
  IsDesignerItem = 'IS_DESIGNER_ITEM',
  Label = 'LABEL',
  Material = 'MATERIAL',
  Merchant = 'MERCHANT',
  NumberOfItems = 'NUMBER_OF_ITEMS',
  OnSale = 'ON_SALE',
  Premium = 'PREMIUM',
  Price = 'PRICE',
  Quality = 'QUALITY',
  SeatHeight = 'SEAT_HEIGHT',
  Shape = 'SHAPE',
  ShippingMethod = 'SHIPPING_METHOD',
  Showroom = 'SHOWROOM',
  StartDate = 'START_DATE',
  Style = 'STYLE',
  Width = 'WIDTH'
}

export type SearchFiltersByUrlInput = {
  lang: Language;
  url: Scalars['String']['input'];
};

export type SearchFiltersByUrlResponse = {
  __typename?: 'SearchFiltersByURLResponse';
  filters: Array<SearchFilterItem>;
  order?: Maybe<Ordering>;
  sort?: Maybe<SearchSort>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SearchProductsBlock = {
  __typename?: 'SearchProductsBlock';
  /** @deprecated Use `url` instead */
  filters?: Maybe<Array<ListingPageFilterItem>>;
  id: Scalars['UUID']['output'];
  /** @deprecated Use `url` instead */
  order?: Maybe<Ordering>;
  products: Array<Product>;
  /** @deprecated Use `url` instead */
  query?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `url` instead */
  recommended?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `url` instead */
  sort?: Maybe<SearchSort>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type SearchProductsBlockProductsArgs = {
  additionalFilters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchProductsBlockSubtitleArgs = {
  lang?: InputMaybe<Language>;
};


export type SearchProductsBlockTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type SearchProductsBlockUrlArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * SearchProductsInput contains all information to build a
 * search request. If no facets are provided then the default
 * facets are assumed and returned.
 */
export type SearchProductsInput = {
  analyticsTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetKey>>>;
  facetsStats?: InputMaybe<Array<InputMaybe<SearchFacetsStatKey>>>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SearchSort>;
  sortingType?: InputMaybe<SortingType>;
};

/**
 * The SearchProductsResult is the type containing the found
 * items, discovered facets and the pagination information
 * of the current query.
 */
export type SearchProductsResult = {
  __typename?: 'SearchProductsResult';
  facets?: Maybe<Array<Maybe<SearchFacet>>>;
  facetsStats?: Maybe<Array<Maybe<SearchFacetStats>>>;
  indexName?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Product>>>;
  pagination?: Maybe<PaginationResult>;
  queryID?: Maybe<Scalars['String']['output']>;
};

export type SearchScreenFilterItem = {
  __typename?: 'SearchScreenFilterItem';
  key: SearchFilterKey;
  value: Scalars['String']['output'];
};

export type SearchScreenParams = {
  __typename?: 'SearchScreenParams';
  facets?: Maybe<Array<Maybe<SearchFacetKey>>>;
  filters: Array<SearchScreenFilterItem>;
  order?: Maybe<Ordering>;
  pagination?: Maybe<PaginationParams>;
  query?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<SearchSort>;
};

export enum SearchSort {
  Created = 'CREATED',
  Default = 'DEFAULT',
  Distance = 'DISTANCE',
  Popularity = 'POPULARITY',
  Price = 'PRICE',
  Title = 'TITLE'
}

export type SearchSubpage = {
  __typename?: 'SearchSubpage';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SearchSubpagesInput = {
  lang: Language;
  url: Scalars['String']['input'];
};

export type SearchSubpagesResponse = {
  __typename?: 'SearchSubpagesResponse';
  items: Array<SearchSubpage>;
};

export type SellerCountVsOrderCount = {
  __typename?: 'SellerCountVsOrderCount';
  order_count: Scalars['Int']['output'];
  seller_count: Scalars['Int']['output'];
};

export type SendOtpResponse = {
  __typename?: 'SendOtpResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  description: Scalars['String']['output'];
  fullDescription?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type ServiceDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ServiceFullDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ServiceNameArgs = {
  lang?: InputMaybe<Language>;
};


export type ServiceSlugArgs = {
  lang?: InputMaybe<Language>;
};

export enum ServiceType {
  PushToTop = 'PUSH_TO_TOP'
}

export enum Shape {
  Organic = 'ORGANIC',
  Other = 'OTHER',
  Oval = 'OVAL',
  Rectangle = 'RECTANGLE',
  Round = 'ROUND',
  Square = 'SQUARE',
  Triangle = 'TRIANGLE'
}

export type Shipment = {
  __typename?: 'Shipment';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  merchant: Merchant;
  order: Order;
  return_code?: Maybe<Scalars['String']['output']>;
  tracking_code?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ShipmentInput = {
  order_id: Scalars['UUID']['input'];
  return_code?: InputMaybe<Scalars['String']['input']>;
  tracking_code?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingEstimator = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  price: Price;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ShippingMethodPriceArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  origin?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethodCountryPrice = {
  __typename?: 'ShippingMethodCountryPrice';
  country: Scalars['String']['output'];
  price: Price;
};

export enum ShippingMethodEnum {
  Courier = 'COURIER',
  Custom = 'CUSTOM',
  Pickup = 'PICKUP',
  Postal = 'POSTAL'
}

export type ShippingOption = {
  __typename?: 'ShippingOption';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Price>;
  shippingMethod: ShippingMethodEnum;
  shippingProvider?: Maybe<ShippingProviderEnum>;
};

export enum ShippingProviderEnum {
  Brenger = 'BRENGER',
  Wuunder = 'WUUNDER'
}

export type ShowRoomOrderInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<PaymentMethod>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  use_payment_intents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Showroom = {
  __typename?: 'Showroom';
  address?: Maybe<ShowroomAddress>;
  googleMapsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  image: Scalars['String']['output'];
  info: Scalars['String']['output'];
  openingHours: Scalars['String']['output'];
};


export type ShowroomInfoArgs = {
  lang?: InputMaybe<Language>;
};


export type ShowroomOpeningHoursArgs = {
  lang?: InputMaybe<Language>;
};

export type ShowroomAddress = {
  __typename?: 'ShowroomAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SignupAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  postal_code: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SignupInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  access_token: Scalars['String']['output'];
  user: Member;
};

export type SignupWithEmailPasswordInput = {
  address?: InputMaybe<SignupAddressInput>;
  email: Scalars['String']['input'];
  family_name?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: MerchantType;
};

export enum Size {
  /** @deprecated Not required */
  All = 'ALL',
  Lg = 'LG',
  Md = 'MD',
  Sm = 'SM',
  Xs = 'XS'
}

/** The SortingType enum represents the type of sorting we want to do */
export enum SortingType {
  Exhaustive = 'EXHAUSTIVE',
  /** @deprecated We always use EXHAUSTIVE sorting type */
  Relevant = 'RELEVANT'
}

export type Stats = {
  __typename?: 'Stats';
  avg_order_value: Scalars['Float']['output'];
  avg_order_value_business: Scalars['Float']['output'];
  avg_order_value_individual: Scalars['Float']['output'];
  business_merchants_count: Scalars['Int']['output'];
  business_products_count: Scalars['Int']['output'];
  buyer_count_vs_order_count: Array<BuyerCountVsOrderCount>;
  individual_merchants_count: Scalars['Int']['output'];
  individual_products_count: Scalars['Int']['output'];
  merchant_count_vs_chat_count: Array<MerchantCountVsChatCount>;
  merchant_count_vs_product_count: Array<MerchantCountVsProductCount>;
  recurring_ad_creators_count: Scalars['Int']['output'];
  recurring_threads_by_merchants: Scalars['Int']['output'];
  sales_by_category: Array<CategorySales>;
  seller_count_vs_order_count: Array<SellerCountVsOrderCount>;
  total_bids: Scalars['Int']['output'];
  total_gross_sales_margin: Scalars['Float']['output'];
  total_gross_sales_volume: Scalars['Float']['output'];
  total_gross_sales_volume_business: Scalars['Float']['output'];
  total_gross_sales_volume_individual: Scalars['Float']['output'];
  total_sales_commission: Scalars['Float']['output'];
  total_sales_courier: Scalars['Float']['output'];
  total_threads: Scalars['Int']['output'];
  total_transaction_fees: Scalars['Float']['output'];
  total_transactions: Scalars['Int']['output'];
  unique_ad_creators_count: Scalars['Int']['output'];
  unique_threads_by_merchants_count: Scalars['Int']['output'];
};

export type StatsAdsAndSignups = {
  __typename?: 'StatsAdsAndSignups';
  ads: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  signups: Scalars['Int']['output'];
};

export type StatsBuyers = {
  __typename?: 'StatsBuyers';
  average_time_between_orders: Scalars['Float']['output'];
};

export type StatsBuyersVsOrders = {
  __typename?: 'StatsBuyersVsOrders';
  byOrderCount: Array<Maybe<StatsBuyersVsOrdersItem>>;
  total: Array<Maybe<StatsBuyersVsOrdersItem>>;
};

export type StatsBuyersVsOrdersItem = {
  __typename?: 'StatsBuyersVsOrdersItem';
  average_life: Scalars['Float']['output'];
  buyer_count: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  order_count: Scalars['Int']['output'];
};

export type StatsByMerchantSignup = {
  __typename?: 'StatsByMerchantSignup';
  buyers: StatsByMerchantSignupByType;
  buyersAndSellers: StatsByMerchantSignupByType;
  sellers: StatsByMerchantSignupByType;
};

export type StatsByMerchantSignupByType = {
  __typename?: 'StatsByMerchantSignupByType';
  business: Array<StatsByMerchantSignupByTypeItem>;
  individual: Array<StatsByMerchantSignupByTypeItem>;
  total: Array<StatsByMerchantSignupByTypeItem>;
};

export type StatsByMerchantSignupByTypeItem = {
  __typename?: 'StatsByMerchantSignupByTypeItem';
  gross_sales_volume: Scalars['Float']['output'];
  order_quarter: Scalars['String']['output'];
  signup_month: Scalars['String']['output'];
  total_sales_commission: Scalars['Float']['output'];
  total_sales_courier: Scalars['Float']['output'];
  transactions_count: Scalars['Int']['output'];
  user_count: Scalars['Int']['output'];
};

export type StatsByMonth = {
  __typename?: 'StatsByMonth';
  average_order_value: Scalars['Float']['output'];
  courier_shipping_amount: Scalars['Float']['output'];
  courier_shipping_amount_showroom: Scalars['Float']['output'];
  courier_shipping_count: Scalars['Int']['output'];
  courier_shipping_count_showroom: Scalars['Int']['output'];
  custom_shipping_amount: Scalars['Float']['output'];
  custom_shipping_count: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  non_services_gross_sales_volume: Scalars['Float']['output'];
  non_services_transactions: Scalars['Int']['output'];
  pickup_count: Scalars['Int']['output'];
  pickup_count_showroom: Scalars['Int']['output'];
  promo_package_amount: Scalars['Float']['output'];
  promo_package_count: Scalars['Int']['output'];
  registered_shipping_amount: Scalars['Float']['output'];
  registered_shipping_count: Scalars['Int']['output'];
  services_gross_sales_volume: Scalars['Float']['output'];
  services_transactions: Scalars['Int']['output'];
  standard_shipping_amount: Scalars['Float']['output'];
  standard_shipping_count: Scalars['Int']['output'];
  total_gross_sales_margin: Scalars['Float']['output'];
  total_gross_sales_volume: Scalars['Float']['output'];
  total_sales_commission: Scalars['Float']['output'];
  total_sales_courier: Scalars['Float']['output'];
  total_transaction_fees: Scalars['Float']['output'];
  total_transactions: Scalars['Int']['output'];
  total_transactions_showroom: Scalars['Int']['output'];
};

export type StatsByOrderNo = {
  __typename?: 'StatsByOrderNo';
  avg: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  order_no: Scalars['Int']['output'];
  sum: Scalars['Float']['output'];
};

export type StatsByPeriod = {
  __typename?: 'StatsByPeriod';
  lastMonth?: Maybe<StatsByPeriodItem>;
  lastQuarter?: Maybe<StatsByPeriodItem>;
  lastWeek?: Maybe<StatsByPeriodItem>;
  lastYear?: Maybe<StatsByPeriodItem>;
  lifetime?: Maybe<StatsByPeriodItem>;
  monthToDate?: Maybe<StatsByPeriodItem>;
  quarterToDate?: Maybe<StatsByPeriodItem>;
  today?: Maybe<StatsByPeriodItem>;
  yearToDate?: Maybe<StatsByPeriodItem>;
  yesterday?: Maybe<StatsByPeriodItem>;
};

export type StatsByPeriodItem = {
  __typename?: 'StatsByPeriodItem';
  adsApprovalRate?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateArt?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateDecoration?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateFurniture?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateLighting?: Maybe<Scalars['Float']['output']>;
  adsCreated?: Maybe<Scalars['Int']['output']>;
  averageCourierRevenue?: Maybe<Scalars['Float']['output']>;
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageSalesFee?: Maybe<Scalars['Float']['output']>;
  courierRatio?: Maybe<Scalars['Float']['output']>;
  feesRevenue?: Maybe<Scalars['Float']['output']>;
  grossMarginValue?: Maybe<Scalars['Float']['output']>;
  numberOfBids?: Maybe<Scalars['Int']['output']>;
  numberOfChats?: Maybe<Scalars['Int']['output']>;
  numberOfItemsThatHadBid?: Maybe<Scalars['Int']['output']>;
  numberOfSales?: Maybe<Scalars['Int']['output']>;
  signups?: Maybe<Scalars['Int']['output']>;
  signupsFBIG?: Maybe<Scalars['Int']['output']>;
  signupsFNF?: Maybe<Scalars['Int']['output']>;
  signupsGoogle?: Maybe<Scalars['Int']['output']>;
  signupsInvited?: Maybe<Scalars['Int']['output']>;
  signupsOther?: Maybe<Scalars['Int']['output']>;
  signupsTV?: Maybe<Scalars['Int']['output']>;
  totalCourierCount?: Maybe<Scalars['Float']['output']>;
  totalCourierRevenue?: Maybe<Scalars['Float']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type StatsByPeriodMonthly = {
  __typename?: 'StatsByPeriodMonthly';
  adsApprovalRate?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateArt?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateDecoration?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateFurniture?: Maybe<Scalars['Float']['output']>;
  adsApprovalRateLighting?: Maybe<Scalars['Float']['output']>;
  adsCreated?: Maybe<Scalars['Int']['output']>;
  averageCourierRevenue?: Maybe<Scalars['Float']['output']>;
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageSalesFee?: Maybe<Scalars['Float']['output']>;
  courierRatio?: Maybe<Scalars['Float']['output']>;
  feesRevenue?: Maybe<Scalars['Float']['output']>;
  grossMarginValue?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  numberOfBids?: Maybe<Scalars['Int']['output']>;
  numberOfChats?: Maybe<Scalars['Int']['output']>;
  numberOfItemsThatHadBid?: Maybe<Scalars['Int']['output']>;
  numberOfSales?: Maybe<Scalars['Int']['output']>;
  signups?: Maybe<Scalars['Int']['output']>;
  signupsFBIG?: Maybe<Scalars['Int']['output']>;
  signupsFNF?: Maybe<Scalars['Int']['output']>;
  signupsGoogle?: Maybe<Scalars['Int']['output']>;
  signupsInvited?: Maybe<Scalars['Int']['output']>;
  signupsOther?: Maybe<Scalars['Int']['output']>;
  signupsTV?: Maybe<Scalars['Int']['output']>;
  totalCourierCount?: Maybe<Scalars['Float']['output']>;
  totalCourierRevenue?: Maybe<Scalars['Float']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type StatsByProductCategory = {
  __typename?: 'StatsByProductCategory';
  active_count: Scalars['Int']['output'];
  average_order_value: Scalars['Float']['output'];
  average_sold_after: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  sales_volume: Scalars['Float']['output'];
  sold_count: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
};

export type StatsByQuarter = {
  __typename?: 'StatsByQuarter';
  average_order_value: Scalars['Float']['output'];
  courier_shipping_amount: Scalars['Float']['output'];
  courier_shipping_amount_showroom: Scalars['Float']['output'];
  courier_shipping_count: Scalars['Int']['output'];
  courier_shipping_count_showroom: Scalars['Int']['output'];
  custom_shipping_amount: Scalars['Float']['output'];
  custom_shipping_count: Scalars['Int']['output'];
  non_services_gross_sales_volume: Scalars['Float']['output'];
  non_services_transactions: Scalars['Int']['output'];
  pickup_count: Scalars['Int']['output'];
  pickup_count_showroom: Scalars['Int']['output'];
  promo_package_amount: Scalars['Float']['output'];
  promo_package_count: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
  registered_shipping_amount: Scalars['Float']['output'];
  registered_shipping_count: Scalars['Int']['output'];
  services_gross_sales_volume: Scalars['Float']['output'];
  services_transactions: Scalars['Int']['output'];
  standard_shipping_amount: Scalars['Float']['output'];
  standard_shipping_count: Scalars['Int']['output'];
  total_gross_sales_margin: Scalars['Float']['output'];
  total_gross_sales_volume: Scalars['Float']['output'];
  total_sales_commission: Scalars['Float']['output'];
  total_sales_courier: Scalars['Float']['output'];
  total_transaction_fees: Scalars['Float']['output'];
  total_transactions: Scalars['Int']['output'];
  total_transactions_showroom: Scalars['Int']['output'];
};

export type StatsBySignupDate = {
  __typename?: 'StatsBySignupDate';
  buyer: Array<Maybe<StatsBySignupDateItem>>;
  seller: Array<Maybe<StatsBySignupDateItem>>;
};

export type StatsBySignupDateItem = {
  __typename?: 'StatsBySignupDateItem';
  dateRange: Scalars['String']['output'];
  lastHalfYear: StatsBySignupDateItemItem;
  lastMonth: StatsBySignupDateItemItem;
  lastQuarter: StatsBySignupDateItemItem;
  lastWeek: StatsBySignupDateItemItem;
  lastYear: StatsBySignupDateItemItem;
  today: StatsBySignupDateItemItem;
};

export type StatsBySignupDateItemItem = {
  __typename?: 'StatsBySignupDateItemItem';
  grossMarginValue: Scalars['Float']['output'];
  transactions: Scalars['Int']['output'];
};

export type StatsByUser = {
  __typename?: 'StatsByUser';
  id: Scalars['UUID']['output'];
  last6Months: StatsByUserItem;
  last12Months: StatsByUserItem;
  last18Months: StatsByUserItem;
};

export type StatsByUserItem = {
  __typename?: 'StatsByUserItem';
  bids: Scalars['Int']['output'];
  favorites: Scalars['Int']['output'];
  listings: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
};

export type StatsFavoriteMonthly = {
  __typename?: 'StatsFavoriteMonthly';
  favorite_count: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  product_count: Scalars['Int']['output'];
};

export type StatsFavoriteQuarterly = {
  __typename?: 'StatsFavoriteQuarterly';
  favorite_count: Scalars['Int']['output'];
  product_count: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
};

export type StatsFavorites = {
  __typename?: 'StatsFavorites';
  monthly: Array<StatsFavoriteMonthly>;
  quarterly: Array<StatsFavoriteQuarterly>;
};

export type StatsFavoritesByProductState = {
  __typename?: 'StatsFavoritesByProductState';
  active_ads: StatsFavoritesByProductStateItem;
  all_ads: StatsFavoritesByProductStateItem;
  sold_ads: StatsFavoritesByProductStateItem;
};

export type StatsFavoritesByProductStateItem = {
  __typename?: 'StatsFavoritesByProductStateItem';
  average_favorite_count: Scalars['Float']['output'];
  max_favorite_count: Scalars['Int']['output'];
  min_favorite_count: Scalars['Int']['output'];
};

export type StatsMerchant = {
  __typename?: 'StatsMerchant';
  average_ads_active: Scalars['Float']['output'];
  average_ads_banned: Scalars['Float']['output'];
  average_ads_canceled: Scalars['Float']['output'];
  average_ads_created: Scalars['Float']['output'];
  average_ads_sold: Scalars['Float']['output'];
  average_sold_after: Scalars['Float']['output'];
  average_sold_percentage: Scalars['Float']['output'];
  total_ads_active: Scalars['Int']['output'];
  total_ads_banned: Scalars['Int']['output'];
  total_ads_canceled: Scalars['Int']['output'];
  total_ads_created: Scalars['Int']['output'];
  total_ads_sold: Scalars['Int']['output'];
};

export type StatsMerchants = {
  __typename?: 'StatsMerchants';
  business: StatsMerchant;
  individual: StatsMerchant;
  total: StatsMerchant;
};

export type StatsProduct = {
  __typename?: 'StatsProduct';
  business: StatsProductItem;
  individual: StatsProductItem;
  total: StatsProductItem;
};

export type StatsProductItem = {
  __typename?: 'StatsProductItem';
  monthly: Array<StatsProductMonthly>;
  quarterly: Array<StatsProductQuarterly>;
};

export type StatsProductMonthly = {
  __typename?: 'StatsProductMonthly';
  active_products: Scalars['Int']['output'];
  average_sold_after: Scalars['Float']['output'];
  banned_products: Scalars['Int']['output'];
  canceled_products: Scalars['Int']['output'];
  curation_products: Scalars['Int']['output'];
  draft_products: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  rejected_products: Scalars['Int']['output'];
  sold_products: Scalars['Int']['output'];
  total_products: Scalars['Int']['output'];
};

export type StatsProductQuarterly = {
  __typename?: 'StatsProductQuarterly';
  active_products: Scalars['Int']['output'];
  average_sold_after: Scalars['Float']['output'];
  banned_products: Scalars['Int']['output'];
  canceled_products: Scalars['Int']['output'];
  curation_products: Scalars['Int']['output'];
  draft_products: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
  rejected_products: Scalars['Int']['output'];
  sold_products: Scalars['Int']['output'];
  total_products: Scalars['Int']['output'];
};

export type StatsRevenue = {
  __typename?: 'StatsRevenue';
  buyers: StatsRevenueUserType;
  sellers: StatsRevenueUserType;
};

export type StatsRevenueMonthly = {
  __typename?: 'StatsRevenueMonthly';
  average_fee: Scalars['Float']['output'];
  average_items: Scalars['Float']['output'];
  average_payment: Scalars['Float']['output'];
  average_shipping: Scalars['Float']['output'];
  average_subtotal: Scalars['Float']['output'];
  average_total: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
};

export type StatsRevenueQuarterly = {
  __typename?: 'StatsRevenueQuarterly';
  average_fee: Scalars['Float']['output'];
  average_items: Scalars['Float']['output'];
  average_payment: Scalars['Float']['output'];
  average_shipping: Scalars['Float']['output'];
  average_subtotal: Scalars['Float']['output'];
  average_total: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
};

export type StatsRevenueUserType = {
  __typename?: 'StatsRevenueUserType';
  monthly: Array<StatsRevenueMonthly>;
  quarterly: Array<StatsRevenueQuarterly>;
};

export type StatsSellers = {
  __typename?: 'StatsSellers';
  age_groups: Array<AgeGroup>;
};

export type StatsThreads = {
  __typename?: 'StatsThreads';
  monthly: Array<StatsThreadsMonthly>;
  quarterly: Array<StatsThreadsQuarterly>;
};

export type StatsThreadsMonthly = {
  __typename?: 'StatsThreadsMonthly';
  average_bid_count: Scalars['Float']['output'];
  average_message_count: Scalars['Float']['output'];
  average_order_count: Scalars['Float']['output'];
  converted_threads: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  total_bid_count: Scalars['Int']['output'];
  total_message_count: Scalars['Int']['output'];
  total_order_count: Scalars['Int']['output'];
  total_threads: Scalars['Int']['output'];
};

export type StatsThreadsQuarterly = {
  __typename?: 'StatsThreadsQuarterly';
  average_bid_count: Scalars['Float']['output'];
  average_message_count: Scalars['Float']['output'];
  average_order_count: Scalars['Float']['output'];
  converted_threads: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
  total_bid_count: Scalars['Int']['output'];
  total_message_count: Scalars['Int']['output'];
  total_order_count: Scalars['Int']['output'];
  total_threads: Scalars['Int']['output'];
};

export type StatsUserMonthly = {
  __typename?: 'StatsUserMonthly';
  business_signups: Scalars['Int']['output'];
  individual_signups: Scalars['Int']['output'];
  month_year: Scalars['String']['output'];
  total_signups: Scalars['Int']['output'];
};

export type StatsUserQuarterly = {
  __typename?: 'StatsUserQuarterly';
  business_signups: Scalars['Int']['output'];
  individual_signups: Scalars['Int']['output'];
  quarter: Scalars['String']['output'];
  total_signups: Scalars['Int']['output'];
};

export type StatsUsers = {
  __typename?: 'StatsUsers';
  monthly: Array<StatsUserMonthly>;
  quarterly: Array<StatsUserQuarterly>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  account_id: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type StripeAccountDetails = {
  __typename?: 'StripeAccountDetails';
  account_created: Scalars['Boolean']['output'];
  bank_account?: Maybe<ExternalBankAccount>;
  payouts_enabled: Scalars['Boolean']['output'];
};

export type StripeAccountLink = {
  __typename?: 'StripeAccountLink';
  url: Scalars['String']['output'];
};

export type StripeAccountLinkInput = {
  otp?: InputMaybe<Scalars['String']['input']>;
  refresh_url: Scalars['String']['input'];
  return_url: Scalars['String']['input'];
  type: StripeAccountLinkType;
};

export enum StripeAccountLinkType {
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  AccountUpdate = 'ACCOUNT_UPDATE'
}

export type StripePayment = {
  __typename?: 'StripePayment';
  client_secret_id: Scalars['String']['output'];
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  payment_method: Scalars['String']['output'];
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payment_source_id?: Maybe<Scalars['String']['output']>;
};

export type Style = AbstractAttribute & {
  __typename?: 'Style';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  listingPage: ListingPage;
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type StyleMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type StyleSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type StyleTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type SubcategoriesInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};

export type Subject = AbstractAttribute & {
  __typename?: 'Subject';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SubjectMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type Subscriber = {
  __typename?: 'Subscriber';
  id: Scalars['UUID']['output'];
  merchant: Merchant;
  requestedTranslationLanguage?: Maybe<Scalars['String']['output']>;
  role: SubscriberRole;
};

export enum SubscriberRole {
  Bot = 'BOT',
  Curator = 'CURATOR',
  Subscriber = 'SUBSCRIBER',
  Support = 'SUPPORT'
}

export type Subscription = {
  __typename?: 'Subscription';
  healthy: Scalars['Boolean']['output'];
  messageCreated: Message;
  messageUpdated: Message;
  status?: Maybe<Scalars['Int']['output']>;
};

export type TextBlock = AbstractBlock & {
  __typename?: 'TextBlock';
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  sections: Array<TextSection>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TextSection = {
  __typename?: 'TextSection';
  button?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Thread = {
  __typename?: 'Thread';
  canSendImageMessage: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  item: ThreadItem;
  /** @deprecated Please use the getMessages query. */
  messages: Array<Message>;
  started_by: Merchant;
  subscribers: Array<Subscriber>;
  unread_count: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type ThreadMessagesArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type ThreadFilter = {
  key?: InputMaybe<ThreadFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ThreadFilterKey {
  Item = 'ITEM',
  StartedBy = 'STARTED_BY',
  Thread = 'THREAD'
}

export type ThreadItem = Merchant | Product;

export type ThreadResult = {
  __typename?: 'ThreadResult';
  items: Array<Thread>;
  pagination: PaginationResult;
};

export enum ThreadSort {
  Created = 'CREATED',
  Item = 'ITEM',
  StartedBy = 'STARTED_BY',
  Updated = 'UPDATED'
}

export type TrackAddToCart = {
  productId: Scalars['UUID']['input'];
};

export type TranslateThreadInput = {
  id: Scalars['UUID']['input'];
  lang: Language;
};

export type TranslationResult = {
  __typename?: 'TranslationResult';
  detectedLanguageCode?: Maybe<Scalars['String']['output']>;
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type UnavailableDate = {
  __typename?: 'UnavailableDate';
  date: Scalars['Date']['output'];
  state: UnavailableDateState;
};

export enum UnavailableDateState {
  Rejected = 'REJECTED',
  Unavailable = 'UNAVAILABLE'
}

export type UpdateCartInput = {
  /** @deprecated Use shipping_address_id */
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  billing_address_id?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Moved to CartItem */
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to CartItem */
  delivery_method?: InputMaybe<DeliveryMethod>;
  payment_method?: InputMaybe<PaymentMethod>;
  shipping_address_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateCartItemInput = {
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  delivery_method?: InputMaybe<DeliveryMethod>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  external_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  external_shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  services?: InputMaybe<Array<Scalars['UUID']['input']>>;
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
};

export type UpdateForgottenPasswordInput = {
  new_password: Scalars['String']['input'];
  new_password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type UpdateForgottenPasswordResponse = {
  __typename?: 'UpdateForgottenPasswordResponse';
  message: Scalars['String']['output'];
  status: UpdateForgottenPasswordResult;
};

export enum UpdateForgottenPasswordResult {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type UpdateMemberPassword = {
  current?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhoneWithOtpInput = {
  newOtp: Scalars['String']['input'];
  newPhone: Scalars['String']['input'];
};

export type UpdatePhoneWithOtpResponse = {
  __typename?: 'UpdatePhoneWithOTPResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: Member;
};

export type UpdateProductInput = {
  additional_info?: InputMaybe<Array<Scalars['UUID']['input']>>;
  address?: InputMaybe<Scalars['UUID']['input']>;
  allow_bid?: InputMaybe<Scalars['Boolean']['input']>;
  allow_buy_now?: InputMaybe<Scalars['Boolean']['input']>;
  already_advertised_on_whoppah?: InputMaybe<Scalars['Boolean']['input']>;
  art_orientation?: InputMaybe<ArtOrientation>;
  artist_suggestion?: InputMaybe<Scalars['String']['input']>;
  artists?: InputMaybe<Array<Scalars['UUID']['input']>>;
  auto_discount?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['UUID']['input']>;
  brand_suggestion?: InputMaybe<Scalars['String']['input']>;
  buy_now_price?: InputMaybe<PriceInput>;
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  colors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  condition?: InputMaybe<ProductCondition>;
  delivery_method?: InputMaybe<DeliveryMethod>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer_suggestion?: InputMaybe<Scalars['String']['input']>;
  designers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** @deprecated No longer used */
  is_in_showroom?: InputMaybe<Scalars['Boolean']['input']>;
  materials?: InputMaybe<Array<Scalars['UUID']['input']>>;
  merchant?: InputMaybe<Scalars['UUID']['input']>;
  minimum_bid?: InputMaybe<PriceInput>;
  mpn?: InputMaybe<Scalars['String']['input']>;
  new_price?: InputMaybe<PriceInput>;
  note_for_curator?: InputMaybe<Scalars['String']['input']>;
  number_of_items?: InputMaybe<Scalars['Int']['input']>;
  original_price?: InputMaybe<PriceInput>;
  postal_package_size?: InputMaybe<PostalPackageSize>;
  postal_package_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  quality?: InputMaybe<ProductQuality>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
  seat_height?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Shape>;
  shipping_cost?: InputMaybe<PriceInput>;
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  subject?: InputMaybe<Array<Scalars['UUID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  usage_signs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  usage_signs_description?: InputMaybe<Scalars['String']['input']>;
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Clients should not be allowed to update weight */
  weight?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UsageSign = AbstractAttribute & {
  __typename?: 'UsageSign';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type UsageSignMediaArgs = {
  type?: InputMaybe<MediaType>;
};

export type ValidateVoucherInvalid = {
  __typename?: 'ValidateVoucherInvalid';
  invalid: Scalars['Boolean']['output'];
  invalid_reason: Scalars['String']['output'];
};

export type ValidateVoucherResult = ValidateVoucherInvalid | ValidateVoucherValid;

export type ValidateVoucherValid = {
  __typename?: 'ValidateVoucherValid';
  type: DiscountType;
  value: Scalars['Float']['output'];
};

export type VerifyOtpInput = {
  otp: Scalars['String']['input'];
};

export type VerifyOtpResponse = {
  __typename?: 'VerifyOtpResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Video = {
  __typename?: 'Video';
  id: Scalars['UUID']['output'];
  thumbnail: Scalars['String']['output'];
  type: VideoType;
  url: Scalars['String']['output'];
};


export type VideoThumbnailArgs = {
  size?: InputMaybe<Size>;
};


export type VideoUrlArgs = {
  playlist?: InputMaybe<PlaylistType>;
};

export type VideoBlock = AbstractBlock & {
  __typename?: 'VideoBlock';
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BlockLocation>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videos: Array<Video>;
};

export enum VideoType {
  Default = 'DEFAULT'
}

export type Voucher = {
  __typename?: 'Voucher';
  code: Scalars['String']['output'];
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

export type WuunderShipment = {
  __typename?: 'WuunderShipment';
  failedToSend: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  labelGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  labelUrl?: Maybe<Scalars['String']['output']>;
  order: Order;
  parcelPointsUrl?: Maybe<Scalars['String']['output']>;
  rateCarrier: Scalars['String']['output'];
  rateCode: Scalars['String']['output'];
  ratePrice: Scalars['String']['output'];
  sendByDate: Scalars['DateTime']['output'];
  shouldRemind: Scalars['Boolean']['output'];
  status?: Maybe<WuunderShipmentStatus>;
  trackAndTraceCode?: Maybe<Scalars['String']['output']>;
  trackAndTraceUrl?: Maybe<Scalars['String']['output']>;
};


export type WuunderShipmentParcelPointsUrlArgs = {
  lang?: InputMaybe<Language>;
};

export enum WuunderShipmentStatus {
  Delivered = 'DELIVERED',
  InTransit = 'IN_TRANSIT',
  Issue = 'ISSUE',
  NotSent = 'NOT_SENT'
}

export type WuunderShippingRate = {
  __typename?: 'WuunderShippingRate';
  carrierCode?: Maybe<Scalars['String']['output']>;
  carrierImageUrl?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  carrierProductCode?: Maybe<Scalars['String']['output']>;
  deliveryAfter?: Maybe<Scalars['String']['output']>;
  deliveryBefore?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  pickupAfter?: Maybe<Scalars['String']['output']>;
  pickupBefore?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type ProductServiceOrderInput = {
  payment_method?: InputMaybe<PaymentMethod>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  service_id?: InputMaybe<Scalars['UUID']['input']>;
  use_payment_intents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateReviewInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

export enum VatCheck {
  Failed = 'FAILED',
  Invalid = 'INVALID',
  Ok = 'OK'
}

export type VatCheckInput = {
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type VatCheckResult = {
  __typename?: 'vatCheckResult';
  result?: Maybe<VatCheck>;
};

export type BoostCartFragmentFragment_BoostCart_products_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction_buy_now_price_Price | null };

export type BoostCartFragmentFragment_BoostCart_products_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: BoostCartFragmentFragment_BoostCart_products_Product_image_Image | null, auction?: BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction | null };

export type BoostCartFragmentFragment_BoostCart_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostCartFragmentFragment = { __typename?: 'BoostCart', products: Array<BoostCartFragmentFragment_BoostCart_products_Product>, total: BoostCartFragmentFragment_BoostCart_total_Price };

export type CartFragmentFragment_Cart_payment_CartPayment = { __typename?: 'CartPayment', payment_intent_id: string, payment_client_secret: string };

export type CartFragmentFragment_Cart_shipping_address_Address = { __typename?: 'Address', id: any, city: string, country: string, line1: string, line2?: string | null, postal_code: string, state?: string | null };

export type CartFragmentFragment_Cart_items_CartItem_shipping_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingCost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_externalShippingCost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service = { __typename?: 'Service', id: any, name: string, icon: string, description: string, fullDescription?: string | null, name_en: string };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService = { __typename?: 'CartItemService', id: string, eligible: boolean, ineligibleReason?: string | null, ineligibleError?: string | null, active: boolean, service: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service, price?: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_address_Address = { __typename?: 'Address', city: string, country: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Artist = { __typename?: 'Artist' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Brand = { __typename?: 'Brand' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Color = { __typename?: 'Color' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Designer = { __typename?: 'Designer' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Label = { __typename?: 'Label' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Subject = { __typename?: 'Subject' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes = CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_AdditionalInfo | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Artist | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Brand | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Color | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Designer | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Label | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Material | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Style | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Subject | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_UsageSign;

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction = { __typename?: 'Auction', sold_at?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_sold_at_Price | null, buy_now_price?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_buy_now_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice = { __typename?: 'ShippingMethodCountryPrice', country: string, price: CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type CartFragmentFragment_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, view_count: number, favorite_count: number, quality: ProductQuality, showroom_state?: string | null, is_in_showroom?: boolean | null, number_of_items?: number | null, ground_floor_only_delivery?: boolean | null, delivery_method: DeliveryMethod, address?: CartFragmentFragment_Cart_items_CartItem_product_Product_address_Address | null, buy_now_price?: CartFragmentFragment_Cart_items_CartItem_product_Product_buy_now_price_Price | null, categories: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_categories_Category>, attributes: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_attributes>, auction?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction | null, image?: CartFragmentFragment_Cart_items_CartItem_product_Product_image_Image | null, custom_shipping_cost?: CartFragmentFragment_Cart_items_CartItem_product_Product_custom_shipping_cost_Price | null, shipping_method?: CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_ShippingMethod | null, shipping_method_prices: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice>, merchant: CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant };

export type CartFragmentFragment_Cart_items_CartItem_bid_Bid_order_Order = { __typename?: 'Order', id: any };

export type CartFragmentFragment_Cart_items_CartItem_bid_Bid = { __typename?: 'Bid', id: any, order?: CartFragmentFragment_Cart_items_CartItem_bid_Bid_order_Order | null };

export type CartFragmentFragment_Cart_items_CartItem_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem = { __typename?: 'CartItem', id: any, external_delivery?: boolean | null, external_delivery_available?: boolean | null, service_type?: ServiceType | null, delivery_method?: DeliveryMethod | null, shipping?: CartFragmentFragment_Cart_items_CartItem_shipping_Price | null, shippingCost?: CartFragmentFragment_Cart_items_CartItem_shippingCost_Price | null, externalShippingCost?: CartFragmentFragment_Cart_items_CartItem_externalShippingCost_Price | null, shippingOptions: Array<CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption>, available_services: Array<CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService>, product: CartFragmentFragment_Cart_items_CartItem_product_Product, bid?: CartFragmentFragment_Cart_items_CartItem_bid_Bid | null, total: CartFragmentFragment_Cart_items_CartItem_total_Price, subtotal: CartFragmentFragment_Cart_items_CartItem_subtotal_Price };

export type CartFragmentFragment_Cart_available_coupon_codes_CouponCode_discount_CouponCodeDiscount = { __typename?: 'CouponCodeDiscount', type: DiscountType, value: number };

export type CartFragmentFragment_Cart_available_coupon_codes_CouponCode = { __typename?: 'CouponCode', code: string, valid_upto?: any | null, discount: CartFragmentFragment_Cart_available_coupon_codes_CouponCode_discount_CouponCodeDiscount };

export type CartFragmentFragment_Cart_totals_OrderTotals = { __typename?: 'OrderTotals', service_cost_incl_vat: number, credit_card_cost_incl_vat: number, paypal_cost_incl_vat: number, discount_incl_vat: number, shipping_incl_vat: number, subtotal_incl_vat: number, total_incl_vat: number, buyer_protection_incl_vat: number };

export type CartFragmentFragment_Cart_totals2_CartTotals_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_serviceCost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_shipping_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_discount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_service_Service = { __typename?: 'Service', id: any, name: string };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices = { __typename?: 'CartTotalsServices', service: CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_service_Service, price: CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_price_Price };

export type CartFragmentFragment_Cart_totals2_CartTotals = { __typename?: 'CartTotals', total?: CartFragmentFragment_Cart_totals2_CartTotals_total_Price | null, subtotal?: CartFragmentFragment_Cart_totals2_CartTotals_subtotal_Price | null, serviceCost?: CartFragmentFragment_Cart_totals2_CartTotals_serviceCost_Price | null, shipping?: CartFragmentFragment_Cart_totals2_CartTotals_shipping_Price | null, discount?: CartFragmentFragment_Cart_totals2_CartTotals_discount_Price | null, services: Array<CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices> };

export type CartFragmentFragment = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals?: CartFragmentFragment_Cart_totals_OrderTotals | null, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type CartProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_address_Address = { __typename?: 'Address', city: string, country: string };

export type CartProductFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string };

export type CartProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string };

export type CartProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: CartProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type CartProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type CartProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null };

export type CartProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, buy_now_price?: CartProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type CartProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type CartProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type CartProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type CartProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type CartProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type CartProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes = CartProductFragmentFragment_Product_attributes_AdditionalInfo | CartProductFragmentFragment_Product_attributes_Artist | CartProductFragmentFragment_Product_attributes_Brand | CartProductFragmentFragment_Product_attributes_Color | CartProductFragmentFragment_Product_attributes_Designer | CartProductFragmentFragment_Product_attributes_Label | CartProductFragmentFragment_Product_attributes_Material | CartProductFragmentFragment_Product_attributes_Style | CartProductFragmentFragment_Product_attributes_Subject | CartProductFragmentFragment_Product_attributes_UsageSign;

export type CartProductFragmentFragment_Product_merchant_Merchant_addresses_Address = { __typename?: 'Address', id: any, country: string };

export type CartProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, addresses: Array<CartProductFragmentFragment_Product_merchant_Merchant_addresses_Address> };

export type CartProductFragmentFragment = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, isInCart: boolean, view_count: number, favorite_count: number, quality: ProductQuality, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type PrivateProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_image_Image = { __typename?: 'Image', url: string, id: any };

export type PrivateProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type PrivateProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type PrivateProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, allow_bid: boolean, buy_now_price?: PrivateProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null, minimum_bid?: PrivateProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PrivateProductFragmentFragment_Product_auction_Auction_sold_at_Price | null };

export type PrivateProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type PrivateProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type PrivateProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, created: any, image?: PrivateProductFragmentFragment_Product_merchant_Merchant_image_Image | null };

export type PrivateProductFragmentFragment_Product_merchant_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type PrivateProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PrivateProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type PrivateProductFragmentFragment_Product_breadcrumbs_Category = { __typename?: 'Category', id: any, slug: string };

export type PrivateProductFragmentFragment_Product_brand_Brand = { __typename?: 'Brand', id: any, slug: string };

export type PrivateProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, hex?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PrivateProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PrivateProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject' };

export type PrivateProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes = PrivateProductFragmentFragment_Product_attributes_AdditionalInfo | PrivateProductFragmentFragment_Product_attributes_Artist | PrivateProductFragmentFragment_Product_attributes_Brand | PrivateProductFragmentFragment_Product_attributes_Color | PrivateProductFragmentFragment_Product_attributes_Designer | PrivateProductFragmentFragment_Product_attributes_Label | PrivateProductFragmentFragment_Product_attributes_Material | PrivateProductFragmentFragment_Product_attributes_Style | PrivateProductFragmentFragment_Product_attributes_Subject | PrivateProductFragmentFragment_Product_attributes_UsageSign;

export type PrivateProductFragmentFragment_Product_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback = { __typename?: 'CurationFeedback', message: string, severity: CurationFeedbackSeverity };

export type PrivateProductFragmentFragment = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, description?: string | null, state: ProductState, view_count: number, favorite_count: number, quality: ProductQuality, status: ProductStatus, auto_discount?: boolean | null, brand_suggestion?: string | null, artist_suggestion?: string | null, number_of_items?: number | null, shape?: Shape | null, created?: any | null, condition: ProductCondition, isBoostable?: boolean | null, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, usage_signs_description?: string | null, is_in_showroom?: boolean | null, note_for_curator?: string | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: string | null, postal_package_weight_kg?: number | null, buy_now_price?: PrivateProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductFragmentFragment_Product_original_price_Price | null, newPrice?: PrivateProductFragmentFragment_Product_newPrice_Price | null, image?: PrivateProductFragmentFragment_Product_image_Image | null, images: Array<PrivateProductFragmentFragment_Product_images_Image>, address?: PrivateProductFragmentFragment_Product_address_Address | null, auction?: PrivateProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: PrivateProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: PrivateProductFragmentFragment_Product_merchant_Merchant, merchant_fee?: PrivateProductFragmentFragment_Product_merchant_fee_Fee | null, favorite?: PrivateProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PrivateProductFragmentFragment_Product_categories_Category>, breadcrumbs: Array<PrivateProductFragmentFragment_Product_breadcrumbs_Category>, brand?: PrivateProductFragmentFragment_Product_brand_Brand | null, attributes: Array<PrivateProductFragmentFragment_Product_attributes>, shipping_cost: PrivateProductFragmentFragment_Product_shipping_cost_Price, curation_feedback?: PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback | null };

export type PrivateProductOverviewFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PrivateProductOverviewFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string, x_small_url: string };

export type PrivateProductOverviewFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, x_small_url: string };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, allow_buy_now: boolean, state: AuctionState, minimum_bid?: PrivateProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, buy_now_price?: PrivateProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PrivateProductOverviewFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type PrivateProductOverviewFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', title: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Color = { __typename?: 'Color' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Label = { __typename?: 'Label', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type PrivateProductOverviewFragmentFragment_Product_attributes = PrivateProductOverviewFragmentFragment_Product_attributes_AdditionalInfo | PrivateProductOverviewFragmentFragment_Product_attributes_Artist | PrivateProductOverviewFragmentFragment_Product_attributes_Brand | PrivateProductOverviewFragmentFragment_Product_attributes_Color | PrivateProductOverviewFragmentFragment_Product_attributes_Designer | PrivateProductOverviewFragmentFragment_Product_attributes_Label | PrivateProductOverviewFragmentFragment_Product_attributes_Material | PrivateProductOverviewFragmentFragment_Product_attributes_Style | PrivateProductOverviewFragmentFragment_Product_attributes_Subject | PrivateProductOverviewFragmentFragment_Product_attributes_UsageSign;

export type PrivateProductOverviewFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string };

export type PrivateProductOverviewFragmentFragment = { __typename?: 'Product', id: any, title: string, slug: string, quality: ProductQuality, view_count: number, favorite_count: number, favorite?: PrivateProductOverviewFragmentFragment_Product_favorite_Favorite | null, image?: PrivateProductOverviewFragmentFragment_Product_image_Image | null, images: Array<PrivateProductOverviewFragmentFragment_Product_images_Image>, auction?: PrivateProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PrivateProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PrivateProductOverviewFragmentFragment_Product_attributes>, categories: Array<PrivateProductOverviewFragmentFragment_Product_categories_Category> };

export type ProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_brand_Brand = { __typename?: 'Brand', id: any };

export type ProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type ProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, minimum_bid?: ProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: ProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: ProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type ProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type ProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: ProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type ProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type ProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, created: any, image?: ProductFragmentFragment_Product_merchant_Merchant_image_Image | null };

export type ProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type ProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type ProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type ProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type ProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type ProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type ProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type ProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes = ProductFragmentFragment_Product_attributes_AdditionalInfo | ProductFragmentFragment_Product_attributes_Artist | ProductFragmentFragment_Product_attributes_Brand | ProductFragmentFragment_Product_attributes_Color | ProductFragmentFragment_Product_attributes_Designer | ProductFragmentFragment_Product_attributes_Label | ProductFragmentFragment_Product_attributes_Material | ProductFragmentFragment_Product_attributes_Style | ProductFragmentFragment_Product_attributes_Subject | ProductFragmentFragment_Product_attributes_UsageSign;

export type ProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string, platform: ArPlatform };

export type ProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string, platform: ArPlatform };

export type ProductFragmentFragment_Product_product_type_ProductType = { __typename?: 'ProductType', android_arobject?: ProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject | null, ios_arobject?: ProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, view_count: number, auto_discount?: boolean | null, favorite_count: number, is_in_showroom?: boolean | null, showroom_zone?: string | null, quality: ProductQuality, brand_suggestion?: string | null, artist_suggestion?: string | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: string | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type ImageFragmentFragment = { __typename?: 'Image', id: any, url: string, position: number, width?: number | null, height?: number | null };

export type PublicProductFragmentFragment_Product_showroom_Showroom_address_ShowroomAddress = { __typename?: 'ShowroomAddress', id: any, city?: string | null };

export type PublicProductFragmentFragment_Product_showroom_Showroom = { __typename?: 'Showroom', id: any, image: string, info: string, openingHours: string, googleMapsUrl?: string | null, address?: PublicProductFragmentFragment_Product_showroom_Showroom_address_ShowroomAddress | null };

export type PublicProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType = { __typename?: 'ProductType', android_arobject?: PublicProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject | null };

export type PublicProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, position: number, width?: number | null, height?: number | null };

export type PublicProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, created?: any | null, updated?: any | null, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, coming_soon_time?: any | null, minimum_bid?: PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert = { __typename?: 'ComingSoonAlert', id: any, created: any };

export type PublicProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PublicProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod = { __typename?: 'ExternalShippingMethod', title: string, price: PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod_price_Price };

export type PublicProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type PublicProductFragmentFragment_Product_merchant_Merchant_avatar_image_Image = { __typename?: 'Image', url: string, id: any };

export type PublicProductFragmentFragment_Product_merchant_Merchant_addresses_Address = { __typename?: 'Address', id: any, country: string };

export type PublicProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, rating?: number | null, reviewsCount?: number | null, number_of_ads?: number | null, number_of_sells?: number | null, created: any, type: MerchantType, vacationModeEnabledAt?: any | null, image?: PublicProductFragmentFragment_Product_merchant_Merchant_image_Image | null, avatar_image?: PublicProductFragmentFragment_Product_merchant_Merchant_avatar_image_Image | null, addresses: Array<PublicProductFragmentFragment_Product_merchant_Merchant_addresses_Address> };

export type PublicProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PublicProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null };

export type PublicProductFragmentFragment_Product_shipping_cost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice = { __typename?: 'ShippingMethodCountryPrice', country: string, price: PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price };

export type PublicProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PublicProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type PublicProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PublicProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes = PublicProductFragmentFragment_Product_attributes_AdditionalInfo | PublicProductFragmentFragment_Product_attributes_Artist | PublicProductFragmentFragment_Product_attributes_Brand | PublicProductFragmentFragment_Product_attributes_Color | PublicProductFragmentFragment_Product_attributes_Designer | PublicProductFragmentFragment_Product_attributes_Label | PublicProductFragmentFragment_Product_attributes_Material | PublicProductFragmentFragment_Product_attributes_Style | PublicProductFragmentFragment_Product_attributes_Subject | PublicProductFragmentFragment_Product_attributes_UsageSign;

export type PublicProductFragmentFragment = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, description?: string | null, usage_signs_description?: string | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, cleaningServiceAvailable: boolean, favorite_count: number, isOwner?: boolean | null, isDesignerItem?: boolean | null, is_in_showroom?: boolean | null, showroom_zone?: string | null, quality: ProductQuality, two_man_delivery?: boolean | null, ground_floor_only_delivery?: boolean | null, created?: any | null, updated?: any | null, brand_suggestion?: string | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, original_title: string, original_description?: string | null, original_usage_signs_description?: string | null, showroom?: PublicProductFragmentFragment_Product_showroom_Showroom | null, newPrice?: PublicProductFragmentFragment_Product_newPrice_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductFragmentFragment_Product_original_price_Price | null, android_arobject?: PublicProductFragmentFragment_Product_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_ios_arobject_ARObject | null, product_type?: PublicProductFragmentFragment_Product_product_type_ProductType | null, images: Array<PublicProductFragmentFragment_Product_images_Image>, address?: PublicProductFragmentFragment_Product_address_Address | null, auction?: PublicProductFragmentFragment_Product_auction_Auction | null, coming_soon_alert?: PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert | null, custom_shipping_cost?: PublicProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod | null, externalShippingMethods: Array<PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod>, merchant: PublicProductFragmentFragment_Product_merchant_Merchant, favorite?: PublicProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PublicProductFragmentFragment_Product_categories_Category>, shipping_cost: PublicProductFragmentFragment_Product_shipping_cost_Price, shipping_method_prices: Array<PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice>, attributes: Array<PublicProductFragmentFragment_Product_attributes> };

export type ImageOverviewFragmentFragment = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PublicProductOverviewFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PublicProductOverviewFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, allow_buy_now: boolean, state: AuctionState, sold_at?: PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price | null, minimum_bid?: PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PublicProductOverviewFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type PublicProductOverviewFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type PublicProductOverviewFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PublicProductOverviewFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes = PublicProductOverviewFragmentFragment_Product_attributes_AdditionalInfo | PublicProductOverviewFragmentFragment_Product_attributes_Artist | PublicProductOverviewFragmentFragment_Product_attributes_Brand | PublicProductOverviewFragmentFragment_Product_attributes_Color | PublicProductOverviewFragmentFragment_Product_attributes_Designer | PublicProductOverviewFragmentFragment_Product_attributes_Label | PublicProductOverviewFragmentFragment_Product_attributes_Material | PublicProductOverviewFragmentFragment_Product_attributes_Style | PublicProductOverviewFragmentFragment_Product_attributes_Subject | PublicProductOverviewFragmentFragment_Product_attributes_UsageSign;

export type PublicProductOverviewFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null };

export type PublicProductOverviewFragmentFragment = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, quality: ProductQuality, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type ShippingOptionFragmentFragment = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type WuunderShipmentFragmentFragment = { __typename?: 'WuunderShipment', id: any, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: WuunderShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant_image_Image = { __typename?: 'Image', url: string };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant = { __typename?: 'Merchant', id: any, email?: string | null, type: MerchantType, expert_seller?: boolean | null, name: string, image?: ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant_image_Image | null };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', merchant: ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant };

export type ListThreadFragmentFragment_Thread_item_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState };

export type ListThreadFragmentFragment_Thread_item_Product_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type ListThreadFragmentFragment_Thread_item_Merchant = { __typename?: 'Merchant' };

export type ListThreadFragmentFragment_Thread_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, auction?: ListThreadFragmentFragment_Thread_item_Product_auction_Auction | null, image?: ListThreadFragmentFragment_Thread_item_Product_image_Image | null };

export type ListThreadFragmentFragment_Thread_item = ListThreadFragmentFragment_Thread_item_Merchant | ListThreadFragmentFragment_Thread_item_Product;

export type ListThreadFragmentFragment = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type MessageFragment_Message_sender_Member = { __typename?: 'Member', id: any, email: string };

export type MessageFragment_Message_item_Bid_amount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MessageFragment_Message_item_Bid_order_Order = { __typename?: 'Order', orderState: OrderState };

export type MessageFragment_Message_item_Order_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', slug: string };

export type MessageFragment_Message_item_Order_address_OrderAddress = { __typename?: 'OrderAddress', name: string, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type MessageFragment_Message_item_Order_wuunderShipment_WuunderShipment = { __typename?: 'WuunderShipment', id: any, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: WuunderShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null };

export type MessageFragment_Message_item_Audio = { __typename?: 'Audio' };

export type MessageFragment_Message_item_Bid = { __typename?: 'Bid', id: any, state: BidState, is_counter: boolean, buyerId: any, canceledFromState?: BidCanceledFromState | null, amount: MessageFragment_Message_item_Bid_amount_Price, order?: MessageFragment_Message_item_Bid_order_Order | null };

export type MessageFragment_Message_item_Document = { __typename?: 'Document' };

export type MessageFragment_Message_item_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type MessageFragment_Message_item_Order = { __typename?: 'Order', id: any, delivery_method: DeliveryMethod, currency: Currency, total_incl_vat: number, discount_incl_vat: number, fee_incl_vat: number, shipping_incl_vat: number, subtotal_incl_vat: number, created?: any | null, orderState: OrderState, externalDelivery?: boolean | null, shipping_method?: MessageFragment_Message_item_Order_shipping_method_ShippingMethod | null, address?: MessageFragment_Message_item_Order_address_OrderAddress | null, wuunderShipment?: MessageFragment_Message_item_Order_wuunderShipment_WuunderShipment | null };

export type MessageFragment_Message_item_Product = { __typename?: 'Product' };

export type MessageFragment_Message_item_Shipment = { __typename?: 'Shipment' };

export type MessageFragment_Message_item_Video = { __typename?: 'Video' };

export type MessageFragment_Message_item = MessageFragment_Message_item_Audio | MessageFragment_Message_item_Bid | MessageFragment_Message_item_Document | MessageFragment_Message_item_Image | MessageFragment_Message_item_Order | MessageFragment_Message_item_Product | MessageFragment_Message_item_Shipment | MessageFragment_Message_item_Video;

export type MessageFragment = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, flaggedReasons?: Array<string> | null, originalBody?: string | null, sender: MessageFragment_Message_sender_Member, item?: MessageFragment_Message_item | null };

export type AcceptTosMutation_acceptTos_Merchant = { __typename?: 'Merchant', id: any, pendingActions: Array<PendingAction> };

export type AcceptTosMutation_Mutation = { __typename?: 'Mutation', acceptTos: AcceptTosMutation_acceptTos_Merchant };


export type AcceptTosMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTosMutation = AcceptTosMutation_Mutation;

export type AddProductToCartMutation_addProductToCart_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, isInCart: boolean, view_count: number, favorite_count: number, quality: ProductQuality, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type AddProductToCartMutation_addProductToCart_Cart_items_CartItem = { __typename?: 'CartItem', product: AddProductToCartMutation_addProductToCart_Cart_items_CartItem_product_Product };

export type AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals = { __typename?: 'CartTotals', subtotal?: AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals_subtotal_Price | null };

export type AddProductToCartMutation_addProductToCart_Cart = { __typename?: 'Cart', id: any, items: Array<AddProductToCartMutation_addProductToCart_Cart_items_CartItem>, totals2?: AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals | null };

export type AddProductToCartMutation_Mutation = { __typename?: 'Mutation', addProductToCart: AddProductToCartMutation_addProductToCart_Cart };


export type AddProductToCartMutationVariables = Exact<{
  product_id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AddProductToCartMutation = AddProductToCartMutation_Mutation;

export type AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, isInCart: boolean, view_count: number, favorite_count: number, quality: ProductQuality, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem = { __typename?: 'CartItem', product: AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem_product_Product };

export type AddProductsToCartMutation_addProductsToCart_Cart = { __typename?: 'Cart', id: any, items: Array<AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem> };

export type AddProductsToCartMutation_Mutation = { __typename?: 'Mutation', addProductsToCart: AddProductsToCartMutation_addProductsToCart_Cart };


export type AddProductsToCartMutationVariables = Exact<{
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AddProductsToCartMutation = AddProductsToCartMutation_Mutation;

export type AddReferralCodeMutation_addReferralCode_AddReferralCodeResult = { __typename?: 'AddReferralCodeResult', success: boolean };

export type AddReferralCodeMutation_Mutation = { __typename?: 'Mutation', addReferralCode: AddReferralCodeMutation_addReferralCode_AddReferralCodeResult };


export type AddReferralCodeMutationVariables = Exact<{
  referral_code: Scalars['String']['input'];
}>;


export type AddReferralCodeMutation = AddReferralCodeMutation_Mutation;

export type AddToBoostCartMutation_addToBoostCart_BoostCart = { __typename?: 'BoostCart', products: Array<BoostCartFragmentFragment_BoostCart_products_Product>, total: BoostCartFragmentFragment_BoostCart_total_Price };

export type AddToBoostCartMutation_Mutation = { __typename?: 'Mutation', addToBoostCart: AddToBoostCartMutation_addToBoostCart_BoostCart };


export type AddToBoostCartMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  clearBeforeAdding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddToBoostCartMutation = AddToBoostCartMutation_Mutation;

export type AddToCartMutation_addToCart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals?: CartFragmentFragment_Cart_totals_OrderTotals | null, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type AddToCartMutation_Mutation = { __typename?: 'Mutation', addToCart: AddToCartMutation_addToCart_Cart };


export type AddToCartMutationVariables = Exact<{
  type: CartItemType;
  object_id: Scalars['UUID']['input'];
  service_type?: InputMaybe<ServiceType>;
  lang?: InputMaybe<Language>;
}>;


export type AddToCartMutation = AddToCartMutation_Mutation;

export type AnalyzeProductImageMutation_analyzeProductImage_AnalyzeProductImageResult = { __typename?: 'AnalyzeProductImageResult', imageId: string };

export type AnalyzeProductImageMutation_Mutation = { __typename?: 'Mutation', analyzeProductImage?: AnalyzeProductImageMutation_analyzeProductImage_AnalyzeProductImageResult | null };


export type AnalyzeProductImageMutationVariables = Exact<{
  input: AnalyzeProductImageInput;
}>;


export type AnalyzeProductImageMutation = AnalyzeProductImageMutation_Mutation;

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_category_Category = { __typename?: 'Category', id: any, title: string };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_brand_Brand = { __typename?: 'Brand', id: any, title: string };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_colors_Color = { __typename?: 'Color', id: any, title: string };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_materials_Material = { __typename?: 'Material', id: any, title: string };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_usageSigns_UsageSign = { __typename?: 'UsageSign', id: any, title: string };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult = { __typename?: 'AnalyzeProductTitleAndImagesResult', description?: string | null, brandSuggestion?: string | null, quality?: ProductQuality | null, category?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_category_Category | null, brand?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_brand_Brand | null, colors: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_colors_Color>, materials: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_materials_Material>, usageSigns: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_usageSigns_UsageSign> };

export type AnalyzeMutation_Mutation = { __typename?: 'Mutation', analyzeProductTitleAndImages?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult | null };


export type AnalyzeMutationVariables = Exact<{
  input: AnalyzeProductTitleAndImagesInput;
  lang?: InputMaybe<Language>;
}>;


export type AnalyzeMutation = AnalyzeMutation_Mutation;

export type AskProductQuestionMutation_askProductQuestion_Thread = { __typename?: 'Thread', id: any };

export type AskProductQuestionMutation_Mutation = { __typename?: 'Mutation', askProductQuestion: AskProductQuestionMutation_askProductQuestion_Thread };


export type AskProductQuestionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  body: Scalars['String']['input'];
}>;


export type AskProductQuestionMutation = AskProductQuestionMutation_Mutation;

export type AcceptBrengerProposedDateMutation_acceptBrengerProposedDate_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any, state: BrengerProposedDateState, date: any };

export type AcceptBrengerProposedDateMutation_Mutation = { __typename?: 'Mutation', acceptBrengerProposedDate: AcceptBrengerProposedDateMutation_acceptBrengerProposedDate_BrengerProposedDate };


export type AcceptBrengerProposedDateMutationVariables = Exact<{
  dateId: Scalars['UUID']['input'];
}>;


export type AcceptBrengerProposedDateMutation = AcceptBrengerProposedDateMutation_Mutation;

export type ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates_proposedDates_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any };

export type ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates = { __typename?: 'BrengerProposedDates', proposedDates: Array<ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates_proposedDates_BrengerProposedDate> };

export type ProposeBrengerAppointmentDatesMutation_Mutation = { __typename?: 'Mutation', proposeBrengerAppointmentDates: ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates };


export type ProposeBrengerAppointmentDatesMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  dates: Array<Scalars['Date']['input']> | Scalars['Date']['input'];
}>;


export type ProposeBrengerAppointmentDatesMutation = ProposeBrengerAppointmentDatesMutation_Mutation;

export type AcceptBidMutation_acceptBid_Bid = { __typename?: 'Bid', id: any };

export type AcceptBidMutation_Mutation = { __typename?: 'Mutation', acceptBid: AcceptBidMutation_acceptBid_Bid };


export type AcceptBidMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AcceptBidMutation = AcceptBidMutation_Mutation;

export type CancelBidMutation_cancelBid_Bid = { __typename?: 'Bid', id: any, state: BidState };

export type CancelBidMutation_Mutation = { __typename?: 'Mutation', cancelBid?: CancelBidMutation_cancelBid_Bid | null };


export type CancelBidMutationVariables = Exact<{
  input: CancelBidInput;
}>;


export type CancelBidMutation = CancelBidMutation_Mutation;

export type CreateBidMutation_createBid_Bid_auction_Auction_product_Product_brand_Brand = { __typename?: 'Brand', title: string };

export type CreateBidMutation_createBid_Bid_auction_Auction_product_Product = { __typename?: 'Product', id: any, title: string, brand?: CreateBidMutation_createBid_Bid_auction_Auction_product_Product_brand_Brand | null };

export type CreateBidMutation_createBid_Bid_auction_Auction = { __typename?: 'Auction', product: CreateBidMutation_createBid_Bid_auction_Auction_product_Product };

export type CreateBidMutation_createBid_Bid_thread_Thread = { __typename?: 'Thread', id: any };

export type CreateBidMutation_createBid_Bid = { __typename?: 'Bid', id: any, auction: CreateBidMutation_createBid_Bid_auction_Auction, thread?: CreateBidMutation_createBid_Bid_thread_Thread | null };

export type CreateBidMutation_Mutation = { __typename?: 'Mutation', createBid: CreateBidMutation_createBid_Bid };


export type CreateBidMutationVariables = Exact<{
  auctionId: Scalars['UUID']['input'];
  amount: Scalars['Float']['input'];
}>;


export type CreateBidMutation = CreateBidMutation_Mutation;

export type CreateCounterBidMutation_createCounterBid_Bid = { __typename?: 'Bid', id: any };

export type CreateCounterBidMutation_Mutation = { __typename?: 'Mutation', createCounterBid: CreateCounterBidMutation_createCounterBid_Bid };


export type CreateCounterBidMutationVariables = Exact<{
  auctionId: Scalars['UUID']['input'];
  amount: Scalars['Float']['input'];
  buyerId: Scalars['UUID']['input'];
}>;


export type CreateCounterBidMutation = CreateCounterBidMutation_Mutation;

export type RejectBidMutation_rejectBid_Bid = { __typename?: 'Bid', id: any };

export type RejectBidMutation_Mutation = { __typename?: 'Mutation', rejectBid: RejectBidMutation_rejectBid_Bid };


export type RejectBidMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RejectBidMutation = RejectBidMutation_Mutation;

export type WithdrawProductMutation_withdrawProduct_Product = { __typename?: 'Product', id: any };

export type WithdrawProductMutation_Mutation = { __typename?: 'Mutation', withdrawProduct: WithdrawProductMutation_withdrawProduct_Product };


export type WithdrawProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<ProductWithdrawReason>;
}>;


export type WithdrawProductMutation = WithdrawProductMutation_Mutation;

export type CreateMessageMutation_createMessage_Message = { __typename?: 'Message', id: any, body?: string | null, updated?: any | null };

export type CreateMessageMutation_Mutation = { __typename?: 'Mutation', createMessage?: CreateMessageMutation_createMessage_Message | null };


export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = CreateMessageMutation_Mutation;

export type CreateThreadMutation_createThread_Thread = { __typename?: 'Thread', id: any };

export type CreateThreadMutation_Mutation = { __typename?: 'Mutation', createThread: CreateThreadMutation_createThread_Thread };


export type CreateThreadMutationVariables = Exact<{
  input: CreateThreadInput;
}>;


export type CreateThreadMutation = CreateThreadMutation_Mutation;

export type DeleteThreadMutation_Mutation = { __typename?: 'Mutation', deleteThread: boolean };


export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type DeleteThreadMutation = DeleteThreadMutation_Mutation;

export type DisableThreadTranslationMutation_disableThreadTranslation_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null };

export type DisableThreadTranslationMutation_disableThreadTranslation_Thread = { __typename?: 'Thread', id: any, subscribers: Array<DisableThreadTranslationMutation_disableThreadTranslation_Thread_subscribers_Subscriber> };

export type DisableThreadTranslationMutation_Mutation = { __typename?: 'Mutation', disableThreadTranslation: DisableThreadTranslationMutation_disableThreadTranslation_Thread };


export type DisableThreadTranslationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DisableThreadTranslationMutation = DisableThreadTranslationMutation_Mutation;

export type ReadThreadMutation_Mutation = { __typename?: 'Mutation', readThread: boolean };


export type ReadThreadMutationVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type ReadThreadMutation = ReadThreadMutation_Mutation;

export type TranslateThreadMutation_translateThread_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null };

export type TranslateThreadMutation_translateThread_Thread = { __typename?: 'Thread', id: any, subscribers: Array<TranslateThreadMutation_translateThread_Thread_subscribers_Subscriber> };

export type TranslateThreadMutation_Mutation = { __typename?: 'Mutation', translateThread: TranslateThreadMutation_translateThread_Thread };


export type TranslateThreadMutationVariables = Exact<{
  input: TranslateThreadInput;
}>;


export type TranslateThreadMutation = TranslateThreadMutation_Mutation;

export type ClearCartMutation_clearCart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals?: CartFragmentFragment_Cart_totals_OrderTotals | null, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type ClearCartMutation_Mutation = { __typename?: 'Mutation', clearCart: ClearCartMutation_clearCart_Cart };


export type ClearCartMutationVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type ClearCartMutation = ClearCartMutation_Mutation;

export type CreateAbuseReportMutation_Mutation = { __typename?: 'Mutation', createAbuseReport: boolean };


export type CreateAbuseReportMutationVariables = Exact<{
  input: AbuseReportInput;
}>;


export type CreateAbuseReportMutation = CreateAbuseReportMutation_Mutation;

export type CreateAddressMutation_createAddress_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type CreateAddressMutation_Mutation = { __typename?: 'Mutation', createAddress: CreateAddressMutation_createAddress_Address };


export type CreateAddressMutationVariables = Exact<{
  merchant_id: Scalars['UUID']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
}>;


export type CreateAddressMutation = CreateAddressMutation_Mutation;

export type CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert_product_Product = { __typename?: 'Product', id: any };

export type CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert = { __typename?: 'ComingSoonAlert', id: any, created: any, product: CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert_product_Product };

export type CreateComingSoonAlertMutation_Mutation = { __typename?: 'Mutation', createComingSoonAlert: CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert };


export type CreateComingSoonAlertMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CreateComingSoonAlertMutation = CreateComingSoonAlertMutation_Mutation;

export type CreateFavoriteMutation_createFavorite_Favorite_item_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type CreateFavoriteMutation_createFavorite_Favorite_item_Merchant = { __typename?: 'Merchant' };

export type CreateFavoriteMutation_createFavorite_Favorite_item_Product = { __typename?: 'Product', id: any, favorite?: CreateFavoriteMutation_createFavorite_Favorite_item_Product_favorite_Favorite | null };

export type CreateFavoriteMutation_createFavorite_Favorite_item = CreateFavoriteMutation_createFavorite_Favorite_item_Merchant | CreateFavoriteMutation_createFavorite_Favorite_item_Product;

export type CreateFavoriteMutation_createFavorite_Favorite = { __typename?: 'Favorite', id: any, created: any, item: CreateFavoriteMutation_createFavorite_Favorite_item };

export type CreateFavoriteMutation_Mutation = { __typename?: 'Mutation', createFavorite: CreateFavoriteMutation_createFavorite_Favorite };


export type CreateFavoriteMutationVariables = Exact<{
  input: FavoriteInput;
}>;


export type CreateFavoriteMutation = CreateFavoriteMutation_Mutation;

export type CreateOrUpdateBankAccountMutation_createOrUpdateBankAccount_ExternalBankAccount = { __typename?: 'ExternalBankAccount', id: string, currency: Currency, country: string, account_holder_name?: string | null, bank_name: string, last4: string };

export type CreateOrUpdateBankAccountMutation_Mutation = { __typename?: 'Mutation', createOrUpdateBankAccount: CreateOrUpdateBankAccountMutation_createOrUpdateBankAccount_ExternalBankAccount };


export type CreateOrUpdateBankAccountMutationVariables = Exact<{
  input: ExternalBankAccountInput;
}>;


export type CreateOrUpdateBankAccountMutation = CreateOrUpdateBankAccountMutation_Mutation;

export type CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup_payment_OrderGroupPayment = { __typename?: 'OrderGroupPayment', paymentIntentId: string, paymentClientSecret: string };

export type CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup = { __typename?: 'OrderGroup', id: any, paymentMethod: PaymentMethod, payment?: CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup_payment_OrderGroupPayment | null };

export type CreateOrderGroupForCartMutation_Mutation = { __typename?: 'Mutation', createOrderGroupForCart: CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup };


export type CreateOrderGroupForCartMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrderGroupForCartMutation = CreateOrderGroupForCartMutation_Mutation;

export type CreatePaymentForBoostMutation_createPaymentForBoost_BoostPayment = { __typename?: 'BoostPayment', paymentClientSecret: string, paymentIntentId: string };

export type CreatePaymentForBoostMutation_Mutation = { __typename?: 'Mutation', createPaymentForBoost: CreatePaymentForBoostMutation_createPaymentForBoost_BoostPayment };


export type CreatePaymentForBoostMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type CreatePaymentForBoostMutation = CreatePaymentForBoostMutation_Mutation;

export type CreateProductMutation_createProduct_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, view_count: number, auto_discount?: boolean | null, favorite_count: number, is_in_showroom?: boolean | null, showroom_zone?: string | null, quality: ProductQuality, brand_suggestion?: string | null, artist_suggestion?: string | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: string | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type CreateProductMutation_Mutation = { __typename?: 'Mutation', createProduct: CreateProductMutation_createProduct_Product };


export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type CreateProductMutation = CreateProductMutation_Mutation;

export type CreateSavedSearchMutation_createSavedSearch_SavedSearch = { __typename?: 'SavedSearch', id: any };

export type CreateSavedSearchMutation_Mutation = { __typename?: 'Mutation', createSavedSearch: CreateSavedSearchMutation_createSavedSearch_SavedSearch };


export type CreateSavedSearchMutationVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  query?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSavedSearchMutation = CreateSavedSearchMutation_Mutation;

export type CreateStripeAccountLinkMutation_createStripeAccountLink_StripeAccountLink = { __typename?: 'StripeAccountLink', url: string };

export type CreateStripeAccountLinkMutation_Mutation = { __typename?: 'Mutation', createStripeAccountLink: CreateStripeAccountLinkMutation_createStripeAccountLink_StripeAccountLink };


export type CreateStripeAccountLinkMutationVariables = Exact<{
  input: StripeAccountLinkInput;
}>;


export type CreateStripeAccountLinkMutation = CreateStripeAccountLinkMutation_Mutation;

export type ForgotPasswordMutation_forgotPassword_ForgotPasswordResponse = { __typename?: 'ForgotPasswordResponse', message: string, status: ForgotPasswordResult };

export type ForgotPasswordMutation_Mutation = { __typename?: 'Mutation', forgotPassword: ForgotPasswordMutation_forgotPassword_ForgotPasswordResponse };


export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = ForgotPasswordMutation_Mutation;

export type GenerateIterableJwtMutation_generateIterableJwt_GenerateIterableJwtResponse = { __typename?: 'GenerateIterableJwtResponse', token: string };

export type GenerateIterableJwtMutation_Mutation = { __typename?: 'Mutation', generateIterableJwt: GenerateIterableJwtMutation_generateIterableJwt_GenerateIterableJwtResponse };


export type GenerateIterableJwtMutationVariables = Exact<{
  input?: InputMaybe<GenerateIterableJwtInput>;
}>;


export type GenerateIterableJwtMutation = GenerateIterableJwtMutation_Mutation;

export type LoginMutation_login_LoginResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null };

export type LoginMutation_login_LoginResponse_user_Member = { __typename?: 'Member', id: any, locale: Locale, merchants: Array<LoginMutation_login_LoginResponse_user_Member_merchants_Merchant> };

export type LoginMutation_login_LoginResponse = { __typename?: 'LoginResponse', access_token: string, user: LoginMutation_login_LoginResponse_user_Member };

export type LoginMutation_Mutation = { __typename?: 'Mutation', login: LoginMutation_login_LoginResponse };


export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = LoginMutation_Mutation;

export type LoginWithAppleMutation_loginWithApple_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithAppleMutation_Mutation = { __typename?: 'Mutation', loginWithApple: LoginWithAppleMutation_loginWithApple_LoginResponse };


export type LoginWithAppleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithAppleMutation = LoginWithAppleMutation_Mutation;

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null };

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member = { __typename?: 'Member', id: any, locale: Locale, merchants: Array<LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member_merchants_Merchant> };

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse = { __typename?: 'EmailTokenLoginResponse', token: string, redirectUrl: string, user: LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member };

export type LoginWithEmailTokenMutation_Mutation = { __typename?: 'Mutation', loginWithEmailToken: LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse };


export type LoginWithEmailTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  cookie: Scalars['String']['input'];
}>;


export type LoginWithEmailTokenMutation = LoginWithEmailTokenMutation_Mutation;

export type LoginWithFacebookMutation_loginWithFacebook_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithFacebookMutation_Mutation = { __typename?: 'Mutation', loginWithFacebook: LoginWithFacebookMutation_loginWithFacebook_LoginResponse };


export type LoginWithFacebookMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithFacebookMutation = LoginWithFacebookMutation_Mutation;

export type LoginWithGoogleMutation_loginWithGoogle_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithGoogleMutation_Mutation = { __typename?: 'Mutation', loginWithGoogle: LoginWithGoogleMutation_loginWithGoogle_LoginResponse };


export type LoginWithGoogleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithGoogleMutation = LoginWithGoogleMutation_Mutation;

export type RequestVacationModeDisableMutation_requestVacationModeDisable_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type RequestVacationModeDisableMutation_Mutation = { __typename?: 'Mutation', requestVacationModeDisable: RequestVacationModeDisableMutation_requestVacationModeDisable_Merchant };


export type RequestVacationModeDisableMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestVacationModeDisableMutation = RequestVacationModeDisableMutation_Mutation;

export type RequestVacationModeEnableMutation_requestVacationModeEnable_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type RequestVacationModeEnableMutation_Mutation = { __typename?: 'Mutation', requestVacationModeEnable: RequestVacationModeEnableMutation_requestVacationModeEnable_Merchant };


export type RequestVacationModeEnableMutationVariables = Exact<{
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type RequestVacationModeEnableMutation = RequestVacationModeEnableMutation_Mutation;

export type UpdateVacationModeEndDateMutation_updateVacationModeEndDate_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type UpdateVacationModeEndDateMutation_Mutation = { __typename?: 'Mutation', updateVacationModeEndDate: UpdateVacationModeEndDateMutation_updateVacationModeEndDate_Merchant };


export type UpdateVacationModeEndDateMutationVariables = Exact<{
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateVacationModeEndDateMutation = UpdateVacationModeEndDateMutation_Mutation;

export type ReactivateProductMutation_reactivateProduct_Product = { __typename?: 'Product', id: any, status: ProductStatus };

export type ReactivateProductMutation_Mutation = { __typename?: 'Mutation', reactivateProduct: ReactivateProductMutation_reactivateProduct_Product };


export type ReactivateProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReactivateProductMutation = ReactivateProductMutation_Mutation;

export type RemoveAddressMutation_Mutation = { __typename?: 'Mutation', removeAddress: boolean };


export type RemoveAddressMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveAddressMutation = RemoveAddressMutation_Mutation;

export type RemoveCartItemMutation_removeCartItem_CartItem_product_Product = { __typename?: 'Product', isInCart: boolean };

export type RemoveCartItemMutation_removeCartItem_CartItem = { __typename?: 'CartItem', id: any, product: RemoveCartItemMutation_removeCartItem_CartItem_product_Product };

export type RemoveCartItemMutation_Mutation = { __typename?: 'Mutation', removeCartItem: RemoveCartItemMutation_removeCartItem_CartItem };


export type RemoveCartItemMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveCartItemMutation = RemoveCartItemMutation_Mutation;

export type RemoveComingSoonAlertMutation_Mutation = { __typename?: 'Mutation', removeComingSoonAlert: boolean };


export type RemoveComingSoonAlertMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveComingSoonAlertMutation = RemoveComingSoonAlertMutation_Mutation;

export type RemoveFavoriteProductMutation_Mutation = { __typename?: 'Mutation', removeFavorite: boolean };


export type RemoveFavoriteProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveFavoriteProductMutation = RemoveFavoriteProductMutation_Mutation;

export type RemoveSavedSearchMutation_Mutation = { __typename?: 'Mutation', removeSavedSearch: boolean };


export type RemoveSavedSearchMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveSavedSearchMutation = RemoveSavedSearchMutation_Mutation;

export type RequestAccountDeletionMutation_requestAccountDeletion_RequestAccountDeletionResponse = { __typename?: 'RequestAccountDeletionResponse', requestedDeletionAt: any, scheduledDeletionAt: any };

export type RequestAccountDeletionMutation_Mutation = { __typename?: 'Mutation', requestAccountDeletion: RequestAccountDeletionMutation_requestAccountDeletion_RequestAccountDeletionResponse };


export type RequestAccountDeletionMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestAccountDeletionMutation = RequestAccountDeletionMutation_Mutation;

export type RequestEmailTokenMutation_Mutation = { __typename?: 'Mutation', requestEmailToken: string };


export type RequestEmailTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type RequestEmailTokenMutation = RequestEmailTokenMutation_Mutation;

export type RequestPhoneUpdateOtpMutation_requestPhoneUpdateOTP_RequestPhoneUpdateOTPResponse = { __typename?: 'RequestPhoneUpdateOTPResponse', success: boolean, message: string, retryAfter: number };

export type RequestPhoneUpdateOtpMutation_Mutation = { __typename?: 'Mutation', requestPhoneUpdateOTP: RequestPhoneUpdateOtpMutation_requestPhoneUpdateOTP_RequestPhoneUpdateOTPResponse };


export type RequestPhoneUpdateOtpMutationVariables = Exact<{
  input: RequestPhoneUpdateOtpInput;
}>;


export type RequestPhoneUpdateOtpMutation = RequestPhoneUpdateOtpMutation_Mutation;

export type CreateFeedbackMutation_createFeedback_Order = { __typename?: 'Order', id: any, state: OrderState, disputeReason?: string | null };

export type CreateFeedbackMutation_Mutation = { __typename?: 'Mutation', createFeedback: CreateFeedbackMutation_createFeedback_Order };


export type CreateFeedbackMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  received: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  disputeReason?: InputMaybe<DisputeReason>;
}>;


export type CreateFeedbackMutation = CreateFeedbackMutation_Mutation;

export type SendOtpMutation_sendOtp_SendOtpResponse = { __typename?: 'SendOtpResponse', message: string, success: boolean };

export type SendOtpMutation_Mutation = { __typename?: 'Mutation', sendOtp: SendOtpMutation_sendOtp_SendOtpResponse };


export type SendOtpMutationVariables = Exact<{ [key: string]: never; }>;


export type SendOtpMutation = SendOtpMutation_Mutation;

export type SignupMutation_signup_SignupResponse = { __typename?: 'SignupResponse', access_token: string };

export type SignupMutation_Mutation = { __typename?: 'Mutation', signup: SignupMutation_signup_SignupResponse };


export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = SignupMutation_Mutation;

export type TranslateReviewsMutation_translateReviews_Review_reviewer_Merchant = { __typename?: 'Merchant', name: string };

export type TranslateReviewsMutation_translateReviews_Review = { __typename?: 'Review', id: any, review?: string | null, score?: number | null, created?: any | null, originalReview?: string | null, reviewer?: TranslateReviewsMutation_translateReviews_Review_reviewer_Merchant | null };

export type TranslateReviewsMutation_Mutation = { __typename?: 'Mutation', translateReviews?: Array<TranslateReviewsMutation_translateReviews_Review> | null };


export type TranslateReviewsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang: Language;
}>;


export type TranslateReviewsMutation = TranslateReviewsMutation_Mutation;

export type UpdateCartMutation_updateCart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals?: CartFragmentFragment_Cart_totals_OrderTotals | null, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type UpdateCartMutation_Mutation = { __typename?: 'Mutation', updateCart: UpdateCartMutation_updateCart_Cart };


export type UpdateCartMutationVariables = Exact<{
  payment_method?: InputMaybe<PaymentMethod>;
  delivery_method?: InputMaybe<DeliveryMethod>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  shipping_address_id?: InputMaybe<Scalars['UUID']['input']>;
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type UpdateCartMutation = UpdateCartMutation_Mutation;

export type UpdateCartItemMutation_updateCartItem_CartItem = { __typename?: 'CartItem', id: any };

export type UpdateCartItemMutation_Mutation = { __typename?: 'Mutation', updateCartItem: UpdateCartItemMutation_updateCartItem_CartItem };


export type UpdateCartItemMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  services?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type UpdateCartItemMutation = UpdateCartItemMutation_Mutation;

export type UpdateForgottenPasswordMutation_updateForgottenPassword_UpdateForgottenPasswordResponse = { __typename?: 'UpdateForgottenPasswordResponse', message: string, status: UpdateForgottenPasswordResult };

export type UpdateForgottenPasswordMutation_Mutation = { __typename?: 'Mutation', updateForgottenPassword: UpdateForgottenPasswordMutation_updateForgottenPassword_UpdateForgottenPasswordResponse };


export type UpdateForgottenPasswordMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  token: Scalars['String']['input'];
  new_password: Scalars['String']['input'];
  new_password_confirmation: Scalars['String']['input'];
}>;


export type UpdateForgottenPasswordMutation = UpdateForgottenPasswordMutation_Mutation;

export type UpdateMeMutation_updateMe_Member_merchants_Merchant = { __typename?: 'Merchant', type: MerchantType, name: string, phone?: string | null };

export type UpdateMeMutation_updateMe_Member = { __typename?: 'Member', id: any, email: string, given_name: string, family_name: string, dob?: any | null, locale: Locale, placeOfBirth?: string | null, countryOfBirth?: string | null, merchants: Array<UpdateMeMutation_updateMe_Member_merchants_Merchant> };

export type UpdateMeMutation_Mutation = { __typename?: 'Mutation', updateMe: UpdateMeMutation_updateMe_Member };


export type UpdateMeMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Locale>;
  type?: InputMaybe<MerchantType>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['UUID']['input']>;
  place_of_birth?: InputMaybe<Scalars['String']['input']>;
  country_of_birth?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMeMutation = UpdateMeMutation_Mutation;

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, phone?: string | null, verified?: boolean | null };

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member = { __typename?: 'Member', id: any, merchants: Array<UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member_merchants_Merchant> };

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse = { __typename?: 'UpdatePhoneWithOTPResponse', success: boolean, message: string, user: UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member };

export type UpdatePhoneWithOtpMutation_Mutation = { __typename?: 'Mutation', updatePhoneWithOTP: UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse };


export type UpdatePhoneWithOtpMutationVariables = Exact<{
  input: UpdatePhoneWithOtpInput;
}>;


export type UpdatePhoneWithOtpMutation = UpdatePhoneWithOtpMutation_Mutation;

export type UpdateProductMutation_updateProduct_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, view_count: number, auto_discount?: boolean | null, favorite_count: number, is_in_showroom?: boolean | null, showroom_zone?: string | null, quality: ProductQuality, brand_suggestion?: string | null, artist_suggestion?: string | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: string | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type UpdateProductMutation_Mutation = { __typename?: 'Mutation', updateProduct: UpdateProductMutation_updateProduct_Product };


export type UpdateProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = UpdateProductMutation_Mutation;

export type UpdateSavedSearchMutation_updateSavedSearch_SavedSearch = { __typename?: 'SavedSearch', id: any, enabled?: boolean | null };

export type UpdateSavedSearchMutation_Mutation = { __typename?: 'Mutation', updateSavedSearch: UpdateSavedSearchMutation_updateSavedSearch_SavedSearch };


export type UpdateSavedSearchMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateSavedSearchMutation = UpdateSavedSearchMutation_Mutation;

export type ValidateVoucherMutation_validateVoucher_ValidateVoucherInvalid = { __typename?: 'ValidateVoucherInvalid', invalid: boolean, invalid_reason: string };

export type ValidateVoucherMutation_validateVoucher_ValidateVoucherValid = { __typename?: 'ValidateVoucherValid', type: DiscountType, value: number };

export type ValidateVoucherMutation_validateVoucher = ValidateVoucherMutation_validateVoucher_ValidateVoucherInvalid | ValidateVoucherMutation_validateVoucher_ValidateVoucherValid;

export type ValidateVoucherMutation_Mutation = { __typename?: 'Mutation', validateVoucher: ValidateVoucherMutation_validateVoucher };


export type ValidateVoucherMutationVariables = Exact<{
  code: Scalars['String']['input'];
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ValidateVoucherMutation = ValidateVoucherMutation_Mutation;

export type VerifyOtpMutation_verifyOtp_VerifyOtpResponse = { __typename?: 'VerifyOtpResponse', message: string, success: boolean };

export type VerifyOtpMutation_Mutation = { __typename?: 'Mutation', verifyOtp: VerifyOtpMutation_verifyOtp_VerifyOtpResponse };


export type VerifyOtpMutationVariables = Exact<{
  input: VerifyOtpInput;
}>;


export type VerifyOtpMutation = VerifyOtpMutation_Mutation;

export type CreateWuunderShipmentMutation_createWuunderShipment_WuunderShipment = { __typename?: 'WuunderShipment', id: any };

export type CreateWuunderShipmentMutation_Mutation = { __typename?: 'Mutation', createWuunderShipment?: CreateWuunderShipmentMutation_createWuunderShipment_WuunderShipment | null };


export type CreateWuunderShipmentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type CreateWuunderShipmentMutation = CreateWuunderShipmentMutation_Mutation;

export type AdsAboutToExpireQuery_products_ProductResult_items_Product_image_Image = { __typename?: 'Image', url: string, width?: number | null, height?: number | null };

export type AdsAboutToExpireQuery_products_ProductResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: AdsAboutToExpireQuery_products_ProductResult_items_Product_image_Image | null };

export type AdsAboutToExpireQuery_products_ProductResult_pagination_PaginationResult = { __typename?: 'PaginationResult', count: number };

export type AdsAboutToExpireQuery_products_ProductResult = { __typename?: 'ProductResult', items: Array<AdsAboutToExpireQuery_products_ProductResult_items_Product>, pagination: AdsAboutToExpireQuery_products_ProductResult_pagination_PaginationResult };

export type AdsAboutToExpireQuery_Query = { __typename?: 'Query', products: AdsAboutToExpireQuery_products_ProductResult };


export type AdsAboutToExpireQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
}>;


export type AdsAboutToExpireQuery = AdsAboutToExpireQuery_Query;

export type AttributesQuery_attributesByKey_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, slug: string };

export type AttributesQuery_attributesByKey_Artist = { __typename?: 'Artist', id: any, title: string };

export type AttributesQuery_attributesByKey_Brand = { __typename?: 'Brand' };

export type AttributesQuery_attributesByKey_Color = { __typename?: 'Color', id: any, slug: string, hex?: string | null, title: string };

export type AttributesQuery_attributesByKey_Designer = { __typename?: 'Designer' };

export type AttributesQuery_attributesByKey_Label = { __typename?: 'Label' };

export type AttributesQuery_attributesByKey_Material = { __typename?: 'Material', id: any, title: string };

export type AttributesQuery_attributesByKey_Style = { __typename?: 'Style' };

export type AttributesQuery_attributesByKey_Subject = { __typename?: 'Subject' };

export type AttributesQuery_attributesByKey_UsageSign = { __typename?: 'UsageSign', id: any, slug: string };

export type AttributesQuery_attributesByKey = AttributesQuery_attributesByKey_AdditionalInfo | AttributesQuery_attributesByKey_Artist | AttributesQuery_attributesByKey_Brand | AttributesQuery_attributesByKey_Color | AttributesQuery_attributesByKey_Designer | AttributesQuery_attributesByKey_Label | AttributesQuery_attributesByKey_Material | AttributesQuery_attributesByKey_Style | AttributesQuery_attributesByKey_Subject | AttributesQuery_attributesByKey_UsageSign;

export type AttributesQuery_Query = { __typename?: 'Query', attributesByKey: Array<AttributesQuery_attributesByKey> };


export type AttributesQueryVariables = Exact<{
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AttributesQuery = AttributesQuery_Query;

export type BoostCartQuery_boostCart_BoostCart = { __typename?: 'BoostCart', products: Array<BoostCartFragmentFragment_BoostCart_products_Product>, total: BoostCartFragmentFragment_BoostCart_total_Price };

export type BoostCartQuery_Query = { __typename?: 'Query', boostCart: BoostCartQuery_boostCart_BoostCart };


export type BoostCartQueryVariables = Exact<{ [key: string]: never; }>;


export type BoostCartQuery = BoostCartQuery_Query;

export type BrandsQuery_brands_Brand_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type BrandsQuery_brands_Brand = { __typename?: 'Brand', id: any, title: string, slug: string, image?: string | null, listingPage?: BrandsQuery_brands_Brand_listingPage_ListingPage | null };

export type BrandsQuery_Query = { __typename?: 'Query', brands: Array<BrandsQuery_brands_Brand> };


export type BrandsQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  filters?: InputMaybe<BrandsFilter>;
}>;


export type BrandsQuery = BrandsQuery_Query;

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_unavailableDates_UnavailableDate = { __typename?: 'UnavailableDate', date: any, state: UnavailableDateState };

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions = { __typename?: 'BrengerAppointmentOptions', dateFrom?: any | null, dateTo?: any | null, finalised: boolean, awaitingResponseFrom?: GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_awaitingResponseFrom_Merchant | null, unavailableDates?: Array<GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_unavailableDates_UnavailableDate> | null };

export type GetBrengerAppointmentOptionsQuery_Query = { __typename?: 'Query', getBrengerAppointmentOptions: GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions };


export type GetBrengerAppointmentOptionsQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type GetBrengerAppointmentOptionsQuery = GetBrengerAppointmentOptionsQuery_Query;

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate_merchant_Merchant = { __typename?: 'Merchant', name: string };

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any, date: any, state: BrengerProposedDateState, merchantId: any, merchant: GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate_merchant_Merchant };

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates = { __typename?: 'BrengerProposedDates', proposedDates: Array<GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate> };

export type GetBrengerProposedDatesQuery_Query = { __typename?: 'Query', getBrengerProposedDates: GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates };


export type GetBrengerProposedDatesQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type GetBrengerProposedDatesQuery = GetBrengerProposedDatesQuery_Query;

export type CartQueryQuery_cart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals?: CartFragmentFragment_Cart_totals_OrderTotals | null, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type CartQueryQuery_Query = { __typename?: 'Query', cart: CartQueryQuery_cart_Cart };


export type CartQueryQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type CartQueryQuery = CartQueryQuery_Query;

export type CartCountQuery_Query = { __typename?: 'Query', cartCount: number };


export type CartCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CartCountQuery = CartCountQuery_Query;

export type GetProductShippingOptionsQuery_getProductShippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type GetProductShippingOptionsQuery_Query = { __typename?: 'Query', getProductShippingOptions: Array<GetProductShippingOptionsQuery_getProductShippingOptions_ShippingOption> };


export type GetProductShippingOptionsQueryVariables = Exact<{
  input?: InputMaybe<ProductShippingOptionsInput>;
}>;


export type GetProductShippingOptionsQuery = GetProductShippingOptionsQuery_Query;

export type ListingPageQuery_listingPage_ListingPage_filters_ListingPageFilterItem = { __typename?: 'ListingPageFilterItem', key: ListingPageFilterKey, value: string };

export type ListingPageQuery_listingPage_ListingPage_categoryPages_ListingCategoryPage = { __typename?: 'ListingCategoryPage', listingLevel: ListingLevel, activeProductCount: number, url: string, title: string };

export type ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage_category_Category = { __typename?: 'Category', icon?: string | null };

export type ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage = { __typename?: 'ListingPage', url: string, title: string, category?: ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage_category_Category | null };

export type ListingPageQuery_listingPage_ListingPage_breadcrumbs_ListingPage = { __typename?: 'ListingPage', url: string, title: string, title_en: string };

export type ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage = { __typename?: 'RelatedListingPage', type: ListingPageRelationType, listingPage: ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage };

export type ListingPageQuery_listingPage_ListingPage = { __typename?: 'ListingPage', title: string, url: string, description?: string | null, image?: string | null, sort?: SearchSort | null, order?: Ordering | null, recommended?: boolean | null, noIndex?: boolean | null, filters: Array<ListingPageQuery_listingPage_ListingPage_filters_ListingPageFilterItem>, categoryPages: Array<ListingPageQuery_listingPage_ListingPage_categoryPages_ListingCategoryPage>, subcategoryPages: Array<ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage>, breadcrumbs: Array<ListingPageQuery_listingPage_ListingPage_breadcrumbs_ListingPage>, relatedListingPages: Array<ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage> };

export type ListingPageQuery_Query = { __typename?: 'Query', listingPage?: ListingPageQuery_listingPage_ListingPage | null };


export type ListingPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  lang: Language;
}>;


export type ListingPageQuery = ListingPageQuery_Query;

export type CategoriesQuery_categories_CategoryResult_items_Category_parent_Category = { __typename?: 'Category', id: any, slug: string, level?: number | null };

export type CategoriesQuery_categories_CategoryResult_items_Category_children_Category = { __typename?: 'Category', id: any };

export type CategoriesQuery_categories_CategoryResult_items_Category = { __typename?: 'Category', id: any, slug: string, level?: number | null, title: string, parent?: CategoriesQuery_categories_CategoryResult_items_Category_parent_Category | null, children?: Array<CategoriesQuery_categories_CategoryResult_items_Category_children_Category | null> | null };

export type CategoriesQuery_categories_CategoryResult = { __typename?: 'CategoryResult', items: Array<CategoriesQuery_categories_CategoryResult_items_Category> };

export type CategoriesQuery_Query = { __typename?: 'Query', categories: CategoriesQuery_categories_CategoryResult };


export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = CategoriesQuery_Query;

export type GetListThreadQuery_thread_Thread = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type GetListThreadQuery_Query = { __typename?: 'Query', thread?: GetListThreadQuery_thread_Thread | null };


export type GetListThreadQueryVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type GetListThreadQuery = GetListThreadQuery_Query;

export type GetMessagesQuery_getMessages_GetMessagesResult_items_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, flaggedReasons?: Array<string> | null, originalBody?: string | null, sender: MessageFragment_Message_sender_Member, item?: MessageFragment_Message_item | null };

export type GetMessagesQuery_getMessages_GetMessagesResult_pagination_CursorPaginationResult = { __typename?: 'CursorPaginationResult', hasMore: boolean };

export type GetMessagesQuery_getMessages_GetMessagesResult = { __typename?: 'GetMessagesResult', items: Array<GetMessagesQuery_getMessages_GetMessagesResult_items_Message>, pagination: GetMessagesQuery_getMessages_GetMessagesResult_pagination_CursorPaginationResult };

export type GetMessagesQuery_Query = { __typename?: 'Query', getMessages: GetMessagesQuery_getMessages_GetMessagesResult };


export type GetMessagesQueryVariables = Exact<{
  input: GetMessagesInput;
  lang?: InputMaybe<Language>;
}>;


export type GetMessagesQuery = GetMessagesQuery_Query;

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_addresses_Address = { __typename?: 'Address', city: string, country: string };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant = { __typename?: 'Merchant', id: any, email?: string | null, type: MerchantType, expert_seller?: boolean | null, name: string, created: any, rating?: number | null, reviewsCount?: number | null, addresses: Array<GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_addresses_Address>, image?: GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_image_Image | null };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null, merchant: GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant };

export type GetThreadQuery_thread_Thread_item_Product_categories_Category = { __typename?: 'Category', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Artist = { __typename?: 'Artist' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Brand = { __typename?: 'Brand' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Color = { __typename?: 'Color' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Designer = { __typename?: 'Designer' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Label = { __typename?: 'Label' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Subject = { __typename?: 'Subject' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type GetThreadQuery_thread_Thread_item_Product_attributes = GetThreadQuery_thread_Thread_item_Product_attributes_AdditionalInfo | GetThreadQuery_thread_Thread_item_Product_attributes_Artist | GetThreadQuery_thread_Thread_item_Product_attributes_Brand | GetThreadQuery_thread_Thread_item_Product_attributes_Color | GetThreadQuery_thread_Thread_item_Product_attributes_Designer | GetThreadQuery_thread_Thread_item_Product_attributes_Label | GetThreadQuery_thread_Thread_item_Product_attributes_Material | GetThreadQuery_thread_Thread_item_Product_attributes_Style | GetThreadQuery_thread_Thread_item_Product_attributes_Subject | GetThreadQuery_thread_Thread_item_Product_attributes_UsageSign;

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_highest_bid_Bid = { __typename?: 'Bid', state: BidState, id: any };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_order_Order = { __typename?: 'Order', orderState: OrderState };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_message_Message = { __typename?: 'Message', id: any };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid = { __typename?: 'Bid', id: any, state: BidState, merchantId: any, buyerId: any, isCounter: boolean, order?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_order_Order | null, message?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_message_Message | null };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction = { __typename?: 'Auction', id: any, updated?: any | null, allow_buy_now: boolean, allow_bid: boolean, end_date?: any | null, state: AuctionState, buy_now_price?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_buy_now_price_Price | null, minimum_bid?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_minimum_bid_Price | null, highest_bid?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_highest_bid_Bid | null, sold_at?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_sold_at_Price | null, bids: Array<GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid> };

export type GetThreadQuery_thread_Thread_item_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, vacationModeEnabledAt?: any | null };

export type GetThreadQuery_thread_Thread_item_Product_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_original_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_shippingMethod_ShippingMethod = { __typename?: 'ShippingMethod', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_review_Review = { __typename?: 'Review', id: any };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', shipmentId?: string | null, state?: string | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', orderId: any, finalisedDate?: any | null, hasProposedDates: boolean, type: BrengerAppointmentType, awaitingResponseFrom?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant | null, brengerShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', shipmentId?: string | null, state?: string | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', orderId: any, finalisedDate?: any | null, hasProposedDates: boolean, type: BrengerAppointmentType, awaitingResponseFrom?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant | null, brengerShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_wuunderShipment_WuunderShipment = { __typename?: 'WuunderShipment', id: any, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: WuunderShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order = { __typename?: 'Order', id: any, created?: any | null, merchantId: any, buyerId: any, state: OrderState, outsourceShippingMethod?: string | null, returnShippingMethod?: string | null, returnCaseStatus?: string | null, disputeReason?: string | null, damageFormUrl?: string | null, deliveryMethod: DeliveryMethod, externalDelivery?: boolean | null, shippingMethod?: GetThreadQuery_thread_Thread_item_Product_orders_Order_shippingMethod_ShippingMethod | null, review?: GetThreadQuery_thread_Thread_item_Product_orders_Order_review_Review | null, brengerAppointment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment | null, returnBrengerAppointment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment | null, wuunderShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_wuunderShipment_WuunderShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type GetThreadQuery_thread_Thread_item_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type GetThreadQuery_thread_Thread_item_Merchant = { __typename?: 'Merchant' };

export type GetThreadQuery_thread_Thread_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, quality: ProductQuality, state: ProductState, categories: Array<GetThreadQuery_thread_Thread_item_Product_categories_Category>, attributes: Array<GetThreadQuery_thread_Thread_item_Product_attributes>, auction?: GetThreadQuery_thread_Thread_item_Product_auction_Auction | null, merchant: GetThreadQuery_thread_Thread_item_Product_merchant_Merchant, buy_now_price?: GetThreadQuery_thread_Thread_item_Product_buy_now_price_Price | null, original_price?: GetThreadQuery_thread_Thread_item_Product_original_price_Price | null, image?: GetThreadQuery_thread_Thread_item_Product_image_Image | null, orders: Array<GetThreadQuery_thread_Thread_item_Product_orders_Order>, address?: GetThreadQuery_thread_Thread_item_Product_address_Address | null, shippingOptions: Array<GetThreadQuery_thread_Thread_item_Product_shippingOptions_ShippingOption> };

export type GetThreadQuery_thread_Thread_item = GetThreadQuery_thread_Thread_item_Merchant | GetThreadQuery_thread_Thread_item_Product;

export type GetThreadQuery_thread_Thread = { __typename?: 'Thread', id: any, unread_count: number, canSendImageMessage: boolean, subscribers: Array<GetThreadQuery_thread_Thread_subscribers_Subscriber>, item: GetThreadQuery_thread_Thread_item };

export type GetThreadQuery_Query = { __typename?: 'Query', thread?: GetThreadQuery_thread_Thread | null };


export type GetThreadQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type GetThreadQuery = GetThreadQuery_Query;

export type GetThreadsQuery_getThreads_GetThreadsResult_items_Thread = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type GetThreadsQuery_getThreads_GetThreadsResult_pagination_CursorPaginationResult = { __typename?: 'CursorPaginationResult', hasMore: boolean };

export type GetThreadsQuery_getThreads_GetThreadsResult = { __typename?: 'GetThreadsResult', items: Array<GetThreadsQuery_getThreads_GetThreadsResult_items_Thread>, pagination: GetThreadsQuery_getThreads_GetThreadsResult_pagination_CursorPaginationResult };

export type GetThreadsQuery_Query = { __typename?: 'Query', getThreads: GetThreadsQuery_getThreads_GetThreadsResult };


export type GetThreadsQueryVariables = Exact<{
  input?: InputMaybe<GetThreadsInput>;
}>;


export type GetThreadsQuery = GetThreadsQuery_Query;

export type GetUnreadMessageCountQuery_Query = { __typename?: 'Query', getUnreadMessageCount: number };


export type GetUnreadMessageCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadMessageCountQuery = GetUnreadMessageCountQuery_Query;

export type CheckVatQuery_checkVat_vatCheckResult = { __typename?: 'vatCheckResult', result?: VatCheck | null };

export type CheckVatQuery_Query = { __typename?: 'Query', checkVat?: CheckVatQuery_checkVat_vatCheckResult | null };


export type CheckVatQueryVariables = Exact<{
  vat: Scalars['String']['input'];
}>;


export type CheckVatQuery = CheckVatQuery_Query;

export type GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock_listingPage_ListingPage = { __typename?: 'ListingPage', url: string };

export type GetCollectionsQuery_pageByKey_Page_blocks_AttributeBlock = { __typename?: 'AttributeBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_AudioBlock = { __typename?: 'AudioBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CallToActionBlock = { __typename?: 'CallToActionBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CategoriesBlock = { __typename?: 'CategoriesBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CategoryBlock = { __typename?: 'CategoryBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CollectionBlock = { __typename?: 'CollectionBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_ImageBlock = { __typename?: 'ImageBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_MemberBlock = { __typename?: 'MemberBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_MerchantBlock = { __typename?: 'MerchantBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock = { __typename?: 'ProductBlock', id: any, title: string, description?: string | null, slug: string, image: string, listingPage?: GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock_listingPage_ListingPage | null };

export type GetCollectionsQuery_pageByKey_Page_blocks_QueryBlock = { __typename?: 'QueryBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_SearchProductsBlock = { __typename?: 'SearchProductsBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_TextBlock = { __typename?: 'TextBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_VideoBlock = { __typename?: 'VideoBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks = GetCollectionsQuery_pageByKey_Page_blocks_AttributeBlock | GetCollectionsQuery_pageByKey_Page_blocks_AudioBlock | GetCollectionsQuery_pageByKey_Page_blocks_CallToActionBlock | GetCollectionsQuery_pageByKey_Page_blocks_CategoriesBlock | GetCollectionsQuery_pageByKey_Page_blocks_CategoryBlock | GetCollectionsQuery_pageByKey_Page_blocks_CollectionBlock | GetCollectionsQuery_pageByKey_Page_blocks_ImageBlock | GetCollectionsQuery_pageByKey_Page_blocks_MemberBlock | GetCollectionsQuery_pageByKey_Page_blocks_MerchantBlock | GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock | GetCollectionsQuery_pageByKey_Page_blocks_QueryBlock | GetCollectionsQuery_pageByKey_Page_blocks_SearchProductsBlock | GetCollectionsQuery_pageByKey_Page_blocks_TextBlock | GetCollectionsQuery_pageByKey_Page_blocks_VideoBlock;

export type GetCollectionsQuery_pageByKey_Page = { __typename?: 'Page', id: any, blocks: Array<GetCollectionsQuery_pageByKey_Page_blocks> };

export type GetCollectionsQuery_Query = { __typename?: 'Query', pageByKey?: GetCollectionsQuery_pageByKey_Page | null };


export type GetCollectionsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type GetCollectionsQuery = GetCollectionsQuery_Query;

export type DesignersQuery_designers_Designer_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type DesignersQuery_designers_Designer = { __typename?: 'Designer', id: any, title: string, slug: string, image?: string | null, listingPage?: DesignersQuery_designers_Designer_listingPage_ListingPage | null };

export type DesignersQuery_Query = { __typename?: 'Query', designers: Array<DesignersQuery_designers_Designer> };


export type DesignersQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  filters?: InputMaybe<DesignersFilter>;
}>;


export type DesignersQuery = DesignersQuery_Query;

export type FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', slug: string };

export type FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult_items_Product | null> | null };

export type FallbackProductFromDmSlugQuery_Query = { __typename?: 'Query', searchProducts?: FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult | null };


export type FallbackProductFromDmSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type FallbackProductFromDmSlugQuery = FallbackProductFromDmSlugQuery_Query;

export type FavoriteProductsQuery_favorites_FavoriteResult_pagination_PaginationResult = { __typename?: 'PaginationResult', limit: number, page: number, pages: number, count: number };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', active: boolean, shippingProvider?: ShippingProviderEnum | null };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Merchant = { __typename?: 'Merchant' };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, quality: ProductQuality, view_count: number, favorite_count: number, shippingOptions: Array<FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product_shippingOptions_ShippingOption>, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item = FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Merchant | FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product;

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite = { __typename?: 'Favorite', id: any, item: FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item };

export type FavoriteProductsQuery_favorites_FavoriteResult = { __typename?: 'FavoriteResult', pagination: FavoriteProductsQuery_favorites_FavoriteResult_pagination_PaginationResult, items: Array<FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite> };

export type FavoriteProductsQuery_Query = { __typename?: 'Query', favorites: FavoriteProductsQuery_favorites_FavoriteResult };


export type FavoriteProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  sort?: InputMaybe<FavoriteSort>;
  order?: InputMaybe<Ordering>;
}>;


export type FavoriteProductsQuery = FavoriteProductsQuery_Query;

export type GetCollectionQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, quality: ProductQuality, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type GetCollectionQuery_searchProducts_SearchProductsResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type GetCollectionQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<GetCollectionQuery_searchProducts_SearchProductsResult_items_Product | null> | null, pagination?: GetCollectionQuery_searchProducts_SearchProductsResult_pagination_PaginationResult | null };

export type GetCollectionQuery_blockByKey_AttributeBlock = { __typename?: 'AttributeBlock' };

export type GetCollectionQuery_blockByKey_AudioBlock = { __typename?: 'AudioBlock' };

export type GetCollectionQuery_blockByKey_CallToActionBlock = { __typename?: 'CallToActionBlock' };

export type GetCollectionQuery_blockByKey_CategoriesBlock = { __typename?: 'CategoriesBlock' };

export type GetCollectionQuery_blockByKey_CategoryBlock = { __typename?: 'CategoryBlock' };

export type GetCollectionQuery_blockByKey_CollectionBlock = { __typename?: 'CollectionBlock' };

export type GetCollectionQuery_blockByKey_ImageBlock = { __typename?: 'ImageBlock' };

export type GetCollectionQuery_blockByKey_MemberBlock = { __typename?: 'MemberBlock' };

export type GetCollectionQuery_blockByKey_MerchantBlock = { __typename?: 'MerchantBlock' };

export type GetCollectionQuery_blockByKey_ProductBlock = { __typename?: 'ProductBlock', id: any, title: string, slug: string, image: string };

export type GetCollectionQuery_blockByKey_QueryBlock = { __typename?: 'QueryBlock' };

export type GetCollectionQuery_blockByKey_SearchProductsBlock = { __typename?: 'SearchProductsBlock' };

export type GetCollectionQuery_blockByKey_TextBlock = { __typename?: 'TextBlock' };

export type GetCollectionQuery_blockByKey_VideoBlock = { __typename?: 'VideoBlock' };

export type GetCollectionQuery_blockByKey = GetCollectionQuery_blockByKey_AttributeBlock | GetCollectionQuery_blockByKey_AudioBlock | GetCollectionQuery_blockByKey_CallToActionBlock | GetCollectionQuery_blockByKey_CategoriesBlock | GetCollectionQuery_blockByKey_CategoryBlock | GetCollectionQuery_blockByKey_CollectionBlock | GetCollectionQuery_blockByKey_ImageBlock | GetCollectionQuery_blockByKey_MemberBlock | GetCollectionQuery_blockByKey_MerchantBlock | GetCollectionQuery_blockByKey_ProductBlock | GetCollectionQuery_blockByKey_QueryBlock | GetCollectionQuery_blockByKey_SearchProductsBlock | GetCollectionQuery_blockByKey_TextBlock | GetCollectionQuery_blockByKey_VideoBlock;

export type GetCollectionQuery_Query = { __typename?: 'Query', searchProducts?: GetCollectionQuery_searchProducts_SearchProductsResult | null, blockByKey?: GetCollectionQuery_blockByKey | null };


export type GetCollectionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  sort?: InputMaybe<SearchSort>;
  order?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type GetCollectionQuery = GetCollectionQuery_Query;

export type GetFallbackListingPageQuery_getFallbackListingPage_ListingPage = { __typename?: 'ListingPage', url: string };

export type GetFallbackListingPageQuery_Query = { __typename?: 'Query', getFallbackListingPage: GetFallbackListingPageQuery_getFallbackListingPage_ListingPage };


export type GetFallbackListingPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang: Language;
}>;


export type GetFallbackListingPageQuery = GetFallbackListingPageQuery_Query;

export type GuestCartQuery_guestCart_GuestCart_products_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, isInCart: boolean, view_count: number, favorite_count: number, quality: ProductQuality, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type GuestCartQuery_guestCart_GuestCart = { __typename?: 'GuestCart', products: Array<GuestCartQuery_guestCart_GuestCart_products_Product> };

export type GuestCartQuery_Query = { __typename?: 'Query', guestCart: GuestCartQuery_guestCart_GuestCart };


export type GuestCartQueryVariables = Exact<{
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type GuestCartQuery = GuestCartQuery_Query;

export type CategoryBasicDetailsFragment = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string };

export type HomepageCategoriesQuery_categories_Category_children_Category = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string };

export type HomepageCategoriesQuery_categories_Category_avatarImage_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type HomepageCategoriesQuery_categories_Category = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string, children?: Array<HomepageCategoriesQuery_categories_Category_children_Category | null> | null, avatarImage?: HomepageCategoriesQuery_categories_Category_avatarImage_Image | null };

export type HomepageCategoriesQuery_Query = { __typename?: 'Query', categories: Array<HomepageCategoriesQuery_categories_Category> };


export type HomepageCategoriesQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type HomepageCategoriesQuery = HomepageCategoriesQuery_Query;

export type MeQuery_me_Member_merchants_Merchant_fee_Fee = { __typename?: 'Fee', type: CalculationMethod, amount: number };

export type MeQuery_me_Member_merchants_Merchant_image_Image = { __typename?: 'Image', url: string };

export type MeQuery_me_Member_merchants_Merchant_addresses_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type MeQuery_me_Member_merchants_Merchant_bank_account_BankAccount = { __typename?: 'BankAccount', account_number: string, account_holder_name: string };

export type MeQuery_me_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, name: string, email?: string | null, biography?: string | null, phone?: string | null, verified?: boolean | null, referral_code?: string | null, expert_seller?: boolean | null, rating?: number | null, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null, number_of_favorites?: number | null, business_name?: string | null, url?: string | null, tax_id?: string | null, vat_id?: string | null, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null, pendingActions: Array<PendingAction>, fee?: MeQuery_me_Member_merchants_Merchant_fee_Fee | null, image?: MeQuery_me_Member_merchants_Merchant_image_Image | null, addresses: Array<MeQuery_me_Member_merchants_Merchant_addresses_Address>, bank_account?: MeQuery_me_Member_merchants_Merchant_bank_account_BankAccount | null };

export type MeQuery_me_Member = { __typename?: 'Member', id: any, given_name: string, family_name: string, email: string, locale: Locale, last_login?: any | null, date_joined: any, dob?: any | null, lastUsedPaymentMethod?: PaymentMethod | null, placeOfBirth?: string | null, countryOfBirth?: string | null, merchants: Array<MeQuery_me_Member_merchants_Merchant> };

export type MeQuery_Query = { __typename?: 'Query', me?: MeQuery_me_Member | null };


export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = MeQuery_Query;

export type ReviewsQuery_reviews_ReviewResult_items_Review_reviewer_Merchant = { __typename?: 'Merchant', name: string };

export type ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_merchant_Merchant = { __typename?: 'Merchant', name: string };

export type ReviewsQuery_reviews_ReviewResult_items_Review_order_Order = { __typename?: 'Order', merchant: ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_merchant_Merchant };

export type ReviewsQuery_reviews_ReviewResult_items_Review = { __typename?: 'Review', id: any, score?: number | null, review?: string | null, anonymous?: boolean | null, created?: any | null, originalReview?: string | null, reviewer?: ReviewsQuery_reviews_ReviewResult_items_Review_reviewer_Merchant | null, order: ReviewsQuery_reviews_ReviewResult_items_Review_order_Order };

export type ReviewsQuery_reviews_ReviewResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type ReviewsQuery_reviews_ReviewResult = { __typename?: 'ReviewResult', items: Array<ReviewsQuery_reviews_ReviewResult_items_Review>, pagination: ReviewsQuery_reviews_ReviewResult_pagination_PaginationResult };

export type ReviewsQuery_Query = { __typename?: 'Query', reviews: ReviewsQuery_reviews_ReviewResult };


export type ReviewsQueryVariables = Exact<{
  merchant: Scalars['String']['input'];
  order?: InputMaybe<Ordering>;
  sort?: InputMaybe<ReviewSort>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type ReviewsQuery = ReviewsQuery_Query;

export type MyProductsQuery_products_ProductResult_items_Product_curation_feedback_CurationFeedback = { __typename?: 'CurationFeedback', message: string, severity: CurationFeedbackSeverity };

export type MyProductsQuery_products_ProductResult_items_Product_shipping_cost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_curated_reason_CurationReason = { __typename?: 'CurationReason', reason?: string | null, message?: string | null };

export type MyProductsQuery_products_ProductResult_items_Product_image_Image = { __typename?: 'Image', url: string, width?: number | null, height?: number | null };

export type MyProductsQuery_products_ProductResult_items_Product_merchant_Merchant = { __typename?: 'Merchant', id: any };

export type MyProductsQuery_products_ProductResult_items_Product_merchant_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, expiry_date?: any | null, expiring?: boolean | null, allow_bid: boolean, allow_buy_now: boolean, minimum_bid?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_minimum_bid_Price | null, sold_at?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_sold_at_Price | null, buy_now_price?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_buy_now_price_Price | null };

export type MyProductsQuery_products_ProductResult_items_Product = { __typename?: 'Product', id: any, title: string, description?: string | null, slug: string, state: ProductState, status: ProductStatus, view_count: number, favorite_count: number, quality: ProductQuality, push_to_top_count?: number | null, last_boost?: any | null, created?: any | null, isBoostable?: boolean | null, delivery_method: DeliveryMethod, curated_custom?: string | null, curation_feedback?: MyProductsQuery_products_ProductResult_items_Product_curation_feedback_CurationFeedback | null, shipping_cost: MyProductsQuery_products_ProductResult_items_Product_shipping_cost_Price, curated_reason?: MyProductsQuery_products_ProductResult_items_Product_curated_reason_CurationReason | null, image?: MyProductsQuery_products_ProductResult_items_Product_image_Image | null, merchant: MyProductsQuery_products_ProductResult_items_Product_merchant_Merchant, merchant_fee?: MyProductsQuery_products_ProductResult_items_Product_merchant_fee_Fee | null, auction?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction | null };

export type MyProductsQuery_products_ProductResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type MyProductsQuery_products_ProductResult = { __typename?: 'ProductResult', items: Array<MyProductsQuery_products_ProductResult_items_Product>, pagination: MyProductsQuery_products_ProductResult_pagination_PaginationResult };

export type MyProductsQuery_Query = { __typename?: 'Query', products: MyProductsQuery_products_ProductResult };


export type MyProductsQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  productStatus?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductSort>;
  sortOrder?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type MyProductsQuery = MyProductsQuery_Query;

export type OrderQuery_order_Order_buyer_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrderQuery_order_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrderQuery_order_Order_product_Product_image_Image = { __typename?: 'Image', url: string, id: any, thumbnail_url: string };

export type OrderQuery_order_Order_product_Product_images_Image = { __typename?: 'Image', id: any, x_small_url: string };

export type OrderQuery_order_Order_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: OrderQuery_order_Order_product_Product_image_Image | null, images: Array<OrderQuery_order_Order_product_Product_images_Image> };

export type OrderQuery_order_Order = { __typename?: 'Order', id: any, identifier: string, total_incl_vat: number, currency: Currency, payment_status?: PaymentStatus | null, payout_status?: PayoutStatus | null, payout_trace_id?: string | null, created?: any | null, state: OrderState, buyer_receipt?: string | null, seller_receipt?: string | null, payout: number, buyer: OrderQuery_order_Order_buyer_Merchant, merchant: OrderQuery_order_Order_merchant_Merchant, product: OrderQuery_order_Order_product_Product };

export type OrderQuery_Query = { __typename?: 'Query', order?: OrderQuery_order_Order | null };


export type OrderQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type OrderQuery = OrderQuery_Query;

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_discount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_tax_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_serviceCost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_shipping_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_addon_Service = { __typename?: 'Service', id: any, name: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals = { __typename?: 'OrderGroupAddonTotals', addon: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_addon_Service, price: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_price_Price };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals = { __typename?: 'OrderGroupTotals', discount: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_discount_Price, total: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_total_Price, subtotal: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_subtotal_Price, tax: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_tax_Price, serviceCost: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_serviceCost_Price, shipping: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_shipping_Price, addons: Array<OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals> };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_billingAddress_OrderAddress = { __typename?: 'OrderAddress', line1: string, line2?: string | null, postal_code: string, country: string, city: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, slug: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_image_Image = { __typename?: 'Image', url: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product = { __typename?: 'Product', id: any, title: string, image?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_image_Image | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, isInCart: boolean, view_count: number, favorite_count: number, quality: ProductQuality, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order = { __typename?: 'Order', id: any, currency: Currency, purchase_type: PurchaseType, subtotal_incl_vat: number, buyer_protection_incl_vat: number, delivery_method: DeliveryMethod, state: OrderState, external_delivery?: boolean | null, shipping_method?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_shipping_method_ShippingMethod | null, service_target?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product | null, product: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_product_Product, thread?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_thread_Thread | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup = { __typename?: 'OrderGroup', id: any, readableId?: string | null, couponCode?: string | null, created?: any | null, type: OrderGroupType, hasExternalDelivery?: boolean | null, paymentMethod: PaymentMethod, totals: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals, billingAddress?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_billingAddress_OrderAddress | null, orders: Array<OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order> };

export type OrderGroupByPaymentIntentQuery_Query = { __typename?: 'Query', orderGroupByPaymentIntent?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup | null };


export type OrderGroupByPaymentIntentQueryVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type OrderGroupByPaymentIntentQuery = OrderGroupByPaymentIntentQuery_Query;

export type OrdersQuery_orders_OrderResult_items_Order_buyer_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrdersQuery_orders_OrderResult_items_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrdersQuery_orders_OrderResult_items_Order_product_Product_image_Image = { __typename?: 'Image', url: string, id: any, thumbnail_url: string };

export type OrdersQuery_orders_OrderResult_items_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, state: ProductState, image?: OrdersQuery_orders_OrderResult_items_Order_product_Product_image_Image | null };

export type OrdersQuery_orders_OrderResult_items_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, buyer_receipt?: string | null, buyer_track_and_trace?: string | null, seller_receipt?: string | null, seller_track_and_trace?: string | null, payment_status?: PaymentStatus | null, payout_status?: PayoutStatus | null, payout_eta?: any | null, payout_trace_id?: string | null, payout: number, total_incl_vat: number, currency: Currency, buyer: OrdersQuery_orders_OrderResult_items_Order_buyer_Merchant, merchant: OrdersQuery_orders_OrderResult_items_Order_merchant_Merchant, product: OrdersQuery_orders_OrderResult_items_Order_product_Product };

export type OrdersQuery_orders_OrderResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type OrdersQuery_orders_OrderResult = { __typename?: 'OrderResult', items: Array<OrdersQuery_orders_OrderResult_items_Order>, pagination: OrdersQuery_orders_OrderResult_pagination_PaginationResult };

export type OrdersQuery_Query = { __typename?: 'Query', orders: OrdersQuery_orders_OrderResult };


export type OrdersQueryVariables = Exact<{
  filterKey: OrderFilterKey;
  userId: Scalars['String']['input'];
  productTitle?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrderSort>;
  order?: InputMaybe<Ordering>;
  orderState?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrdersQuery = OrdersQuery_Query;

export type ProductByIdQuery_productById_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, description?: string | null, state: ProductState, view_count: number, favorite_count: number, quality: ProductQuality, status: ProductStatus, auto_discount?: boolean | null, brand_suggestion?: string | null, artist_suggestion?: string | null, number_of_items?: number | null, shape?: Shape | null, created?: any | null, condition: ProductCondition, isBoostable?: boolean | null, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, usage_signs_description?: string | null, is_in_showroom?: boolean | null, note_for_curator?: string | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: string | null, postal_package_weight_kg?: number | null, buy_now_price?: PrivateProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductFragmentFragment_Product_original_price_Price | null, newPrice?: PrivateProductFragmentFragment_Product_newPrice_Price | null, image?: PrivateProductFragmentFragment_Product_image_Image | null, images: Array<PrivateProductFragmentFragment_Product_images_Image>, address?: PrivateProductFragmentFragment_Product_address_Address | null, auction?: PrivateProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: PrivateProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: PrivateProductFragmentFragment_Product_merchant_Merchant, merchant_fee?: PrivateProductFragmentFragment_Product_merchant_fee_Fee | null, favorite?: PrivateProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PrivateProductFragmentFragment_Product_categories_Category>, breadcrumbs: Array<PrivateProductFragmentFragment_Product_breadcrumbs_Category>, brand?: PrivateProductFragmentFragment_Product_brand_Brand | null, attributes: Array<PrivateProductFragmentFragment_Product_attributes>, shipping_cost: PrivateProductFragmentFragment_Product_shipping_cost_Price, curation_feedback?: PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback | null };

export type ProductByIdQuery_Query = { __typename?: 'Query', productById: ProductByIdQuery_productById_Product };


export type ProductByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProductByIdQuery = ProductByIdQuery_Query;

export type ProductBySlugQuery_productBySlug_Product_auction_Auction = { __typename?: 'Auction', end_date?: any | null, id: any, state: AuctionState, created?: any | null, updated?: any | null, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, coming_soon_time?: any | null, minimum_bid?: PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type ProductBySlugQuery_productBySlug_Product_relatedListingPages_ListingPage = { __typename?: 'ListingPage', title: string, url: string };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_ARObject = { __typename?: 'ARObject' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Audio = { __typename?: 'Audio' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Document = { __typename?: 'Document' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Image = { __typename?: 'Image', id: any, url: string, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Video = { __typename?: 'Video' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media = ProductBySlugQuery_productBySlug_Product_brand_Brand_media_ARObject | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Audio | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Document | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Image | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Video;

export type ProductBySlugQuery_productBySlug_Product_brand_Brand = { __typename?: 'Brand', id: any, slug: string, media: Array<ProductBySlugQuery_productBySlug_Product_brand_Brand_media> };

export type ProductBySlugQuery_productBySlug_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', active: boolean, shippingProvider?: ShippingProviderEnum | null };

export type ProductBySlugQuery_productBySlug_Product = { __typename?: 'Product', created?: any | null, gone: boolean, id: any, identifier: string, title: string, slug: string, description?: string | null, usage_signs_description?: string | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, cleaningServiceAvailable: boolean, favorite_count: number, isOwner?: boolean | null, isDesignerItem?: boolean | null, is_in_showroom?: boolean | null, showroom_zone?: string | null, quality: ProductQuality, two_man_delivery?: boolean | null, ground_floor_only_delivery?: boolean | null, updated?: any | null, brand_suggestion?: string | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, original_title: string, original_description?: string | null, original_usage_signs_description?: string | null, auction?: ProductBySlugQuery_productBySlug_Product_auction_Auction | null, relatedListingPages: Array<ProductBySlugQuery_productBySlug_Product_relatedListingPages_ListingPage>, brand?: ProductBySlugQuery_productBySlug_Product_brand_Brand | null, shippingOptions: Array<ProductBySlugQuery_productBySlug_Product_shippingOptions_ShippingOption>, showroom?: PublicProductFragmentFragment_Product_showroom_Showroom | null, newPrice?: PublicProductFragmentFragment_Product_newPrice_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductFragmentFragment_Product_original_price_Price | null, android_arobject?: PublicProductFragmentFragment_Product_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_ios_arobject_ARObject | null, product_type?: PublicProductFragmentFragment_Product_product_type_ProductType | null, images: Array<PublicProductFragmentFragment_Product_images_Image>, address?: PublicProductFragmentFragment_Product_address_Address | null, coming_soon_alert?: PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert | null, custom_shipping_cost?: PublicProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod | null, externalShippingMethods: Array<PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod>, merchant: PublicProductFragmentFragment_Product_merchant_Merchant, favorite?: PublicProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PublicProductFragmentFragment_Product_categories_Category>, shipping_cost: PublicProductFragmentFragment_Product_shipping_cost_Price, shipping_method_prices: Array<PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice>, attributes: Array<PublicProductFragmentFragment_Product_attributes> };

export type ProductBySlugQuery_Query = { __typename?: 'Query', productBySlug?: ProductBySlugQuery_productBySlug_Product | null };


export type ProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type ProductBySlugQuery = ProductBySlugQuery_Query;

export type GetProductCountByStatusQuery_productCountByStatus_ProductCountByStatus = { __typename?: 'ProductCountByStatus', status: ProductStatus, count: number };

export type GetProductCountByStatusQuery_Query = { __typename?: 'Query', productCountByStatus: Array<GetProductCountByStatusQuery_productCountByStatus_ProductCountByStatus> };


export type GetProductCountByStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCountByStatusQuery = GetProductCountByStatusQuery_Query;

export type ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult = { __typename?: 'ProductPlatformFeeResult', campaign_code?: string | null, fee: ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult_fee_Fee };

export type ProductPlatformFeeQuery_Query = { __typename?: 'Query', getProductPlatformFee: ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult };


export type ProductPlatformFeeQueryVariables = Exact<{
  input?: InputMaybe<ProductPlatformFeeInput>;
}>;


export type ProductPlatformFeeQuery = ProductPlatformFeeQuery_Query;

export type PromotionsQuery_promotions_Promotion_discount_CouponCodeDiscount = { __typename?: 'CouponCodeDiscount', type: DiscountType, value: number };

export type PromotionsQuery_promotions_Promotion = { __typename?: 'Promotion', code: string, valid_upto?: any | null, discount: PromotionsQuery_promotions_Promotion_discount_CouponCodeDiscount };

export type PromotionsQuery_Query = { __typename?: 'Query', promotions: Array<PromotionsQuery_promotions_Promotion> };


export type PromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromotionsQuery = PromotionsQuery_Query;

export type QuerySuggestionsQuery_Query = { __typename?: 'Query', querySuggestions: Array<string> };


export type QuerySuggestionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuerySuggestionsQuery = QuerySuggestionsQuery_Query;

export type ReferralTypesQuery_referralTypes_ReferralType = { __typename?: 'ReferralType', id: any, name: string };

export type ReferralTypesQuery_Query = { __typename?: 'Query', referralTypes: Array<ReferralTypesQuery_referralTypes_ReferralType> };


export type ReferralTypesQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type ReferralTypesQuery = ReferralTypesQuery_Query;

export type RelatedProductsQuery_relatedProducts_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, quality: ProductQuality, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type RelatedProductsQuery_Query = { __typename?: 'Query', relatedProducts: Array<RelatedProductsQuery_relatedProducts_Product> };


export type RelatedProductsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type RelatedProductsQuery = RelatedProductsQuery_Query;

export type SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch_filters_FilterOutput = { __typename?: 'FilterOutput', key?: SearchFilterKey | null, value?: string | null };

export type SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch = { __typename?: 'SavedSearch', id: any, query?: string | null, filters?: Array<SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch_filters_FilterOutput | null> | null };

export type SavedSearchByIdentifierQuery_Query = { __typename?: 'Query', savedSearchByIdentifier?: SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch | null };


export type SavedSearchByIdentifierQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type SavedSearchByIdentifierQuery = SavedSearchByIdentifierQuery_Query;

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Brand = { __typename?: 'Brand', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Category = { __typename?: 'Category', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Color = { __typename?: 'Color', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Designer = { __typename?: 'Designer' };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Empty = { __typename?: 'Empty' };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Material = { __typename?: 'Material', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Style = { __typename?: 'Style', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models = SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Brand | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Category | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Color | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Designer | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Empty | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Material | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Style;

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput = { __typename?: 'FilterOutput', key?: SearchFilterKey | null, value?: string | null, models?: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models> | null };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch = { __typename?: 'SavedSearch', id: any, title?: string | null, query?: string | null, enabled?: boolean | null, filters?: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput | null> | null };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type SavedSearchesQuery_savedSearches_SavedSearchResult = { __typename?: 'SavedSearchResult', items: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch>, pagination: SavedSearchesQuery_savedSearches_SavedSearchResult_pagination_PaginationResult };

export type SavedSearchesQuery_Query = { __typename?: 'Query', savedSearches: SavedSearchesQuery_savedSearches_SavedSearchResult };


export type SavedSearchesQueryVariables = Exact<{
  sort?: InputMaybe<SavedSearchSort>;
  sortOrder?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type SavedSearchesQuery = SavedSearchesQuery_Query;

export type SearchProductsQuery_searchProducts_SearchProductsResult_items_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', active: boolean, shippingProvider?: ShippingProviderEnum | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, quality: ProductQuality, view_count: number, favorite_count: number, shippingOptions: Array<SearchProductsQuery_searchProducts_SearchProductsResult_items_Product_shippingOptions_ShippingOption>, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Artist = { __typename?: 'Artist' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Brand = { __typename?: 'Brand' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Color = { __typename?: 'Color', hex?: string | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Designer = { __typename?: 'Designer' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Label = { __typename?: 'Label' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Material = { __typename?: 'Material' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Style = { __typename?: 'Style' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Subject = { __typename?: 'Subject' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_UsageSign = { __typename?: 'UsageSign' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute = SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_AdditionalInfo | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Artist | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Brand | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Color | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Designer | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Label | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Material | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Style | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Subject | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_UsageSign;

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_category_Category = { __typename?: 'Category', route?: string | null, level?: number | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue = { __typename?: 'SearchFacetValue', value?: string | null, count?: number | null, attribute?: SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute | null, category?: SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_category_Category | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet = { __typename?: 'SearchFacet', key?: SearchFacetKey | null, values?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue | null> | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facetsStats_SearchFacetStats = { __typename?: 'SearchFacetStats', key?: SearchFacetsStatKey | null, min?: number | null, max?: number | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, limit: number, pages: number, count: number };

export type SearchProductsQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', queryID?: string | null, indexName?: string | null, items?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_items_Product | null> | null, facets?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet | null> | null, facetsStats?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facetsStats_SearchFacetStats | null> | null, pagination?: SearchProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult | null };

export type SearchProductsQuery_Query = { __typename?: 'Query', searchProducts?: SearchProductsQuery_searchProducts_SearchProductsResult | null };


export type SearchProductsQueryVariables = Exact<{
  input?: InputMaybe<SearchProductsInput>;
  lang?: InputMaybe<Language>;
}>;


export type SearchProductsQuery = SearchProductsQuery_Query;

export type SearchSubpagesQuery_searchSubpages_SearchSubpagesResponse_items_SearchSubpage = { __typename?: 'SearchSubpage', url: string, title: string };

export type SearchSubpagesQuery_searchSubpages_SearchSubpagesResponse = { __typename?: 'SearchSubpagesResponse', items: Array<SearchSubpagesQuery_searchSubpages_SearchSubpagesResponse_items_SearchSubpage> };

export type SearchSubpagesQuery_Query = { __typename?: 'Query', searchSubpages: SearchSubpagesQuery_searchSubpages_SearchSubpagesResponse };


export type SearchSubpagesQueryVariables = Exact<{
  url: Scalars['String']['input'];
  lang: Language;
}>;


export type SearchSubpagesQuery = SearchSubpagesQuery_Query;

export type ShippingMethodsQuery_shippingMethods_ShippingMethod_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type ShippingMethodsQuery_shippingMethods_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, description?: string | null, price: ShippingMethodsQuery_shippingMethods_ShippingMethod_price_Price };

export type ShippingMethodsQuery_Query = { __typename?: 'Query', shippingMethods: Array<ShippingMethodsQuery_shippingMethods_ShippingMethod> };


export type ShippingMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingMethodsQuery = ShippingMethodsQuery_Query;

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_bank_account_ExternalBankAccount = { __typename?: 'ExternalBankAccount', id: string, currency: Currency, country: string, account_holder_name?: string | null, bank_name: string, last4: string };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails = { __typename?: 'StripeAccountDetails', account_created: boolean, payouts_enabled: boolean, bank_account?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_bank_account_ExternalBankAccount | null };

export type StripeAccountDetailsQuery_Query = { __typename?: 'Query', stripeAccountDetails?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails | null };


export type StripeAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeAccountDetailsQuery = StripeAccountDetailsQuery_Query;

export type UpdateAddressMutation_updateAddress_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type UpdateAddressMutation_Mutation = { __typename?: 'Mutation', updateAddress: UpdateAddressMutation_updateAddress_Address };


export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  merchant_id: Scalars['UUID']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
}>;


export type UpdateAddressMutation = UpdateAddressMutation_Mutation;

export type MessageCreatedSubscription_messageCreated_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, flaggedReasons?: Array<string> | null, originalBody?: string | null, sender: MessageFragment_Message_sender_Member, item?: MessageFragment_Message_item | null };

export type MessageCreatedSubscription_Subscription = { __typename?: 'Subscription', messageCreated: MessageCreatedSubscription_messageCreated_Message };


export type MessageCreatedSubscriptionVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type MessageCreatedSubscription = MessageCreatedSubscription_Subscription;

export type MessageUpdatedSubscription_messageUpdated_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, flaggedReasons?: Array<string> | null, originalBody?: string | null, sender: MessageFragment_Message_sender_Member, item?: MessageFragment_Message_item | null };

export type MessageUpdatedSubscription_Subscription = { __typename?: 'Subscription', messageUpdated: MessageUpdatedSubscription_messageUpdated_Message };


export type MessageUpdatedSubscriptionVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type MessageUpdatedSubscription = MessageUpdatedSubscription_Subscription;
